import { DAILY_REWARD_STATUS } from '@Data/Models';
import { IGU_WALLET_TRANSACTIONS } from '@models/gamingWallet';
import {
    MARKETPLACE_ORDERS_SORT_OPTION,
    MARKETPLACE_PET_TYPE,
} from '@models/marketplace';
import {
    GAME_DIFFICULTY,
    LUCKY_STRIKE_GAMES_STATUS,
    MYSTERY_GAMES,
    MYSTERY_LIKES_STATUS,
    NFT_ROYAL_GAME_HISTORY_STATUS,
    NFT_ROYAL_GAME_MODE,
    TOKEN_TELLER_GAME_PREDICTION_DIRECTION,
    TOKEN_TELLER_GAME_STATUS,
    TOKEN_TELLER_HISTORY_GAMES_STATUS,
} from '@models/mysteryGames';
import ROUTES from '@navigation/routes';

const tr = {
    createWalletPassphrase: {
        title: 'Tohum İfadeniz',
        text: 'Lütfen bu 12 kelimeyi bir kağıda kaydedin. Not alırken sıralarına dikkat edin. Güvenli bir yerde saklayın.',
        button: 'Devam et',
        loading: 'Tohum öbeği oluşturma...',
    },
    createWalletVerification: {
        title: 'Doğrulama',
        text: 'Lütfen doğru kelimeleri numaralarına göre seçin (önceki ekranda yazıldıkları sıraya göre)',
        button: 'Devam et',
        errors: {
            passphraseNotCorrect:
                'Kelimelerin sırası yanlış. Sıralarına göre doğru kelimeleri seçin',
        },
        loading: 'Tohum ifadesini kontrol ediyorum.',
    },
    createWalletFirst: {
        title: 'Tohum İfadenizi Yazın',
        text: 'Cihazınız kaybolur veya çalınırsa, tohum ifadesini kullanarak fonlarınıza erişim sağlayabilirsiniz. Tohum cümlenizi kaybederseniz, fon kaybına neden olur.',
        button: 'Ben Hazırım, Devam Et',
    },
    importWalletInit: {
        title: 'Hesabınızı Bulduk',
        text: 'Başka bir cihazdan giriş yaptınız ve bağlı cüzdanınıza erişiminiz yok. Uygulamayı kullanmaya devam etmek için lütfen cüzdanınızın 12 kelimelik tohum cümlesini girin',
        pets: 'Evcil Hayvanlar',
        import: 'İthalat Cüzdanı',
        loading: 'Cüzdanı içe aktarma...',
    },
    importWalletScreen: {
        title: 'Cüzdan içe aktarma',
        text: 'Cüzdanınızı uygulama içinde kullanabilmek için 12 kelimelik tohum cümlenizi girin',
        listTitle: 'Tohum ifadesi',
        inputPlaceholder: 'Buraya yazın',
        clearAll: 'Tümünü temizle',
        importWallet: 'İthalat',
        privateKeyButton: 'Özel Anahtardan İçe Aktar',
        privateKeyModal: {
            title: 'Özel Anahtardan İçe Aktar',
            text: 'Bir tohum ifadeniz yoksa, cüzdanınızı özel bir anahtar kullanarak içe aktarabilirsiniz',
            label: 'Özel Anahtar',
            placeholder: 'Özel anahtarı girin',
            button: 'İthalat',
        },
        errors: {
            mnemonicError:
                'Bu 12 kelimelik tohum ifadesine sahip cüzdan mevcut değildir. Lütfen tekrar kontrol edin veya başka bir cümle sağlayın',
            privateKeyError:
                'Bu özel anahtara sahip cüzdan mevcut değil. Lütfen tekrar kontrol edin veya başka bir özel anahtar sağlayın',
            walletNotEqual: 'Sağlanan cüzdan hesabın cüzdanıyla eşleşmiyor',
            walletAlreadyVerified:
                'Bu cüzdan başka bir hesaba ait, içe aktarılamıyor',
        },
        success: 'Cüzdan başarıyla içe aktarıldı',
    },
    createWalletInit: {
        createButton: 'Bir Cüzdan Oluşturun',
        importButton: 'Cüzdan İçe Aktarma',
        slider: {
            titleSlide1: 'Bir Cüzdan Bağlayın',
            textSlide1:
                'Yeni bir cüzdan oluşturun veya 12 kelimelik tohum cümlenizi sağlayarak mevcut bir cüzdanı içe aktarın',
            titleSlide2: 'Kendi Kendine Emanet Cüzdanlar',
            textSlide2:
                'IguVerse, özel anahtarlarınızın tek kontrolüne sahip olduğunuz, dolayısıyla kripto para biriminizi kontrol eden ve fonların size ait olduğunu kanıtlayan kendi kendine emanet bir cüzdan üzerinde çalışır',
            titleSlide3: 'Hesabı geri yükle',
            textSlide3:
                'Cihaza ve tohum cümlenize erişiminizi kaybederseniz, cüzdanınızı geri yükleyemeyiz ve paranız kaybolur.',
        },
    },
    createWalletSuccess: {
        title: 'Cüzdan Oluşturuldu',
        text: 'Tebrikler! Cüzdanınız başarıyla oluşturuldu, şimdi hesabınızı kullanmaya başlayabilirsiniz',
        button: 'Son Adıma Git',
        buttonNew: 'Devam et',
    },
    importWalletSuccess: {
        title: 'Cüzdan İthal',
        text: 'Tebrikler! Cüzdanınız başarıyla içe aktarıldı, hesabınızı kullanmaya başlayabilirsiniz',
        button: 'Devam et',
        buttonNew: 'Son Adıma Git',
    },
    login: {
        facebook: 'Facebook ile devam edin',
        google: 'Google ile devam edin',
        apple: 'Apple ile devam edin',
        email: 'E-posta ile devam edin',
        twitter: 'Twitter ile devam edin',
        emailTitle: 'Giriş Yap / Kaydol',
        creatingAccount:
            'Hesap oluşturarak kişisel verilerimin aşağıdakilere göre işlenmesini kabul ediyorum',
        and: 've',
        privacyPolicy: 'Gizlilik Politikası',
        termsOfUse: 'Kullanım Koşulları',
        placeholderEmail: 'E-posta girin',
        labelEmail: 'E-posta',
        placeholderVerificationCode: 'Doğrulama kodunu girin',
        labelVerificationCode: 'Doğrulama kodu e-postanıza gönderilecektir',
        sendCode: 'Gönder',
        resendIn: 'Yeniden gönder',
        seconds: 'sn',
        welcomeTo: 'Hoş geldiniz',
        codeSent: 'Tek Kullanımlık Şifre gönderildi!',
        errors: {
            invalidEmailAddress: 'Geçersiz e-posta adresi',
            emailIsRequired: 'E-posta alanı zorunludur',
            verificationCodeIsRequired:
                'Hesabınıza giriş yapmak için tek seferlik şifre gereklidir',
            verificationCodeIsBadOrExpired:
                'Tek seferlik şifre yanlış veya süresi dolmuş. Tekrar deneyin',
            verificationCodeTooMuchAttempts:
                'Çok fazla deneme. Lütfen daha sonra tekrar deneyin',
            loginFailed: 'Giriş başarısız',
            smthWentWrong:
                'Oturum açma sırasında bir şeyler ters gitti. Daha sonra tekrar deneyin veya farklı bir yöntem deneyin',
        },
        loading: {
            sendingCode: 'Kod gönderiliyor.',
            loggingIn: 'Giriş yapıyorum.',
        },
    },
    mintPetRank: {
        title: 'Evcil Hayvan Sıralamanızı Seçin',
        text: 'Rütbe, evcil hayvanınızın her gün tamamladığı görevler için ne kadar ödül kazanacağını belirler',
        free: 'Ücretsiz',
        roi: 'ROI ≈ ',
        dailyReward: 'Günlük Ödül ≈ ',
        buttonNext: 'Sonraki Adıma Devam Et',
        disabled: 'Hesap başına yalnızca bir Ücretsiz sıralamaya izin verilir',
        info: 'Rütbe nedir?',
        whiteList: 'Beyaz Liste ({{amount}})',
        mysteryBox: 'Gizemli Kutu',
        mysteryBoxWithAmount: 'Gizemli Kutu ({{amount}})',
    },
    mintPickPhoto: {
        title: 'Evcil Hayvan Fotoğrafınızı Seçin',
        text: 'Evcil hayvanınızın fotoğrafını çekin veya galeriden en sevdiğiniz resmi seçin',
        or: 'veya',
        takePhoto: 'Açık Kamera',
        selectFromGallery: "Galeri'den seçim yapın",
        tips: {
            title: 'Mükemmel Fotoğraf için Yönergeler',
            visible: 'Doğru',
            cut: 'Kesmek',
            blurry: 'Bulanık',
            glare: 'Parlama',
            tipOne: 'İyi ışık şarttır',
            tipTwo: 'Nötr arka planlı bir çekim yapmaya çalışın',
            tipThree:
                'Evcil hayvanın fotoğraftaki tek kişi olduğundan emin olun',
        },
        analyzingPhoto: 'Fotoğrafınızı analiz etmek...',
        errors: {
            explicitContent: {
                title: 'Yasak içerik',
                text: 'Resim yasaklı içerik içeriyor. Bu eylemler hesabın yasaklanmasına neden olabilir',
            },
            uploadError: {
                title: 'Yükleme başarısız',
                text: 'İnternet bağlantınızı kontrol edin ve yeniden deneyin',
            },
            processImageFailed: {
                title: 'Görüntü Hatası',
                text: 'Resminiz şu anda işlenemiyor. Tekrar deneyin veya farklı bir fotoğraf kullanın',
            },
            notAnimal: {
                title: 'Burada Hayvan Yok',
                text: 'Algoritmalarımız fotoğrafınızdaki hayvanı tanıyamıyor. Lütfen farklı bir fotoğrafla tekrar deneyin',
                try: 'Tekrar Deneyin',
                cancel: 'İptal',
            },
        },
    },
    mintEditPhoto: {
        title: 'Evcil Hayvanınızı Özelleştirin',
        text: 'NFT evcil hayvanınız için arka planı seçin',
        loading: 'Görüntünüzü hazırlayın...',
    },
    mintNamePhoto: {
        title: 'Evcil Hayvanınıza Bir İsim Verin',
        text: 'Evcil hayvanınız en iyi ismi hak ediyor. İsminizi 20 karakterden uzun tutmayın',
        inputLabel: 'İsim',
        placeHolder: 'örneğin Charlie',
        buttonNext: 'Sonraki Adıma Devam Et',
        infoText:
            'Algoritmalarımız resimlerdeki hayvanları %99 olasılıkla tanıyabiliyor',
        deleteNFTphoto: 'Fotoğraf Kaldır',
        deleteNFTphotoText:
            'Ayrılmak istediğinizden emin misiniz? İlerlemeniz kaybolacak',
        yesDelete: 'Evet, Beni Geri Götür',
        noKeep: 'Hayır, devam et',
        errors: {
            startSpace: 'Boşluk, adın ilk karakteri olamaz',
            specialCharacters: 'İsim özel karakterler içeremez',
            latinCharacters:
                "Ad yalnızca A'dan Z'ye kadar karakterler içerebilir",
            numbers: 'İsim sayı içeremez',
            doubleSpaces: 'İsim çift boşluk içeremez',
            maxLength: 'İsim 20 karakterden uzun olamaz',
            minLength: 'İsim 2 sembolden daha kısa olamaz',
            mint: {
                title: "Darphane NFT'si başarısız oldu",
                petRankWrongState:
                    'Evcil hayvan rütbesi darphane için mevcut değildir',
                obscenePetName:
                    'Evcil hayvan adı kötü kelimeler içeremez. Hesabınız yasaklanabilir',
            },
        },
    },
    mintCheckout: {
        transaction: 'NFT olarak',
        rank: 'Rütbe',
        nftCustomization: 'NFT',
        successTitle: 'Yeni NFT Evcil Hayvanı Yaratıldı',
        successText:
            'Yeni bir evcil hayvanın gururlu sahibi oldunuz. Ona iyi bakmayı unutmayın!',
        backToPlaying: 'Oynamaya Başla',
        backToCollection: 'Koleksiyonu Görüntüle',
    },
    wallet: {
        screenTitle: 'Cüzdan',
        loading: 'Cüzdan yükleniyor...',
        emptyTitle: 'Cüzdan yüklenemiyor',
        emptyText: 'Cüzdan yüklenirken hata oluştu',
        total: 'Toplam',
        deposit: 'Depozito',
        withdraw: 'Geri Çekilme',
        trade: 'Ticaret',
        balances: 'Terazi',
        exchanges: 'Değişimler',
        exchangesInfo:
            'Tokenlarımızı aşağıda listelenen borsalardan herhangi birinde takas edebilirsiniz',
        available: 'Mevcut:',
        view: 'Görünüm',
        depositTo: 'Para Yatırma',
        depositBEP: 'Mevduat {{coin}} (BEP-20)',
        testnet: 'Testnet',
        testnetWarning:
            'Uygulama şu anda Testnet ağında çalışmaktadır, buraya gerçek token yatırmayın',
        howToPurchaseBNB: 'BNB Nasıl Satın Alınır',
        howToPurchaseIGU: 'IGU Nasıl Satın Alınır',
        warning:
            'Jetonlarınızı doğru adrese ve ağa yatırdığınızdan emin olun (BEP-20)',
        withdrawFrom: 'Çekilme',
        transactionHistory: 'İşlem geçmişi',
        viewOnBscScan: "BscScan'de görüntüle",
        noTransactionYet: 'Henüz İşlem Yapılmadı',
        noTransactionYetInfo: 'Henüz herhangi bir işlem yapmadınız',
        transactionDetails: 'İşlem Detayları',
        amount: 'Miktar',
        type: 'Tip',
        date: 'Tarih',
        fromAddress: 'Adresinden',
        toAddress: 'Adrese',
        blockChainFee: 'Blockchain ücreti',
        loadingWithdraw: 'İşlem gönderiliyor.',
        transactions: {
            coin: {
                DEPOSIT: {
                    name: 'Depozito',
                    text: 'Kripto cüzdanınıza ulaştı. Daha fazla ayrıntı için işlem geçmişini görüntüleyin',
                },
                WITHDRAW: {
                    name: 'Para Çekme',
                    text: 'Kripto cüzdanınızdan transfer edildi. İşlem makbuzunuz için lütfen alıcı platformla iletişime geçin',
                },
                SWAP: {
                    name: 'Takas',
                    text: 'Kripto, yerleşik DEX kullanılarak başka bir kripto ile değiştirildi.',
                },
                CLAIM: {
                    name: 'Talep Edilen Ödül',
                    text: 'Ödül talep edildi ve cüzdan bakiyenize aktarıldı',
                },
                NFT_PAYMENT: {
                    name: 'NFT Ödemesi',
                    text: 'Kripto, nane şekeri, iyileştirme veya yükseltme için uygulamada ödeme yapmak için kullanıldı. Daha fazla ayrıntı için işlem geçmişini görüntüleyin',
                },
                UNKNOWN: {
                    name: 'Diğer',
                    text: 'Onaylama, ücret vb. dahil olmak üzere diğer tüm ağ işlemleri. Daha fazla ayrıntı için işlem geçmişini görüntüleyin',
                },
                CONFIRMED: { title: 'Tamamlandı' },
                FAILED: {
                    title: 'Başarısız',
                    text: 'Ağ sorunları nedeniyle işleminizi gerçekleştiremedik',
                },
                PENDING: {
                    title: 'Beklemede',
                    text: 'İşlem henüz ağ tarafından onaylanmamıştır. Genellikle 5 dakika ile 1 saat arasında sürer',
                },
            },
            nft: {
                DEPOSIT: {
                    name: 'Depozito',
                    text: 'NFT cüzdanınıza ulaştı. Daha fazla ayrıntı için işlem geçmişini görüntüleyin',
                },
                WITHDRAW: {
                    name: 'NFT Para Çekme',
                    text: "NFT IguVerse'den transfer edildi. İşlem dekontunuz için lütfen alıcı platform ile iletişime geçiniz",
                },
                MINT: {
                    name: 'Nane',
                    text: 'NFT, IguVerse uygulamasında basıldı',
                },
                CONFIRMED: { title: 'Tamamlandı' },
                FAILED: {
                    title: 'Başarısız',
                    text: 'Ağdaki teknik çalışmalar nedeniyle işleminizi gerçekleştiremedik',
                },
                PENDING: {
                    title: 'Beklemede',
                    text: 'İşlem henüz ağ tarafından onaylanmamıştır. Genellikle 5 dakika ile 1 saat arasında sürer',
                },
            },
            reward: {
                GameIterationReward: {
                    title: 'Görevler Ödül',
                    text: 'Görevler günlük görevleri tamamlamak için kilitli ödül',
                },
                ReferralReward: {
                    title: 'Yönlendirme Ödülü',
                    text: 'Diğer kullanıcı uygulama etkinliği için yönlendirme ödülü',
                },
                Claim: {
                    title: 'Ödül Talep Edin',
                    text: 'Talep işlemi, mevcut sanal VIGUP ödüllerinizi IGUP Ana Cüzdanınıza dönüştürür',
                },
                PetLevelUpPayment: {
                    title: 'Evcil Hayvan Seviyesi Yükseltme',
                    text: 'Evcil hayvanın seviyesini yükseltmek için dahili ödeme',
                },
                PetRankUpPayment: {
                    title: 'Evcil Hayvan Rütbesi Yükseltme',
                    text: 'Evcil hayvan sıralaması için dahili ödeme',
                },
                PetRevivePayment: {
                    title: 'Pet Restore',
                    text: 'Evcil hayvanın restorasyonu için dahili ödeme',
                },
                PetHealUpPayment: {
                    title: 'Evcil Hayvan İyileştirme',
                    text: 'Evcil hayvanı iyileştirmek için dahili ödeme',
                },
                MintBonus: {
                    title: 'Nane Bonusu',
                    text: 'NFT Mint için Bonus Ödül',
                },
                CharityDonation: {
                    title: 'Hayırseverlik Bağışı',
                    text: 'Seçtiğiniz Hayır Kurumuna Bağış',
                },
                GameIterationRewardSubtransaction: {
                    title: 'Görevler Ödül',
                    text: 'Görevler günlük görevleri tamamlamak için kilitli ödül',
                },
                CONFIRMED: { title: 'Tamamlandı' },
                PENDING: {
                    title: 'Beklemede',
                    text: 'Talep işlemi yapıldı, ancak tamamlanmadı. Yeni bir talepte bulunabilmeniz için önce bu işlemi tamamlamanız gerekir',
                },
                UNLOCK: {
                    title: 'Kilitli Ödüller',
                    text: 'Bu ödüller beklemededir ve kilit açma takvimine göre açılacak ve Talep için kullanılabilir olacaktır.',
                    locked: '{{amount}} {{coin}} Kilitli',
                },
                unlockTransactions: { title: 'Kilitlenmemiş İşlemler' },
                UNKNOWN: { name: 'Diğer', text: 'Diğer işlem türleri' },
                GameRewardStakeBonus: {
                    title: 'Artırma Bonusu',
                    text: 'Artırma için kilitli bonuslar',
                },
                GameRewardStakeBonusSubtransaction: {
                    title: 'Artırma Bonusu',
                    text: 'Artırma için kilitli bonuslar',
                },
            },
        },
        nft: {
            nft: 'NFT',
            tokenId: 'Belirteç Kimliği',
            myCollection: 'Koleksiyon Ürünleri',
            tooltip: 'NFT koleksiyonlarınızı buradan görüntüleyebilirsiniz',
            noNFTYet: 'Koleksiyon Yok',
            noNFTYetInfo: 'Boş liste',
            mintNewNft: 'Mint Yeni NFT',
            NFTs: "{{balance}} NFT'ler",
            noNFTs: 'N/A',
            deposit: 'Mevduat NFT',
            viewAll: 'Tümünü Görüntüle',
            allNFTs: "Tüm NFT'ler",
            withdraw: "NFT'yi geri çekin",
            withdrawNftLabelAddress: 'Adres',
            withdrawNftPlaceholderAddress: 'Adres girin',
            withdrawNftTitle: "NFT'yi geri çekin",
            blockchainFee: 'Blockchain ücreti',
            confirmButtonLabel: 'Para Çekmeyi Onayla',
            confirmModal: {
                title: 'NFT Para Çekmeyi Onayla',
                nftName: 'NFT',
                addressFrom: 'Kimden (Cüzdan)',
                addressTo: 'Adrese',
                send: 'Onaylayın',
                cancel: 'İptal',
            },
            withdrawSuccess: {
                title: 'NFT Para Çekme İşlemi Devam Ediyor',
                text: 'NFT {{name}} başarıyla geri çekildi. Genellikle 5 dakika ile 1 saat arasında sürer',
                addressFrom: 'Kimden (Cüzdan)',
                addressTo: 'Adrese',
                backToWallet: 'Cüzdana Geri Dön',
            },
            transactionNft: 'NFT Para Çekme',
            withdrawWarningText:
                "Tokenlarınızı doğru adrese ve ağa (BEP-20) çektiğinizden emin olun. NFT'nizi başka bir ağa veya borsa cüzdanına gönderirseniz, kalıcı olarak kaybedebilirsiniz",
            transactionHistory: 'İşlem Geçmişi',
            noTransactionYet: 'Henüz İşlem Yapılmadı',
            noTransactionYetInfo:
                'Henüz herhangi bir işlem yapmadınız. Ama sorun değil, hemen şimdi yapın',
        },
        rewards: {
            tooltipText:
                'Talep Et düğmesi, sanal ödül jetonlarınızı zincir üzerindeki IGUP jetonlarına dönüştürmenize olanak tanır. Düğme, bekleyen ödülleriniz olduğunda kullanılabilir olacaktır. ',
            claimButton: 'İddia',
            reclaimButton: 'Geri Kazanım',
            stakeButton: 'Artır',
            rewardsWallet: 'Ödül Cüzdanı',
            mainWallet: 'Ana Cüzdan',
            transactionHistoryText: 'İşlem Geçmişi',
            rewardsCarousel: {
                availableRewards: 'Mevcut Ödüller',
                availableRewards_text:
                    'IGUP jetonlarına dönüştürülebilecek ödüller',
                lockedRewards: 'Kilitli Ödüller',
                lockedRewards_text:
                    'Kilit açma programınıza göre ödüller mevcut olacaktır',
                pendingRewards: 'Bekleyen Talep Ödülleri',
                pendingRewards_text: 'Talep işleminizi tamamlayın',
                claimReward: 'Ödül Talep Edin',
            },
            transactionHistory: {
                Claim: 'Talep edilen ödül',
                GameIterationReward: 'Görevler ödül',
                ReferralReward: 'Yönlendirme ödülü',
                PetLevelUpPayment: 'Evcil Hayvan Seviyesi Yükseltme',
                PetRankUpPayment: 'Evcil Hayvan Rütbesi Yükseltme',
                PetRevivePayment: 'Pet Restore',
                PetHealUpPayment: 'Evcil Hayvan İyileştirme',
                MintBonus: 'Nane Bonusu',
                CharityDonation: 'Hayırseverlik Bağışı',
                GameIterationRewardSubtransaction: 'Kilit açma',
                GameRewardStakeBonus: 'Artırma Bonusu',
                GameRewardStakeBonusSubtransaction: 'Kilit açma',
            },
            filter: {
                title: 'Sıralama Ölçütü',
                ALL: 'Tümü',
                Claim: 'Talep Edilen Ödül',
                GameIterationReward: 'Görevler Ödül',
                ReferralReward: 'Yönlendirme Ödülü',
                MintBonus: 'Nane Bonusu',
                GameRewardStakeBonus: 'Artırma Bonusu',
            },
            empty: {
                title: 'Henüz İşlem Yapılmadı',
                text: 'Endişelenmeyin ve bizi izlemeye devam edin. Ödülleri aldığınızda burada görüntülenecektir',
                button: 'Yenile',
            },
            confirmationModal: {
                title: 'Talebi Onayla',
                keys: {
                    from: 'Kimden',
                    to: 'Kime (Cüzdan)',
                    fee: 'Blockchain Ücreti',
                    total: 'Toplam Özet',
                },
                values: {
                    rewardsWallet: 'Ödül Cüzdanı',
                    mainWallet: 'IGUP Cüzdan',
                },
                warning:
                    "Benzin ücretini karşılamak için yeterli paranız ve BNB'niz olduğundan emin olun",
            },
            claimSuccess: {
                title: 'Ödül Talebi İşleme Alınıyor',
                text: 'Ödül Cüzdanınızdan yeni bir talep işlemi başlattınız. Genellikle 5 dakika ile 1 saat arasında sürer',
                backToWallet: 'Cüzdana Geri Dön',
            },
            claimLoading: 'Talep gerçekleştiriliyor, uygulamayı kapatmayın...',
            claimBusy:
                'Ağ şu anda meşgul, lütfen bir süre sonra tekrar deneyin',
        },
        gaming: {
            gamingWalletChangeFeatureText:
                "Bu, IGU'dan VIGU'a yaklaşık bir değişim oranıdır",
            gamingWalletCarousel: {
                AvailableWallet: {
                    title: 'Mevcut Cüzdan',
                    text: 'Katılmak için oyun cüzdanınızı IGU ile doldurun',
                },
                PendingWallet: {
                    title: 'Bekleyen Cüzdan',
                    text: 'Jetonlar siz oyunu bitirene kadar dondurulacaktır',
                },
            },
            gamingWalletButtons: {
                topUp: 'Tamamla',
                withdraw: 'Geri Çekilme',
            },
            TopUpGamingWalletScreen: {
                screenTitle: 'Tamamla',
                title: 'Oyun Cüzdanına Para Yükleyin',
                text: 'Katılmak için oyun cüzdanınıza IGU yükleyin ve VIGU kazanın',
                infoText: 'Nasıl Çalışır',
                button: 'Ödeme',
                inputSection: {
                    infoText:
                        'Satın almak istediğiniz miktarı girin veya seçin',
                    errors: {
                        digits: 'Yalnızca rakamlar olmalıdır',
                        min: 'Tutar en az şu kadar olmalıdır {{limit}} {{coin}}',
                        max: 'Miktar maksimumda olmalıdır {{limit}} {{coin}}',
                    },
                },
                howToModal: {
                    title: 'Oyun Cüzdanına Para Yükleyin',
                    text: 'Katılmak için oyun cüzdanınıza IGU yükleyin ve VIGU kazanın. Jeton yüklemek için aşağıdaki düğmeyi kullanın',
                },
            },
            SelectWithdrawTokenModal: {
                title: 'Para Çekme Jetonunu Seçin',
                text: "Ana Cüzdan'da ödüllerinizi alacağınız tercih edilen jetonu seçebilirsiniz",
                button: 'Seçiniz',
            },
            TopUpSuccessScreen: {
                title: 'Başarılı yükleme',
                text: 'Oyun cüzdanınıza başarılı bir şekilde jeton yüklediniz. Rekabetçi oyunlara şimdi katılın!',
                button: 'Oyunları Keşfedin',
                button2: 'İşlem Geçmişini Görüntüle',
                buttonBack: 'Oyuna Geri Dön',
            },
            transactionHistory: {
                filter: {
                    title: 'Göre sırala',
                    [IGU_WALLET_TRANSACTIONS.All]: 'Tümü',
                    [IGU_WALLET_TRANSACTIONS.Deposit]: 'Tamamla',
                    [IGU_WALLET_TRANSACTIONS.Withdraw]: 'Geri Çekilme',
                    [IGU_WALLET_TRANSACTIONS.RevertWithdraw]: 'Revert Withdraw',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGamePayment]: 'Ödeme',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameRefund]:
                        'Sona Erdi',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameDraw]:
                        'Beraberlik',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameWin]: 'Galibiyet',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameFee]: 'Ücret',
                    [IGU_WALLET_TRANSACTIONS.DepositBonus]: 'Yükleme Bonus',
                },
                transactions: {
                    [IGU_WALLET_TRANSACTIONS.Deposit]: {
                        title: 'Tamamla',
                        text: 'Kriptolar Oyun Cüzdanına aktarılıyor. Bscscan hakkında daha fazla ayrıntı kontrol edin',
                    },
                    [IGU_WALLET_TRANSACTIONS.Withdraw]: {
                        title: 'Geri Çekilme',
                        text: 'Kripto, Oyun Cüzdanından aktarılıyor. Bscscan hakkında daha fazla ayrıntı kontrol edin',
                    },
                    [IGU_WALLET_TRANSACTIONS.RevertWithdraw]: {
                        title: 'Sona Erdi',
                        text: 'Kripto, Oyun Cüzdanından aktarılıyor. Bscscan hakkında daha fazla ayrıntı kontrol edin',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameDraw]: {
                        title: 'The Mystery Of Likes Beraberlik',
                        text: 'Kriptolar Oyun Cüzdanına aktarılıyor. Bscscan hakkında daha fazla ayrıntı kontrol edin',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGamePayment]: {
                        title: 'The Mystery Of Likes Ödeme',
                        text: 'Kripto, Oyun Cüzdanından aktarılıyor. Bscscan hakkında daha fazla ayrıntı kontrol edin',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameRefund]: {
                        title: 'The Mystery Of Likes Expired',
                        text: 'Kriptolar Oyun Cüzdanına aktarılıyor. Bscscan hakkında daha fazla ayrıntı kontrol edin',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameWin]: {
                        title: 'The Mystery Of Likes Galibiyet',
                        text: 'Kriptolar Oyun Cüzdanına aktarılıyor. Bscscan hakkında daha fazla ayrıntı kontrol edin',
                    },
                    [IGU_WALLET_TRANSACTIONS.DepositBonus]: {
                        title: 'Yükleme Bonus',
                        text: 'Kripto, Oyun Cüzdanından aktarılıyor. Bscscan hakkında daha fazla ayrıntı kontrol edin',
                    },
                    [IGU_WALLET_TRANSACTIONS.DirectReferralDepositBonus]: {
                        title: 'Yükleme Bonus (Doğrudan)',
                        text: 'Kripto, Oyun Cüzdanından aktarılıyor. Bscscan hakkında daha fazla ayrıntı kontrol edin',
                    },
                    [IGU_WALLET_TRANSACTIONS.IndirectReferralDepositBonus]: {
                        title: 'Yükleme Bonus (Dolaylı)',
                        text: 'Kripto, Oyun Cüzdanından aktarılıyor. Bscscan hakkında daha fazla ayrıntı kontrol edin',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameFee]: {
                        title: 'Beğeni Ücretinin Gizemi',
                        text: 'Kripto, Oyun Cüzdanından aktarılıyor. Bscscan hakkında daha fazla ayrıntı kontrol edin',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameDirectReferralBonus]:
                        {
                            title: 'Yönlendirme Ödülü (Doğrudan)',
                            text: 'Kripto, Oyun Cüzdanından aktarılıyor. Bscscan hakkında daha fazla ayrıntı kontrol edin',
                        },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameIndirectReferralBonus]:
                        {
                            title: 'Yönlendirme Ödülü (Dolaylı)',
                            text: 'Kripto, Oyun Cüzdanından aktarılıyor. Bscscan hakkında daha fazla ayrıntı kontrol edin',
                        },
                    [IGU_WALLET_TRANSACTIONS.Breeding]: {
                        title: 'NFT Evolution Mint',
                        text: 'Kripto, Oyun Cüzdanından aktarılıyor. Bscscan hakkında daha fazla ayrıntı kontrol edin',
                    },
                    [IGU_WALLET_TRANSACTIONS.GamesTurnoverReward]: {
                        title: 'PVP Bonuslar',
                        text: 'Kriptolar Oyun Cüzdanına aktarılıyor. Bscscan hakkında daha fazla ayrıntı kontrol edin',
                    },

                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGameDraw]: {
                        title: 'The Grand Race - Beraberlik',
                        text: 'Kriptolar Oyun Cüzdanına aktarılıyor. Bscscan hakkında daha fazla ayrıntı kontrol edin',
                    },
                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGamePayment]: {
                        title: 'The Grand Race - Ödeme',
                        text: 'Kripto, Oyun Cüzdanından aktarılıyor. Bscscan hakkında daha fazla ayrıntı kontrol edin',
                    },
                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGameRefund]: {
                        title: 'The Grand Race - Süresi doldu',
                        text: 'Kriptolar Oyun Cüzdanına aktarılıyor. Bscscan hakkında daha fazla ayrıntı kontrol edin',
                    },
                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGameWin]: {
                        title: 'The Grand Race - Galibiyet',
                        text: 'Kriptolar Oyun Cüzdanına aktarılıyor. Bscscan hakkında daha fazla ayrıntı kontrol edin',
                    },
                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGameFee]: {
                        title: 'The Grand Race - Gizemi',
                        text: 'Kripto, Oyun Cüzdanından aktarılıyor. Bscscan hakkında daha fazla ayrıntı kontrol edin',
                    },
                    [IGU_WALLET_TRANSACTIONS.LuckyStrikeGameWin]: {
                        title: 'Lucky Strike - Galibiyet',
                        text: 'Kriptolar Oyun Cüzdanına aktarılıyor. Bscscan hakkında daha fazla ayrıntı kontrol edin',
                    },
                    [IGU_WALLET_TRANSACTIONS.LuckyStrikeGamePayment]: {
                        title: 'Lucky Strike - Bilet',
                        text: 'Kripto, Oyun Cüzdanından aktarılıyor. Bscscan hakkında daha fazla ayrıntı kontrol edin',
                    },
                    [IGU_WALLET_TRANSACTIONS.QuantumSpinReward]: {
                        title: 'Quantum Disk - Ödül',
                        text: 'Kriptolar Oyun Cüzdanına aktarılıyor. Bscscan hakkında daha fazla ayrıntı kontrol edin',
                    },
                    [IGU_WALLET_TRANSACTIONS.QuantumSpin]: {
                        title: 'Quantum Disk - Ödeme',
                        text: 'Kripto, Oyun Cüzdanından aktarılıyor. Bscscan hakkında daha fazla ayrıntı kontrol edin',
                    },
                    [IGU_WALLET_TRANSACTIONS.TokentellerGamePredictWin]: {
                        title: 'Tokenteller - Ödül',
                        text: 'Kriptolar Oyun Cüzdanına aktarılıyor. Bscscan hakkında daha fazla ayrıntı kontrol edin',
                    },
                    [IGU_WALLET_TRANSACTIONS.TokentellerGamePredict]: {
                        title: 'Tokenteller - Ödeme',
                        text: 'Kripto, Oyun Cüzdanından aktarılıyor. Bscscan hakkında daha fazla ayrıntı kontrol edin',
                    },
                    [IGU_WALLET_TRANSACTIONS.TokentellerGamePredictFee]: {
                        title: 'Tokenteller - Gizemi',
                        text: 'Kripto, Oyun Cüzdanından aktarılıyor. Bscscan hakkında daha fazla ayrıntı kontrol edin',
                    },
                    [IGU_WALLET_TRANSACTIONS.TokentellerGamePredictRefund]: {
                        title: 'Tokenteller - Beraberlik',
                        text: 'Kriptolar Oyun Cüzdanına aktarılıyor. Bscscan hakkında daha fazla ayrıntı kontrol edin',
                    },
                },
            },
        },
        stakingBanner: {
            title: 'Ödüllerinizi artırın ve bonuslar kazanın!',
            text: 'IGUP ile artırma özelliği Ödüller sekmesinde şimdi mevcut!',
            button: 'Artırmayı Etkinleştir',
        },
    },
    trade: {
        poweredBy: 'Tarafından desteklenmektedir',
        from: 'Kimden',
        to: 'Için',
        estimate: ' (Tahmin)',
        enterAmount: 'Tutar girin',
        available: 'Maksimum',
        selectToken: 'Belirteç Seçin',
        deposit: 'Depozito',
        trade: 'Takas',
        rate: 'Döviz Kuru',
        confirmTrade: 'Ticareti Onaylayın',
        cancel: 'İptal',
        settings: 'Ayarlar',
        settingTitle: 'Kayma Toleransı',
        slippageMainText:
            'Fiyat aşağıdaki yüzdeden daha fazla olumsuz yönde değişirse işleminiz geri dönecektir',
        save: 'Kaydet',
        percentFour: 'Gir %',
        inputWarning:
            'Kayma Toleransı {{minAmount}} ile {{maxAmount}} arasında olmalıdır. Lütfen başka bir yüzde girin',
        checkout: { estimate: 'Sen ödersin', to: 'Şunları alırsınız' },
        processingTrade: 'İşlem ticareti..',
        calculatingTrade: 'Hesaplanıyor..',
        button: 'Ticaret',
        errors: {
            isRequired: 'Değer gereklidir.',
            maxAmountError:
                'Bakiyede yeterli jeton yok. Lütfen başka bir miktar girin veya para yatırın',
            minLimit: 'Swap tutarı en az {{limit}} {{coin}} olmalıdır',
            bnbNotEnough:
                'Bakiyenizde gaz ücretini karşılamak için yeterli BNB yok. Lütfen başka bir miktar girin veya BNB yatırın',
            transaction: 'İşlem başarısız oldu',
            DS_MATH_SUB_UNDERFLOW:
                'Jeton miktarı çok büyük, farklı bir miktar girmeyi deneyin',
        },
        tradeSuccess: {
            title: 'Takas Tamamlandı',
            text: 'Tebrikler! Jetonları başarıyla takas ettiniz. Jetonlarınız bakiyenizde mevcuttur. İşlem geçmişinde daha fazlasını görüntüle',
            backToWallet: 'Cüzdana Geri Dön',
            from: 'Kimden',
            to: 'Için',
            estimate: '(Tahmin)',
            blockchainFee: 'Blockchain Ücreti',
            totalSummary: 'Toplam Özet',
            back: 'Ticarete Devam',
        },
    },
    tradingView: { title: 'Grafik', back: 'Ticarete Geri Dön' },
    walletSettings: {
        title: 'Cüzdan ayarları',
        header: 'Güvenlik ayarları',
        description:
            'Tohum ifadenizi ve özel anahtarınızı görüntüleyin ve şifrenizi buradan yönetin',
        backup: {
            title: 'Tohum Cümlesi',
            description:
                'Tohum cümlenizi asla kimseye göstermeyin! Tüm paranızı kontrol eder',
            modal: {
                title: 'Cüzdan Kurtarma İfadesi / Anahtarı',
                text: 'Gizli verilerinizi kimsenin görmediğinden emin olun. Herhangi birine ifşa ederek fonlarınızı kaybetme riskiyle karşı karşıya kalırsınız',
                yes: 'Görünüm',
                no: 'Geri',
                alert: 'IguVerse ekibi size asla tohum cümlenizi veya özel anahtarınızı sormayacaktır. Eğer birisi size sorarsa %100 dolandırıcıdır, dikkatli olun!',
                checkbox:
                    'Bir tohum cümlesini / özel anahtarı biriyle paylaşırsam jetonlarımın ve evcil hayvanlarımın çalınması riskini anladığımı kabul ediyorum',
            },
        },
        passcode: {
            title: 'Parola ve Biyometri',
            description:
                'Parolayı ayarlayın veya değiştirin ve biyometrik tanımlamayı değiştirin',
        },
    },
    passcode: {
        passcode: 'Parola',
        modal: {
            title: 'Parolayı Etkinleştir',
            subTitle:
                'Dört basamaklı kod, güvenliğinizi artıracak ve önemli eylemleri onaylamak için kullanılacaktır.',
        },
        welcome: {
            title: 'Parolayı Etkinleştir',
            subTitle:
                'Uygulamaya erişmek ve önemli işlemleri onaylamak için kullanacağınız şifreyi girin',
        },
        new: {
            title: 'Parolayı Etkinleştir',
            subTitle:
                'Uygulamaya erişmek ve önemli işlemleri onaylamak için kullanacağınız şifreyi girin',
        },
        confirm: {
            title: 'Parolayı Onaylayın',
            subTitle:
                'Uygulamaya erişmek ve önemli işlemleri onaylamak için kullanacağınız şifreyi girin',
            error: 'Yanlış kod. Önceki adımda yazdığınız kodun aynısını girin',
        },
        check: {
            title: 'Şifreyi gir',
            subTitle: 'Onaylamak için mevcut şifrenizi girin',
            error: 'Yanlış kod. Tekrar deneyin veya biyometrik kimlik kullanın',
        },
        success: {
            title: 'Hesabınız Koruma Altında!',
            subTitle:
                "Artık IguVerse hesabınız ve cüzdanınız kötü niyetli faaliyetlerden korunmaktadır. Parolayı her zaman Ayarlar'dan değiştirebilirsiniz.",
        },
        change: {
            title: 'Parolayı Değiştir',
            subTitle:
                'Önemli eylemleri onaylamak için kullanılacak yeni parolayı girin',
        },
        faceId: {
            title: 'Biyometrik Tanımlamayı Etkinleştir',
            subTitle:
                'Daha basit ve daha hızlı doğrulama ile önemli eylemleri onaylayın. Bilgileriniz IguVerse tarafından toplanmaz',
        },
        settings: {
            turnOff: 'Parolayı Kapat',
            biometric: {
                title: 'Biyometrik Kimlik',
                subTitle:
                    "Uygulamadaki önemli işlemleri onaylamak için Face ID'yi veya parmak izinizi kullanın",
            },
        },
        modalRemove: {
            title: 'Parola Kapatılsın mı?',
            subTitle:
                'Tüm verileriniz parola ile güvenli bir şekilde saklanır. İstediğiniz zaman ayarlardan tekrar ayarlayabilirsiniz.',
        },
        toasts: {
            turnOff: 'Başarılı! Parola kapatıldı!',
            biometricOff: 'Başarılı! Biyometrik kapalı!',
            biometricOn: 'Başarılı! Biyometrik açık!',
            change: 'Başarılı! Parola değiştirildi!',
            biometricError: 'Hata! Tekrar Deneyin!',
        },
    },
    walletSettingsBackup: {
        mnemonic: {
            title: 'Tohum İfadeniz',
            text: 'Lütfen bu 12 kelimeyi bir kağıda kaydedin. Not alırken sıralarına dikkat edin. Güvenli bir yerde saklayın.',
            reveal: 'İfadeyi Göstermek için Basılı Tutun',
        },
        privateKey: {
            title: 'Özel Anahtarınız',
            text: 'Özel anahtar, bir kullanıcıya bir cüzdana bağlı tüm fonlar üzerinde kontrol sağlayan rastgele oluşturulmuş bir sayıdır. Gizli tutun',
            reveal: 'Özel Anahtarı Göstermek için Basılı Tutun',
        },
        privateKeyModal: {
            title: 'Özel Anahtar',
            text: 'Özel Anahtarınızı not edin. Güvenli bir yerde saklayın',
        },
        buttons: { hidden: 'Açığa Çıkarmak için Tutun', visible: 'Gizle' },
        viewPrivateKey: 'Özel Anahtarınızı görüntüleyin',
        emptyTitle: 'Hata',
        emptyText: 'Cüzdan yüklenemiyor',
    },
    withdrawScreen: {
        title: 'Geri Çekilme',
        labelAddress: 'Adres',
        labelAmount: 'Miktar',
        placeholderAddress: 'Adres girin',
        placeholderAmount: 'Tutar girin',
        labelAvailable: 'Mevcut',
        allButtonLabel: 'Maksimum',
        confirmButtonLabel: 'İşlemi onaylayın',
        depositButtonLabel: 'Depozito',
        depositBEP: 'Mevduat {{coin}} (BEP-20)',
        blockchainFee: 'Blockchain ücreti',
        totalSummary: 'Toplam özet',
        errors: {
            address: 'Adres boş olamaz',
            amountRequired: 'Miktar boş olamaz',
            invalidAddress: 'Geçersiz adres cüzdanı',
            sameWallet: 'Kendi cüzdanınıza çekemezsiniz',
            digits: 'Yalnızca rakamlar olmalıdır',
            maxAmountError:
                'Bakiyede yeterli jeton yok. Lütfen başka bir miktar girin veya para yatırın',
            minLimit: 'Para çekme işlemi en az {{limit}} {{coin}} olmalıdır',
            bnbNotEnough:
                'Bakiyenizde gaz ücretini karşılamak için yeterli BNB yok. Lütfen başka bir miktar girin veya BNB yatırın',
        },
        withdrawWarningText:
            'Jetonlarınızı doğru adrese ve ağa çektiğinizden emin olun (BEP-20)',
        withdrawWarningTextNFT:
            "NFT'nizi başka bir ağa veya borsa cüzdanına gönderirseniz, kalıcı olarak kaybedebilirsiniz",
        transaction: 'Para Çekme',
        withdrawSuccess: {
            title: 'Para Çekme İşlemi Devam Ediyor',
            text: 'Cüzdanınızdan yeni bir para çekme işlemi başlattınız. Genellikle 5 dakika ile 1 saat arasında sürer',
            backToWallet: 'Cüzdana Geri Dön',
            viewTransactionHistory: 'İşlem Geçmişini Görüntüle',
        },
    },
    ModalConfirmTransaction: {
        title: 'İşlemi onaylayın',
        confirm: 'Onaylayın',
        cancel: 'İptal',
    },
    ModalCoinSelect: { select: 'Belirteç Seçin' },
    ModalCropImage: { title: 'Görüntüyü Kırp', crop: 'Kırp ve Devam Et' },
    qrCodeScanner: {
        openSettings: 'Ayarlar',
        noAccessToCamera: 'Kameraya erişim yok',
        title: 'QR Kodunu çerçeve içine yerleştirin',
        wallet: {
            titleScanned: 'Adres tarandı',
            text: "Token'ın adresinin QR kodunu tarayın. Tüm ayrıntıların görünür olduğundan emin olun",
        },
        referral: {
            titleScanned: 'Yönlendirme kodu tarandı',
            text: 'Yönlendirme kodunun QR kodunu tarayın. Tüm ayrıntıların görünür olduğundan emin olun',
        },
        verify: {
            titleScanned: 'Taranan kodu doğrulayın',
            text: 'Doğrulama kodunun QR kodunu tarayın. Tüm ayrıntıların görünür olduğundan emin olun',
        },
    },
    nftSelectGeneration: {
        continue: 'Devam et',
        search: 'Arama',
        pageTitle: 'NFT Evcil Hayvanınızı Oluşturun',
        pageInfo: "NFT'nizin oluşturulma şeklini seçebilirsiniz",
        nftFromPhoto: 'Fotoğraftan NFT',
        nftFromPhotoText:
            'Kendi evcil hayvan fotoğrafınızdan güzel bir NFT oluşturun. Gelecekteki arkadaşınız için muhteşem arka planlarımızdan birini seçin',
        nftFromImagination: 'Hayal Gücünüzden NFT',
        nftFromImaginationText:
            'AI / ML algoritmalarımız sanal evcil hayvanınızı tam olarak hayal ettiğiniz gibi çizebilir. Evcil hayvanınızın özelliklerini tanımlayın ve sonucun tadını çıkarın',
        provideMoreInformation: 'Hayalinizdeki Evcil Hayvanı Tanımlayın',
        provideMoreInformationInfo:
            'Aşağıda önerilen seçeneklerden birini seçin, böylece oluşturulan NFT hayal ettiğiniz şeyle mükemmel bir şekilde eşleşecektir',
        selectAccessories: 'Aksesuar Seçiniz',
        maximumAccessories: 'Maksimum {{num}} aksesuar seçebilirsiniz',
        selectGeneratedNFT: 'Evcil Hayvanınızı Seçin',
        selectGeneratedNFTInfo:
            'İsteğinize göre birkaç benzersiz evcil hayvan yarattık. En çok beğendiğinizi seçin',
        continueNextStep: 'Sonraki Adıma Devam Et',
        generateNewNFT: 'Yeniden Dene',
        generateNFTButton: 'NFT oluşturun',
        loadingModalText: 'Yükleniyor...',
        randomize: 'Rastgele',
        clear: 'Temiz',
        select: 'Seçiniz',
        noResult: 'Sonuç Yok',
        noResultText:
            '"{{query}}" için sonuç bulunamadı. Aramak için başka bir anahtar kelime girin',
        form: {
            animal: {
                label: 'Hayvan',
                placeHolder: 'Hayvan seçin',
                modalTitle: 'Hayvan Seçiniz',
            },
            'drawing-type': {
                label: 'Çizim Türü',
                placeHolder: 'Çizim türünü seçin',
                modalTitle: 'Çizim Türünü Seçin',
            },
            cat: {
                label: 'Kedi Cinsi',
                placeHolder: 'Kedi ırkını seçin',
                modalTitle: 'Kedi Cinsi Seçiniz',
            },
            dog: {
                label: 'Köpek Cinsi',
                placeHolder: 'Köpek ırkını seçin',
                modalTitle: 'Köpek Cinsi Seçiniz',
            },
            'maturity-size': {
                label: 'Olgunluk / Boyut',
                placeHolder: 'Vade veya boyut seçin',
                modalTitle: 'Vade veya Boyut Seçin',
            },
            color: {
                label: 'Renk',
                placeHolder: 'Renk seçiniz',
                modalTitle: 'Renk Seçiniz',
            },
            emotion: {
                label: 'Duygu',
                placeHolder: 'Duygu seçin',
                modalTitle: 'Duygu Seçiniz',
            },
            accessories: {
                label: 'Aksesuarlar',
                placeHolder: 'Aksesuarları seçin',
                modalTitle: 'Aksesuar Seçiniz',
            },
            context: {
                label: 'Bağlam',
                placeHolder: 'Bağlamı seçin',
                modalTitle: 'Bağlam Seçin',
            },
            style: {
                label: 'Stil',
                placeHolder: 'Stil seçin',
                modalTitle: 'Stil Seçiniz',
            },
        },
        errors: {
            maintenance: {
                title: 'Yapay zeka modellerimiz aşırı yüklendi',
                text: 'Maalesef yapay zeka modellerimiz şu anda isteğinizi karşılayamadı. Lütfen tekrar deneyin',
            },
        },
    },
    bottomNavigation: {
        play: 'Oyun',
        charity: 'Hayırseverlik',
        statistics: 'İstatistikler',
        collection: 'Koleksiyon',
        marketplace: 'Mağaza',
    },
    playScreen: {
        timeToComplete: 'Oyun Turu Sona Eriyor',
        startPlaying: 'Oynamaya Başla',
        howToPlay: 'Nasıl Oynanır?',
        nftToPlay: 'Evcil Hayvanlarınız',
        edit: 'Düzenle',
        nftToPlayInfo:
            'Oyuna katılacak ve ödüller kazanacak evcil hayvanlarınızı seçin',
        nftToPlayHint:
            'Evcil hayvanlarınızın sırası önemlidir. İlk evcil hayvan, oyun paylaşımında Evcil Hayvan Kimliğinizde görünen evcil hayvan olacaktır. İlk evcil hayvan aynı zamanda görevleri yerine getirmek için en fazla deneyimi elde eder',
        noNFTyet: 'Burada Kimse Yaşamıyor',
        noNFTyetInfo:
            'Ne yazık ki, henüz bir hayvan arkadaşınız yok. İlk evcil hayvanınızı alın ve oynamaya başlayın',
        exploreShop: 'Mağazayı Keşfet',
        mintNew: 'İlk Evcil Hayvanınızı Alın',
        dailyTasks: 'Günlük Görevler',
        dailyTasksInfo:
            'Enerji kazanmak için günlük görevlerinizi tamamlayın ve ardından jetonlarla değiştirin',
        timeLeftToComplete: 'Oyun Turu Sona Eriyor',
        selectNFT: 'Daha fazla evcil hayvan ekleyin',
        playCards: {
            SHARE_title: 'Evcil Hayvanınızı Paylaşın ',
            SHARE_info:
                'Evcil hayvanlarınızın günlük ilgiye ihtiyacı vardır.\n' +
                'Sosyal medyada paylaşın',
            SHARE_button: 'Açık Sosyal Görev',
            addSocialAccount: 'Sosyal Hesap Ekle',
            socialAlert:
                'Sosyal görev doğrulaması 12 saate kadar sürebilir, daha sonra tamamlanması bir sonraki oyun yinelemesinde Enerji kredilendirilmesine neden olabilir',
            MOVE_title: 'Evcil Hayvanlarınızı Gezdirin',
            MOVE_info:
                'Evcil hayvanlarınızın her gün yürümeye ihtiyacı vardır.\n' +
                'Evcil hayvanlarınızla yürüyün',
            MOVE_button: 'Açık Yürüyüş Görevi',
            PLAY_title: 'Evcil Hayvanlarınızla Oynayın',
            PLAY_info:
                'Tepki tabanlı arcade mini oyununda evcil hayvanlarınızla oynayın',
            PLAY_button: 'Açık Oyun Görevi',
            VERIFY_title: 'Diğer Evcil Hayvanları Bulun',
            VERIFY_info:
                'Sosyal medyada diğer kullanıcıların evcil hayvanlarını bulun',
            VERIFY_button1: 'Görev Bulmaya Devam Et',
            VERIFY_button2: 'Diğer Evcil Hayvanları Bulun',
            completedEnergy:
                '{{energyRewarded}} / {{maxEnergyReward}} Toplanan Enerji',
            SHARE_failed_title: 'Gönderiniz Doğrulanmadı',
            SHARE_failed_text:
                'Gönderinizi doğrularken, diğer kullanıcılar Evcil Hayvan Kimliğinizi bulamadı veya göremedi. Gönderiye bir göz attık ve onu da doğrulayamadık. Ne yazık ki, bugün bu görevden herhangi bir enerji alamayacaksınız. Lütfen bir dahaki sefere daha dikkatli olmaya çalışın',
            SHARE_failed_button: 'Oyuna Geri Dön',
            knowledgeBase: 'Bilgi Tabanını Görüntüle',
            SHARE_failed_reasons: {
                notEnoughFollowers:
                    'Görünüşe göre hesabınız yeterince aktif değil. Lütfen başka bir hesap seçin veya bu hesabı geliştirmeye çalışın',
                petIdNotFound:
                    'Diğer kullanıcılar hesabınıza gönderilen Evcil Hayvan Kimliğini bulamadıklarını söylediler. Lütfen, bir dahaki sefere göndermeyi unutmayın',
                petIdIncorrectPosition:
                    'Evcil Hayvan Kimliğiniz diğer kullanıcıların anlayamayacağı şekilde yerleştirilmiştir. Bir dahaki sefere daha dikkatli olmaya çalışın',
                userNotFound:
                    'Hem kullanıcılar hem de yöneticiler hesabınızı bulamadı. Bir şey mi oldu?',
            },
            SHARE_success_title: 'Paylaşım Görevi Tamamlandı',
            SHARE_success_text:
                'Tebrikler! Bir fotoğraf paylaştınız ve doğrulamayı geçti. Daha fazlası için yarın tekrar gelin',
            SHARE_success_button: 'Detayları Görüntüle',
        },
        modalAllDead: {
            title: 'Evcil Hayvanlarınız Öldü',
            text: 'Evcil hayvanlarınızdan en az biri iyi durumda olana kadar görevleri oynayamazsınız. Evcil hayvanlarınızı onarın ve geri gelin',
            button: 'Restore Evcil Hayvanlar',
        },
        modalSomeDead: {
            title: 'Evcil Hayvanlarınızdan Bazıları Öldü',
            text: 'Bazı evcil hayvanlarınız öldü ve ödül kazanamayacaklar. Devam etmek istediğinize emin misiniz?',
            button: 'Restore Evcil Hayvanlar',
            button2: 'Oyuna Devam Et',
        },
    },
    collectionsScreen: {
        title: 'Koleksiyonum',
        text: 'Burası harika evcil hayvanlarınız için bir yuva',
        mintNewNft: 'İlk Evcil Hayvanınızı Alın',
        mintPet: 'Bir Evcil Hayvan Yaratın',
        noCollectionsYet: 'Burada Kimse Yaşamıyor',
        noCollectionsYetInfo:
            'Ne yazık ki, henüz bir hayvan arkadaşınız yok. Evcil hayvanınız olmadan nasıl yaşayabilirsiniz?',
        levelUp: 'Seviye Yükseltme',
        rankUp: 'Sıralama Yukarı',
        restore: 'Geri Yükleme',
        feed: 'Besleme',
        healAllButtonTooltip:
            "Toplu evcil hayvan iyileştirmesini yalnızca sağlığı %100'den düşük en az 2 evcil hayvanınız varsa kullanabilirsiniz",
    },
    detailedPet: {
        headerSubtitle:
            'Bu sizin NFT evcil hayvanınız, onun yardımıyla günlük görevleri tamamlayabilir ve jeton ödülleri alabilirsiniz. Ona iyi bakın',
        levelXP: {
            title: 'Seviye ve XP',
            text: 'Görevleri tamamlayarak XP kazanın ve evcil hayvanınızın seviyesini yükseltin. Belirli bir seviyeye ulaştıktan sonra evcil hayvan daha yüksek Rütbeye yükselebilir',
            textUpgrade:
                "Tüm deneyimi {{level}} seviyesinde elde ettiniz. Daha fazla jeton kazanmak için NFT'nizi yeni seviyeye yükseltin",
            upgrade: "Seviye {{level}}'e Yükseltme",
        },
        animalType: {
            title: 'Hayvan Türü',
            text: 'Algoritmalarımız resimlerdeki hayvanları yüksek olasılıkla tanıyabilmektedir',
        },
        rank: {
            title: 'Sıralama {{rank}}',
            text: 'Rütbe, ana evcil hayvan özelliklerinden biridir. Daha yüksek Rütbeler daha fazla ödül kazanır ve daha yüksek Ödül Kilidi Açma oranına sahiptir',
            upgrade: '"{{rank}}" Sıralamasına Yükseltme',
            textUpgrade:
                '"{{rank}}" rütbesinde tüm seviyelere ulaştınız. Daha fazla jeton kazanmak için yeni rütbeye yükseltin',
        },
        age: {
            button: "NFT'yi Geri Yükle",
            Baby: 'Bebek = {{current}} / {{max}} Gün',
            Young: 'Genç = {{current}} / {{max}} Gün',
            Adult: 'Yetişkin = {{current}} / {{max}} Gün',
            Old: 'Eski = {{current}} / {{max}} Gün',
            description:
                "Evcil hayvanınızın yaşı, yaratıldığı andan itibaren dikkate alınır. NFT'niz yaşlandığında ölecek ve restore edilmesi gerekecektir",
            descriptionDead:
                'Evcil hayvan uzun ve mutlu bir hayat yaşadı ve vefat etti. Üzülmenize gerek yok, onu geri yükleyebilir ve tekrar oynayabilirsiniz!',
            dailyUnlock: 'Günlük Kilit Açma = ',
            daysMore: 'günler daha fazla',
            modalWhatIsAge: {
                title: 'Yaş nedir?',
                text: 'NFT evcil hayvanınızı yarattığınızda, yaşamaya ve yaşlanmaya başlayacaktır. Yaşlandıkça, sonunda ölecektir. Bu durumda, geri yüklenmesi gerekecektir. Sanal evcil hayvanınızın uzun ömürlülüğü Rütbesine bağlıdır',
                feature: {
                    title: 'Geri Yükleme İndirimi = {{discount}}',
                    text: "NFT'nin doğal ölümünden sonra, {{discount}} indirimle geri yükleyebileceksiniz (Rütbeyi koruyarak)",
                    alert: "Seviye Yükseltme, evcil hayvanınızın yaşını 0'a sıfırlayacak ve yükseltilen sanal evcil hayvan yeni Seviyenin yaş sınırına göre yaşayacaktır. NFT'yi geri yükledikten sonra, Seviye 1'den başlayacaksınız",
                },
            },
            modalNFTisAgeDead: {
                button: 'Geri Yükleme',
                title: 'Evcil Hayvan Yaşlıydı ve Öldü',
                text: 'NFT evcil hayvanı "{{name}}" uzun ve mutlu bir hayat yaşadı ve vefat etti. Üzülmenize gerek yok, onu geri yükleyebilir ve tekrar oynayabilirsiniz!',
                feature: {
                    title: 'Geri Yükleme İndirimi = {{discount}}',
                    text: "NFT'nin doğal ölümünden sonra, {{discount}} indirimle geri yükleyebileceksiniz (Rütbeyi koruyarak)",
                    alert: "Seviye Yükseltme, evcil hayvanınızın yaşını 0'a sıfırlayacak ve yükseltilen sanal evcil hayvan yeni Seviyenin yaş sınırına göre yaşayacaktır. NFT'yi geri yükledikten sonra, Seviye 1'den başlayacaksınız",
                },
            },
            checkoutAgeRevive: {
                title: 'Evcil Hayvanı Geri Yükle',
                text: 'Evcil hayvanınız yaşlıydı ve öldü. Günlük görevler için kullanılamıyor. Onu oyuna geri yükleyin ve daha fazla jeton kazanın',
                restoreTo: 'Geri Yükle',
                transaction: `"{{name}}" NFT'yi geri yükle`,
                errors: {
                    wrongState: 'Bir sorun var, hayvanı canlandıramıyorum.',
                },
            },
            successAgeRevive: {
                title: 'Evcil Hayvan Geri Getirildi!',
                text: 'Evcil hayvan başarıyla geri yüklendi. Günlük görevleri oynayın ve mutlu evcil hayvanınızla daha da fazla jeton kazanın',
                backToPet: 'Evcil Hayvan Görüntüle',
            },
        },
        earnings: {
            title: 'Kazançlar',
            text: 'NFT kazançları evcil hayvanın rütbesine ve seviyesine bağlıdır',
            rank: 'Sıralama Kazançları = ',
            level: 'Seviye Bonusu = ',
        },
        matching: {
            title: 'Eşleşmeler',
            text: "Günlük görevlerde, diğer kullanıcılar NFT'nizi değerlendirebilir ve birbirleriyle eşleştirebilir",
            like: '{{like}} Beğeniler',
            dislike: '{{dislike}} Beğenmeme',
        },
        health: {
            title: 'Sağlık',
            text: "Evcil hayvanınızı besleyin, aksi takdirde sağlığını kaybedebilir. Evcil hayvanın sağlığı 0'a ulaştığında, evcil hayvan ölecektir",
            titleDead: 'NFT Öldü',
            textDead:
                'Hayvanınızı uzun süre beslemediniz ve şimdi öldü. Deneyim, ödül toplayamayacak ve evcil hayvanınızla oynayamayacaksınız. Ama endişelenmeyin, onu canlandırabilir ve oynamaya devam edebilirsiniz. Acele edin!',
            buttonFeed: 'Evcil Hayvan Besleme',
            buttonRestore: "NFT'yi Geri Yükle",
            modalWhatIsHealth: {
                title: 'Sağlık Nedir?',
                text: 'Eğer onu beslemezseniz evcil hayvanınızın sağlığı her gün azalır. Daha fazla kazanmak için sağlığınızı her zaman maksimumda tutun.',
                card: {
                    title: 'Evcil Hayvan Sağlığı = Günlük Ödül',
                    text: "Ödüller HP ile orantılıdır, örneğin 80 HP ile ödüllerin %80'ini kazanırsınız. Evcil hayvanınıza iyi bakın!",
                },
            },
            modalNFTisDead: {
                title: 'NFT Öldü',
                text: 'Hayvanınızı "{{petName}" uzun süredir beslemediniz ve şimdi öldü. Deneyim, ödül toplayamayacak ve evcil hayvanınızla oynayamayacaksınız. Ama endişelenmeyin, onu canlandırabilir ve oynamaya devam edebilirsiniz. Acele edin!',
                button: "NFT'yi Geri Yükle",
            },
            checkoutRevive: {
                title: "NFT'yi Geri Yükle",
                text: "NFT'niz günlük görevler için kullanılamıyor. Oynamak için geri yükleyin ve daha fazla jeton kazanın",
                restoreTo: 'Geri Yükle',
                transaction: `"{{name}}" NFT'yi geri yükle`,
                max: '100 Sağlık',
                errors: {
                    wrongState: 'Bir sorun var, hayvanı canlandıramıyorum.',
                },
            },
            successRevive: {
                title: 'NFT Restore Edildi!',
                text: 'NFT başarıyla geri yüklendi. Günlük görevleri oynayın ve daha da fazla jeton kazanın',
                backToPet: 'Evcil Hayvan Görüntüle',
            },
            checkoutHealUp: {
                title: 'NFT Beslemesi',
                text: 'Hayvanınızın sağlığı günlük beslenmeye bağlıdır. Tam sağlıkla, hayvanınız daha fazla para kazanır',
                restoreTo: 'Restore edildi',
                transaction: `"{{name}}" NFT'yi geri yükle`,
                max: '{{amount}} Sağlık',
                errors: {
                    wrongState: 'Bir sorun var, hayvanı iyileştiremiyorum.',
                },
            },
            infoMultipleHealUp: {
                title: 'Birden Fazla Evcil Hayvan Besleyin',
                text: 'Tüm evcil hayvanlarınızı beslemek için tek bir düğme kullanın! Evcil hayvanlar teker teker iyileştirilecek. Tüm işlemler blok zincirinde gerçekleşir, böylece onları takip edebileceksiniz',
                primaryButton: 'Evcil Hayvan Besleme',
                secondaryButton: 'Bunu bir daha gösterme',
            },
            checkoutMultipleHealUp: {
                title: 'Birden Fazla Evcil Hayvan Besleyin',
                text: "Tüm evcil hayvanlarınızın Sağlığını geri kazanın. Daha fazla Sağlığı olan NFT'ler daha fazla ödül kazanacak",
                transaction: "{{count}} NFT'leri geri yükleyin",
            },
            proceedingMultipleHealUp: {
                title: 'Sağlık Geri Kazandırılıyor',
                text: 'Lütfen tüm işlemler sonuçlanana kadar biraz bekleyin. İşlemler başarısız olabileceğinden ekrandan çıkmayın! İşlemler tamamlandığında, ekrandan çıkabileceksiniz',
                error: 'Bazı NFT işlemleri blok zinciri sorunları nedeniyle başarısız oldu. Tekrar deneyin',
            },
            multipleSuccessHealUp: {
                title: "NFT'lerin Sağlığı Geri Geldi!",
                text: 'Evcil hayvanınızın sağlığı geri geldi. Her işlem hakkında daha fazla ayrıntı için aşağıdaki düğmeye tıklayın',
                backToCollection: 'Koleksiyona Geri Dön',
                item: 'Besleme {{length}} evcil hayvan',
            },
            successHealUp: {
                title: 'NFT Sağlığı Geri Kazandı!',
                text: 'NFT başarıyla beslendi ve sağlığı geri geldi. Günlük görevleri oynayın ve daha da fazla jeton kazanın',
                backToPet: 'Evcil Hayvan Görüntüle',
            },
            healUpAmountChoose: {
                title: 'Sağlığı Geri Kazandırmak için Besleyin',
                text: 'Geri yüklemek istediğiniz sağlık puanı miktarını içeren seçeneği seçin',
                button: 'Ödeme',
                loading: 'Özet hesaplanıyor..',
                label: 'Uygun numarayı seçin',
                errors: {
                    MAX: '{{amount}} sağlığı geri yüklemek için maksimum kullanılabilir',
                    MIN: '{{amount}} sağlığını geri kazanmak için mevcut minimum',
                },
            },
            healthPetCollectionList: { health: '{{health}} Sağlık' },
            healAllLeave: {
                title: 'Ayrılmak istediğinizden emin misiniz?',
                text: 'Evcil hayvanınızın iyileşme süreci devam etmektedir, süreç sırasında ayrılmanız hatalara, çifte harcamaya veya yanlış bakiye kesintisine neden olabilir. Dikkatli ilerleyin',
                leave: 'Yine de git',
                keep: 'İyileşmeyi Bitir',
            },
        },
        blockchainInfo: {
            tokenId: 'Belirteç Kimliği',
            title: "NFT'ye Genel Bakış",
            description:
                'Evcil hayvan NFT varlığınız blok zincirinde saklanır. İstediğiniz zaman cüzdandan çekebilirsiniz',
            descriptionFree:
                'Evcil hayvanınız Rütbesizdir ve gerçek bir NFT değildir. Seviye atlayın ve ondan NFT yapabileceksiniz',
            warningText:
                'NFT çekildikten sonra Cooldown moduna girecek ve 24 saat boyunca oynanamayacaktır',
            cooldown: 'Bekleme süresi',
            withdraw: 'Geri Çekilme',
        },
    },
    mysteryBoxes: {
        title: 'Gizemli Kutular',
        emptyTitle: 'Henüz Gizemli Kutu Yok',
        emptyText: 'Hiç Gizemli Kutunuz yok',
        emptyButton: 'Bir Kutu Satın Alın',
        prepareToOpen:
            "Bir kutu açıp, ChainLink Oracle'ın rastgele sonucunu bekliyorum...",
        banner: {
            isComing: {
                title: 'Gizemli Kutular İndirimi Geliyor',
                text: ' kalan süre',
            },
            isStart: {
                title: 'Gizemli Kutu Satın Alın',
                text: 'Şansınızı deneyin ve en yüksek rütbeleri kazanın',
            },
            isNotAvailable: {
                title: 'Gizemli Kutular İndirimi kapandı',
                text: 'Mystery Boxes satışları nadiren gerçekleşir ve bir sonraki duyuruya kadar mevcut değildir',
            },
        },
        header: {
            title: 'Gizemli Kutular',
            text: 'Satın aldığınız kutular burada saklanacaktır. İstediğiniz zaman açın ve NFT yapın',
        },
        mysteryBoxCard: { open: 'Açık Kutu', mint: 'NFT olarak' },
        error: {
            title: 'Hata',
            text: 'Bir şeyler yanlış gitti. Yeniden yüklemeyi dene',
        },
        openRank: { button: 'Detayları Görüntüle' },
        openBoxModal: {
            title: 'Bir Kutu Açmak İster misiniz?',
            text: "Kutuyu açtıktan sonra, rastgele rütbe alacaksınız ve NFT'yi ücretsiz olarak basabileceksiniz",
            button1: 'Evet, Açık',
            button2: 'Hayır, İptal',
        },
        purchaseWelcome: {
            stepOne: {
                title: 'Gizemli Kutularla Şansınızı Deneyin',
                text: 'Gizemli Kutular size sabit fiyat karşılığında en iyi NFT Sıralamasını elde etme şansı verir. Şansınızı deneyin!',
            },
            stepTwo: {
                title: 'En Yüksek Rütbeyi Alma Şansı',
                text: "Gizemli Kutu'yu satın aldıktan sonra istediğiniz zaman açabilir ve ardından herhangi bir ek ücret ödemeden darphane işlemine devam edebilirsiniz",
            },
            stepThree: {
                title: 'Gerçek Rastlantısallık',
                text: 'Mystery Box farklı dereceler kazanma şansı tamamen rastgeledir ve blok zincirinde gerçek rastgele sayı üretmek için ChainLink Oracle teknolojisini kullanır',
            },
            button: 'Kutu Miktarı Seçiniz',
        },
        purchaseScreen: {
            title: 'Miktar Seçiniz',
            text: 'Tek seferde çoklu kutu satın alabilirsiniz',
            label: 'Miktarı girin veya seçin',
            labelNoInput: 'Gizemli kutuların miktarını seçin',
            errors: {
                max: "Mevcut maksimum kutu sayısı 10'dur",
                min: 'Minimum mevcut 1 kutudur',
                noSymbols: 'Sadece sayılara izin verilir',
            },
            button: 'Ödeme',
            loading: 'Özet hesaplanıyor..',
        },
        purchaseCheckout: {
            title: 'Gizemli Kutular Satın Alın',
            text: 'Gizemli Kutular size sabit fiyat karşılığında en iyi NFT Sıralamasını elde etme şansı verir. Şansınızı deneyin!',
            transactionDetails: {
                label: 'Kutu',
                text: '{{amount}} Gizemli Kutu',
                transaction: 'Satın Al {{amount}} Gizemli Kutu',
            },
        },
        purchaseSuccess: {
            title: 'Gizemli Kutular Satın Alındı!',
            text: 'Gizemli kutular başarıyla satın alındı. Gizemli Kutular sekmesinden açabilirsiniz',
            button: 'Tümünü görüntüle',
        },
        comingSoon: {
            title: 'Gizemli Kutular Çok Yakında',
            text: 'Gizemli Kutular satışı yaklaşıyor. Bizi izlemeye devam edin ve şansınızı deneyin!',
            timer: 'Kalan Süre',
        },
        saleClosed: {
            title: 'Gizemli Kutular Mevcut Değil',
            text: 'Mystery Boxes satışı şu anda mevcut değildir. Resmi duyurular için bizi izlemeye devam edin',
        },
        errors: {
            forbidden: {
                title: 'Satış sona erdi',
                text: 'Satış sona erdi, satın alınacak Gizemli Kutu kalmadı. Bir dahaki sefere şansınızı deneyin',
            },
        },
        modalMysteryBoxSaleInfo: {
            title: 'Gizemli Kutularla Şansınızı Deneyin',
            text: 'NFT değerinin Gizemli Kutu fiyatından daha az olmayacağı garanti edilmektedir. Gizemli Kutular şu fiyata satılacaktır',
            timerTitle: 'Satışa Kadar Süre',
            timerText:
                'Bu, sınırlı bir süre devam edecek olan sınırlı bir koleksiyonun satışıdır. Sadece ',
            timerAdditionalText: "{{miktar} NFT'ler mevcuttur",
            chanceTitle: 'Kazanma Şansı',
            chanceText:
                'Belirli bir olasılıkla bir NFT kazanın. İşte ihtimaller:',
            button: 'Gizemli Kutulara',
        },
    },
    errorBoundary: {
        navigation: 'Hata',
        title: 'İstemci tarafı hatası',
        text: 'Maalesef bizim tarafımızda bir şeyler ters gitti. Bu hatayı görmeye devam ederseniz, lütfen destek ekibimizle iletişime geçin',
        button: 'Ana sayfaya git',
        reloadApp: 'Uygulamayı Yeniden Yükle',
    },
    pullToRefresh: {
        reloadBalance: {
            text: 'Ferahlatıcı denge..',
            modalText: 'Ferahlatıcı.',
        },
        reloadPets: {
            text: 'Ferahlatıcı evcil hayvanlar..',
            modalText: 'Ferahlatıcı.',
        },
        reloadMysteryBox: {
            text: 'Ferahlatıcı gizemli kutular..',
            modalText: 'Ferahlatıcı.',
        },
        reloadTasks: {
            text: 'Yenileme görevleri..',
            modalText: 'Ferahlatıcı.',
        },
        reloadVerifyUsers: {
            text: 'Evcil hayvan arıyorum.',
            modalText: 'Ferahlatıcı.',
        },
        reloadRewards: 'Ferahlatıcı ödüller...',
        reloadStatistics: 'İstatistikler yenileniyor...',
        reloadReferrals: 'Ferahlatıcı yönlendirmeler...',
        loading: 'Ferahlatıcı.',
        pulling: 'Yenilemek İçin Çekin',
        releasing: 'Serbest Bırak',
    },
    petLevelUp: {
        readyToUpModal: {
            titleStart: 'NFT Hazır',
            titleLevelUp: ' {{level}} Seviye ',
            titleEnd: 'Yukarı',
            subTitleStart: "Tebrikler! Tüm deneyimi ve NFT'yi topladınız ",
            subTitleEnd: ' seviye atlamaya hazır',
            button: 'Yükseltme',
            featureRankEarnings: {
                title: 'Sıra Kazançlar ≈ {{igup}} ≈ ({{usd}}$)',
                text: 'Bu sadece rütbeden gelen temel bir değerdir',
            },
            featureLevelEarnings: {
                title: 'Seviye Kazançlar',
                text: 'Bu, rütbe kazançlarına ek olarak gelen bir değerdir',
            },
            featureNextRank: {
                title: '{{levels}} seviye(ler) Daha Fazla "{{rankName}}"',
                text: "Bir sonraki Seviyeye yükseltebilmek için NFT'nizin seviyesini {{levels}} daha yükseltmeniz gerekir",
            },
        },
        petLevelUpSuccess: {
            title: 'NFT Seviye Atladı!',
            text: "NFT {{name}} başarıyla Seviye {{level}}'ye yükseltildi. Günlük görevleri oynayın ve yükseltilmiş NFT ile daha da fazla jeton kazanın",
            backToPet: 'Evcil Hayvan Görüntüle',
            loading: 'Evcil hayvanların güncellenmesi...',
        },
        headerTitle: 'NFT Seviye Yükseltme',
        checkout: {
            upgrade: 'Yükseltme',
            level: 'Seviye {{level}}',
            transaction: '{{name}} NFT için seviye yükseltme',
        },
        errors: { PET_WRONG_STATE: 'Seviye yükseltme mevcut değil' },
    },
    petRankUp: {
        readyToUpModal: {
            title: '{{rank}} Rütbesine Yükseltme',
            subTitle:
                '{{rank}} tüm seviyelere ulaştınız ve Evcil Hayvanınız yükseltmeye hazır',
            button: 'Yükseltme',
        },
        petLevelUpSuccess: {
            title: 'NFT Sıralamada Yükseldi!',
            text: 'NFT {{name}} başarılı bir şekilde {{rank}} rütbesine yükseldi. Günlük görevleri oynayın ve yükseltilmiş NFT ile daha da fazla token kazanın',
            backToCollection: 'Koleksiyona Geri Dön',
            loading: 'Evcil hayvanı güncelle...',
        },
        headerTitle: 'NFT Seviye Yükseltme',
        checkout: {
            upgrade: 'Yükseltme',
            level: 'Seviye {{level}}',
            transaction: '{{name}} NFT için seviye yükseltme',
        },
        errors: { PET_WRONG_STATE: 'Sıralama mevcut değil' },
    },
    petIsPlaying: {
        title: 'Evcil Hayvanınız Oynuyor',
        text: 'Görevleri tamamlamadan önce hesabınızdan çekerseniz, bugün için ödül alamazsınız ve evcil hayvanınız önümüzdeki 24 saat boyunca Bekleme moduna girer',
        button: 'Anlıyorum',
    },
    petOnCooldown: {
        title: 'Bekleme Süresi NFT',
        text: "NFT'niz başka bir borsadan transfer ediliyor ve henüz oynanabilir durumda değil, tahmini transfer süresi yukarıda gösterilmiştir. Daha hızlı olması için elimizden geleni yapıyoruz, anlayışınız için teşekkürler",
    },
    petIsDead: {
        title: 'NFT Öldü',
        text: 'Hayvanınızı "{{petName}" uzun süredir beslemediniz ve şimdi öldü. Deneyim, ödül toplayamayacak ve evcil hayvanınızla oynayamayacaksınız. Ama endişelenmeyin, onu canlandırabilir ve oynamaya devam edebilirsiniz. Acele edin!',
        errors: { PET_WRONG_STATE: 'Evcil hayvan restorasyonu mevcut değil' },
    },
    socializeToEarn: {
        welcomeSlidesShare: {
            startSharing: 'Paylaşmaya Başlayın',
            sharing: 'Paylaşmak Önemsemektir',
            sharingText:
                'Evcil hayvanınız her gün sizin ilginize ihtiyaç duyar. Bunu sosyal medyada arkadaşlarınızla paylaşarak onlara verin',
            sharingEnergy: ' Toplam Enerji',
            socialMedia: 'Evcil Hayvanınızı Sosyal Medyada Paylaşın',
            socialMediaText:
                'Sosyal medya hesabınızı seçin ve sosyal medya içeriğinize bir Evcil Hayvan Kimliği ekleyin ve diğer kullanıcıların evcil hayvanınızı bulmasına izin verin',
            socialMediaEnergy: ' Toplam Enerji',
            referral: 'Yönlendirme bağlantınızı ekleyin',
            referralText:
                'Yönlendirme bağlantınız hikayedeki evcil hayvan kimliğine eklenmelidir. Bağlantı eksikse diğer oyuncular ödevinizi kontrol edemez!',
            errors: {
                FORBIDDEN: {
                    text: 'Bu sosyal hesapla şu anda sosyal görev başlatamazsınız. Yarın tekrar deneyin',
                },
            },
        },
        shareYourPetPhoto: {
            copyToClipboard: 'Kullanıcı adı panoya kopyalandı',
            title: 'Evcil Hayvan Fotoğrafınızı Paylaşın',
            texts: {
                INSTAGRAM:
                    "İçeriğinizi Instagram'da ekli Evcil Hayvan Kimlik kartı ile paylaşın ve diğer kullanıcıların evcil hayvanınızı bulmasına izin verin",
                TIKTOK: "İçeriğinizi TikTok'ta ekli Evcil Hayvan Kimlik kartı ile paylaşın ve diğer kullanıcıların evcil hayvanınızı bulmasına izin verin",
                TWITTER:
                    "Ekli Evcil Hayvan Kimlik kartı ile içeriğinizi Twitter'da paylaşın ve diğer kullanıcıların evcil hayvanınızı bulmasına izin verin",
                FACEBOOK:
                    "İçeriğinizi FACEBOOK'ta ekli Evcil Hayvan Kimlik kartı ile paylaşın ve diğer kullanıcıların evcil hayvanınızı bulmasına izin verin",
            },
            info: 'Nasıl Paylaşılır?',
            download: 'İndir',
            share: 'Paylaş',
            createPhoto: 'Açık Editör',
            button: 'Paylaş ve Bitir',
            warningText:
                'Göreviniz tamamlanana kadar Evcil Hayvan Kimliğinizin mevcut olduğundan ve diğer kullanıcılar tarafından kolayca bulunabildiğinden emin olun',
            selectCreationMethod: 'Fotoğraf Seçin',
            creationMethod: {
                camera: 'Fotoğraf Çekin',
                gallery: 'Galeriden Seçiniz',
            },
            modalPetIdVisible: {
                title: 'Evcil Hayvan Kimliği ve Bağlantı Görünür mü?',
                text: "Hikayeniz diğer kullanıcılar tarafından kontrol edilecektir. Pet ID'yi veya bağlantıyı bulamazlarsa veya içeriğini ayırt edemezlerse, görev tamamlamanız reddedilecektir",
                button1: 'Evet, devam et',
                button2: 'Hayır, Tekrar Kontrol Edin',
            },
            modalShareYourPhoto: {
                title: 'Paylaşım Yöntemini Seçin',
                shareTemplate: {
                    title: 'Paylaşım Şablonu',
                    text: 'Evcil Hayvan Kimliğinizi daha hızlı paylaşmak için oluşturduğumuz şablonu kullanın',
                },
                editToShare: {
                    title: 'Paylaşmak için Düzenle',
                    text: 'Özel Evcil Hayvan Kimliği düzenlemesi için galeriden bir resim yükleyin veya bir fotoğraf çekin',
                },
                downloadPetId: {
                    title: 'Evcil Hayvan Kimliğini İndirin',
                    text: 'Araçlarımızı kullanmadan gönderiyi istediğiniz gibi şekillendirin',
                },
                submit: 'Paylaşılan Evcil Hayvan Kimliğim var',
                loading: 'İçerik hazırlanıyor..',
                saveSuccess: 'Fotoğraf başarıyla kaydedildi',
            },
            petIdVisibleLoading: 'Bulma Görevi Oluşturma...',
            shareSuccess: {
                title: 'Diğer Evcil Hayvanları Bulun',
                text: 'Evcil hayvanınızın fotoğrafını başarıyla paylaştınız. Göreviniz doğrulama aşamasındadır ve genellikle 6 ila 12 saat arasında sürer. Şimdi sosyal medyada diğer evcil hayvanları bulma sırası sizde',
                button1: 'Diğer Evcil Hayvanları Bulun',
                button2: 'Paylaşıma Geri Dön',
                button3: 'Görevlere Geri Dön',
                toastSuccess: 'Tüm doğrulama görevleri tamamlandı',
            },
            alert: 'Görev, yalnızca uygulamanın bağlantısını yerleştirirseniz tamamlanmış kabul edilecektir',
        },
        createShareTemplate: {
            screenTitle: 'Şablon Paylaşımı',
            title: 'Paylaşmak için Şablon Kullanın',
            text: 'İçeriği hızlı ve kolay bir şekilde paylaşmak için önceden tasarlanmış şablonumuzu kullanın',
            shareTemplate: {
                Default: 'Her gün oynarım IguVerse ve\nKripto Kazanın',
                BinanceNft:
                    'Sanal Bir Evcil Hayvan Edinin ve IguVerse ile Kazanmaya Başlayın',
                BnbChain:
                    'Sanal Bir Evcil Hayvan Edinin ve IguVerse ile Kazanmaya Başlayın',
                Okx: 'Aya İniş: IGU, {NEWLINE} OKX Borsasında Başlatılıyor',
                KuCoin: 'Aya İniş: IGU, {NEWLINE} KUCOIN {MARGIN_OFF}Borsasında Başlatılıyor',
                Bybit: 'IguVerse Oy Verin\nve 121.000\nDolarlık Ödülleri\nPaylaşın!',
            },
            placeForLink: 'Bağlantı için yer',
            socialCardTemplate: {
                Default: 'Her gün oynarım IguVerse ve\nKripto Kazanın',
                Bybit: 'IguVerse Oy Verin\nve 121.000\nDolarlık Ödülleri\nPaylaşın!',
            },
        },
        welcomeSlidesVerify: {
            startVerify: 'Bulma Görevini Başlat',
            find: 'Diğer Evcil Hayvanları Bulun',
            findText:
                'Evcil hayvanınızın diğer evcil hayvanların ilgisine ihtiyacı var. Diğer oyuncuların evcil hayvanlarını bulun ve birlikte ödüllerin tadını çıkarın. Diğer evcil hayvanları ararken hata yapmayın, onlar size güveniyor. Günlük hedefiniz tüm evcil hayvanları bulmaktır.',
            findEnergy: ' Toplam Enerji',
            beResponsible: 'Sorumlu Olun',
            beResponsibleText:
                'Adil oynayın ve yanlış kimlikler vererek veya bulamadığınızı iddia ederek sistemi yanıltarak hile yapmaya çalışmayın. Bunu yaptığınızda hesabınız işaretlenebilir ',
            beResponsibleEnergy: ' Toplam Enerji',
        },
        verifyUser: {
            title: 'Evcil Hayvan Bul',
            text: "Sosyal medyada bulunabilen diğerinin kullanıcı Pet ID'sini bulmanız ve girmeniz gerekir. Her başarılı eşleşme için {{energy}} Enerji kazanacaksınız",
            info: 'Evcil Hayvan Kimliği Nasıl Bulunur?',
            label: 'Evcil Hayvan Kimliği',
            placeHolder: 'Evcil Hayvan Kimliğini Girin',
            question: 'Evcil Hayvan Kimliği Nasıl Bulunur?',
            buttonVerify: 'Doğrulama',
            buttonNotFound: 'Evcil Hayvan Kimliği Bulunamadı',
            errorMessage:
                'Yanlış Evcil Hayvan Kimlik kodu. Lütfen tekrar deneyin. Denemeler {{attempts}} kaldı!',
            loadingVerifyUser: 'Kontrol ediyorum.',
            errors: {
                noTasksText1: 'Şu anda mevcut görev yok',
                noTasksText2: 'Sonra tekrar gelin',
                gameIterationExists1: 'Oluşturmanıza izin verilmez',
                gameIterationExists2: 'bu oyun yinelemesinde daha fazla görev',
            },
            toastNoPetVerification: {
                title: 'Hata',
                text: 'Doğrulama için mevcut evcil hayvan yok ',
            },
            toastSuccess: 'Tebrikler! Kullanıcı {{user}} doğrulandı',
            toastFailedVerify: 'Başarısız! Kullanıcı {{user}} doğrulanmadı',
            regexError: 'Yalnızca rakamlara ve A-Z karakterlerine izin verilir',
            verifyEmpty: {
                title: 'Başka Hayvan Yok',
                text: 'Görünüşe göre şu anda kimse oynamıyor. Daha fazla evcil hayvan mevcut olduğunda sizi bilgilendireceğiz',
                button1: 'Diğer Görevleri Keşfedin',
                button2: 'Tekrar deneyin',
                refresh: 'Yenile',
            },
            verifyNotFound: {
                title: 'Evcil Hayvan Bulunamadı',
                text: 'Umarım haklısındır. Eğer evcil hayvan gerçekten oradaysa seni uyaracağız',
                button1: 'Sıradakini Bul',
                button2: 'Çalmayı Bitir',
            },
            verifyAlreadyCompleted: {
                title: 'Çoktan Tamamlandı',
                text: 'Metin Zaten Tamamlandı',
                button1: 'Sonraki Doğrulama',
                button2: 'Çalmayı Bitir',
            },
            verifyMatch: {
                title: 'Evcil Hayvanlar Eşleşti!',
                text: {
                    step1: 'Tebrikler! Evcil hayvanınız ',
                    step2: ' evcil hayvan ile eşleşti ',
                    step3: '! Artık uygulamanın içinden bağlanabileceksiniz',
                },
                button1: 'Sıradakini Bul',
                button2: 'Çalmayı Bitir',
                like: 'Gibi',
                dislike: 'Beğenmeme',
                alreadyRate: 'Kararınızı değiştiremezsiniz',
            },
            verifyFailed: {
                title: 'Başarısız',
                text: 'Ne yazık ki doğru Evcil Hayvan Kimlik kodunu veremediniz',
                button1: 'Sıradakini Bul',
                button2: 'Çalmayı Bitir',
            },
            modalPetIdNotFound: {
                title: 'Evcil Hayvan Kimliği Bulunamadı mı?',
                text: 'Lütfen kullanıcının fotoğrafında Evcil Hayvan Kimliğini bulmaya çalışın. Evcil Hayvan Kimliği oradaysa ve siz bunu sağlamadıysanız, Enerji puanlarınızı kazanamazsınız ve bir uyarı alabilirsiniz.',
                button1: 'Evet, Onayla',
                button2: 'İptal',
            },
            tips: {
                title: 'Doğrulama İpuçları',
                alert: "Evcil Hayvan Kimliği kuralları karşılamıyorsa, 'Evcil Hayvan Kimliği bulunamadı' düğmesine tıklayın",
                post: 'Evcil hayvan kimliği bir hikayeye yerleştirilmelidir',
                picture:
                    'Evcil hayvan kimliği ve üzerindeki tüm bilgiler içerikte görünür olmalıdır',
                changes:
                    'Evcil hayvan kimliği değiştirilebilir, ancak değişiklikler diğer kurallara aykırı olmamalıdır',
                cropping:
                    'Resmin veya parçalarının kırpılmasına veya gizlenmesine izin verilmez',
                overlaying:
                    'Üst üste bindirme veya aşırı küçültmeye izin verilmez',
            },
        },
        petCardId: {
            link: 'IguVerse uygulamasını şu adresten indirin ',
            earnStart: 'Hayvanlarım kazanıyor ',
            earnEnd: ' her gün',
            freeEarn: 'Ücretsiz evcil hayvan kazancım ',
            donateMessage: 'Kazandığımın bir kısmı bağışlanıyor na ',
            bnbMessage:
                'IguVerse x BNB Chain: Web3 ve sosyal medyadaki yeni viral trende katılın',
            okxKuCoinMessage: 'IGU Token Başlıyor ',
            defaultMessage:
                'Pasar dengan AI dan jaringan iklan — gabung sekarang!',
        },
    },
    moveToEarn: {
        welcomeSlides: {
            walkPet: 'Evcil Hayvanlarınızı Gezdirin',
            walkPetText:
                'Evcil hayvanlarınızın da en az sizin kadar sağlıklı kalmak için her gün yürümeye ihtiyacı var. Evcil hayvanınızı yürütün ve Enerji puanları ile ödüllendirileceksiniz',
            energyTotal: ' Enerji Toplam',
            complete: 'Yürüyüş Hedefinizi Tamamlayın',
            completeText:
                'Yürüyüş hedefinizi tamamlayın, performansınızı takip edin ve sağlıklı yaşamın tadını çıkarın',
            antiCheating: 'Hile Karşıtı Algoritmalar',
            antiCheatingText:
                'Hile karşıtı algoritmalarımız, kullanıcıdan gelen şüpheli etkinlikleri tespit edebilir. Hile yapan kullanıcılar enerji puanlarını kaybedeceklerdir',
        },
        modals: {
            prepare: 'Yürümeye Hazırlanın',
            prepareText:
                'Yürüme görevini günde bir kez tamamlayabilirsiniz. Görevi bitirdikten veya kapattıktan sonra, o gün daha fazla oynayamazsınız',
            leave: 'Gitmek mi istiyorsunuz?',
            leaveText:
                'Görevi mevcut Enerji ilerlemenizle bitireceksiniz. Göreve yarın tekrar başlayabilirsiniz',
            leaveBtn1: 'Evet, ayrıl',
            leaveBtn2: 'Hayır, devam et',
            prepareBtn1: 'Yürümeye Başlayın',
            prepareBtn2: 'İptal',
            permissionsInfoText:
                "IguVerse, uygulama kapalı olduğunda veya kullanılmadığında bile konum verilerini toplar. Uygulama, Yürüme Görevi'nin işlevselliğini sağlamak için arka planda konumunuza erişebilir",
            permissionsInfoBtn1: 'Devam et',
            permissionsInfoBtn2: 'İptal',
            leaveWithOutFinish: 'Çıkmak mı istiyorsunuz?',
            leaveWithOutFinishText:
                'Görevi kapattıktan sonra ilerlemeniz kaybolacak ve yeniden başlamanız gerekecektir',
            leaveWithOutFinishBtn1: 'Çıkış',
            leaveWithOutFinishBtn2: 'İptal',
        },
        notSupported: {
            title: 'Coğrafi Konum Mevcut Değil',
            text: "Cihazınız coğrafi konum API'sini desteklemiyor, Yürüme Görevini tamamlayamazsınız",
            button: 'TAMAM',
        },
        locationProblem: {
            title: 'Coğrafi Konum Sorunu',
            text: 'Cihazınızın coğrafi konum özelliğinin beklendiği gibi çalışmayı durdurduğunu fark ettik, görevi yeniden başlatmanız gerekiyor',
            button: 'Anladım',
        },
        progress: {
            paused: 'Duraklatıldı',
            walking: 'Yürümek',
            stopped: 'Durduruldu',
            tooFast: 'Çok Hızlı',
            title: 'Evcil Hayvanınızı Gezdirin',
            timeLeft: 'Yürümek İçin Kalan Zaman',
            tooFastMessage:
                "Hızınız saatte 20 km'den fazla olamaz. Hız düştüğünde ilerleme devam edecektir",
            walkStoppedMessage:
                'Yürümeyi bırakmış gibi görünüyorsunuz. Yürümeye devam ettiğinizde ilerlemeniz devam edecektir',
        },
        summary: {
            title: 'Yürüyüş İstatistikleri',
            youEarned: 'Sen Kazandın',
            energy: 'Enerji',
            subtitle:
                'Tebrikler! Tüm evcil hayvanları buldunuz. Daha fazlası için yarın tekrar gelin',
            distance: 'Mesafe',
            steps: 'Adımlar',
            averageSpeed: 'Ortalama Hız',
            viewMoreTasks: 'Daha Fazla Görev Görüntüle',
            finishPlaying: 'Çalmayı Bitir',
        },
        startWalking: 'Yürümeye Başlayın',
        skip: 'Atlamak için dokunun',
        km: 'km',
        kmH: 'km/h',
    },
    playToEarn: {
        welcomeSlides: {
            energy: 'Enerjinizi Geri Kazanın',
            energyText:
                'Meyveleri toplayın ve engellerin üzerinden atlayarak günlük Enerji seviyenizi yenileyin. Dikkatli olun, günde sadece bir deneme hakkınız var',
            energyAgainText:
                'Daha fazla ödül kazanmak için oyundaki becerinizi kullanın. Görev günde bir kez kullanılabilir, ancak oyunu istediğiniz zaman oynayabilirsiniz',
            energyTotal: ' Toplam Enerji',
            energyAgainTotal: 'Sandbox',
            avoid: 'Engellerden Kaçının',
            avoidText:
                'Ana hedefiniz engellerin üzerinden atlamak ve puan toplamak. Dikkatli olun!',
            food: 'Yiyecek Toplayın',
            foodText:
                'Toplanan yiyecekler size ek puanlar kazandırır. Skor hedefine ulaştıktan sonra oyun biter ve Enerji seviyeniz hemen yenilenir',
        },
        modals: {
            prepareToPlay: {
                title: 'Oynamaya Hazırlanın',
                text: 'İlk oyununuzda enerjiyi geri kazanmak için oynayacaksınız. Tüm enerjiyi toplayamazsanız, oyunu oynayabileceksiniz, ancak enerji ilerlemesi olmadan',
                accept: 'Oynamaya Başla',
                cancel: 'İptal',
            },
            playAgain: {
                title: 'Oynamaya Hazırlanın',
                text: 'Bugün bu oyunda enerjiyi zaten topladınız. Şimdi sadece önümüzdeki günlerde becerilerinizi geliştirmek için oynayabilirsiniz',
                accept: 'Oynamaya Başla',
                cancel: 'İptal',
            },
            loading: { text: 'Oyun hazırlanıyor..' },
            gameTimer: {
                text: 'Engellerin üzerinden atlamak için dokunun. Puan kazanın ve meyveleri toplayın',
                textWebDesktop:
                    'Engellerin üzerinden atlamak için boşluk tuşuna veya farenin sol tuşuna basın. Puan kazanın ve meyveleri toplayın',
                textWebMobile:
                    'Engellerin üzerinden atlamak için dokunun. Puan kazanın ve meyveleri toplayın',
            },
            pause: {
                title: 'Gitmek mi istiyorsunuz?',
                text: 'Mevcut ilerlemeniz Enerjiye dönüştürülecek, ancak bu gün daha fazla oynayamayacaksınız',
                accept: 'Evet, ayrıl',
                cancel: 'Hayır, devam et',
            },
            win: {
                title: 'Görev Tamamlandı',
                text: 'Tebrikler! Günlük görevinizi başarıyla tamamladınız. Eğlenmek için oynamaya devam edebilirsiniz, ancak bu Enerji seviyenizi etkilemeyecektir',
                accept: 'Bitirmek',
                cancel: 'Daha Fazla Oyna',
            },
            loose: {
                title: 'Oyun Bitti',
                text: 'Günlük görevinizde başarısız oldunuz. Eğlenmek için oynamaya devam edebilirsiniz, ancak bu Enerji seviyenizi etkilemeyecektir',
                accept: 'Bitirmek',
                cancel: 'Daha Fazla Oyna',
            },
            score: 'Puanınız',
            energy: 'Enerji Geri Kazandırıldı',
            savedLives: 'Kurtarılan Hayatlar',
            fruitCollected: 'Toplanan Meyveler',
        },
        summary: {
            title: 'Oyun İstatistikleri',
            score: 'Puanınız',
            lives: 'Kurtarılan Hayatlar',
            fruitCollected: 'Toplanan Meyveler',
        },
        startPlaying: 'Oynamaya Başla',
        loadingStatuses: {
            downloading: 'Varlıkları İndirme',
            preparing: 'Dokuları Hazırlama',
            loadingGraphics: 'Grafikleri Yükleme',
            spawning: 'Oyun Nesnelerini Ortaya Çıkarma',
            loading: 'Yükleme (Uygulamayı Kapatmayın)',
        },
    },
    editNFTsScreen: {
        title: 'Oynamak İçin Evcil Hayvan Seçin',
        dragText:
            'Oyunlara katılacak evcil hayvanlar. Sırayı değiştirmek için sürükleyin',
        selectList: 'Listeden evcil hayvan seçin',
        warningMessage:
            'Sıradaki ilk evcil hayvan Sosyal görevinizde Evcil Hayvan Kimliği olarak kullanılacaktır',
        cooldownMessage:
            "NFT'niz Bekleme modunda ve oyuna katılamıyor. Bekleme modu sona erene kadar bekleyin",
        button: 'Kaydet',
        errors: {
            saveChanges: {
                title: 'Kaydedilmemiş Değişiklikler',
                text: 'Kaydedilmemiş değişiklikleriniz var, ayrılmak istediğinizden emin misiniz?',
                button1: 'Ayrılın',
                button2: 'Geri dönün ve kaydedin',
            },
        },
        loading: 'Değişiklikleri kaydediyorum..',
        success: 'NFT siparişi kaydedildi!',
    },
    statuses: {
        COMPLETED: { title: 'Tamamlandı' },
        AWAITS_VERIFICATION: { title: 'Doğrulama bekleniyor' },
        MODERATOR_VERIFICATION_REQUIRED: { title: 'Doğrulama bekleniyor' },
        FAILED: { title: 'Başarısız' },
    },
    profile: {
        title: 'Ayarlar',
        logOut: 'Çıkış Yap',
        deleteAccount: 'Hesabı Sil',
        logOutModal: {
            title: 'Şimdiden ayrılıyor musunuz?',
            description:
                'IguVerse Uygulamasını kullanmak için tekrar giriş yapmanız veya yeni bir hesap açmanız gerekecektir',
            okText: 'Evet, Oturumu Kapat',
            cancelText: 'İptal',
        },
        deleteAccountModal: {
            title: 'Hesap Silme?',
            description:
                'Hesabınızı kalıcı olarak silebilirsiniz, ancak artık giriş yapamayacağınızı ve kullanamayacağınızı unutmayın',
            okText: 'Hesabı Sil',
            inputLabel: 'Onaylama İfadesi',
            placeholder: 'Onay ifadesini girin',
            preConfirmationPhrase: 'Tip ',
            afterConfirmationPhrase: ' eylemi onaylamak için',
            success: 'Hesabınız başarıyla silindi',
            loading: 'Hesabınızı silme..',
        },
        lightTheme: 'Işık',
        darkTheme: 'Karanlık',
        menuItems: {
            admin: {
                title: 'Kullanıcıları doğrulayın',
                description: 'Kullanıcıların sosyal medyasını doğrulayın',
            },
            security: {
                title: 'Güvenlik',
                description: 'Güvenlik ayarlarınızı özelleştirin',
            },
            wallet: {
                title: 'Cüzdan',
                description: 'Cüzdan güvenlik ayarlarınızı yönetin',
            },
            socialAccounts: {
                title: 'Sosyal Hesaplar',
                description:
                    'Sosyal oyuna katılmak için sosyal medyanızı bağlayın',
            },
            assignRole: {
                title: 'Rol Atama',
                description: 'Kullanıcıya bir hesap rolü seçme ve atama',
            },
            language: {
                title: 'Dil',
                description: 'Görüntüleme dilini ayarlama',
            },
            theme: { title: 'Tema', description: 'Bir arayüz teması seçin' },
            notifications: {
                title: 'Bildirimler',
                description:
                    'Uygulamadan almak istediğiniz bildirim türlerini seçin',
            },
            support: {
                title: 'Sohbet desteği',
                description:
                    'Talebinizi bırakın ve uzmanımız size bir sohbette cevap versin',
            },
            supportEmail: {
                title: 'E-posta ile Destek',
                description: 'Yardıma ihtiyacınız olursa bize e-posta gönderin',
            },
            knowledgeBase: {
                title: 'Bilgi Bankası',
                description:
                    'Gizliliğimiz hakkında daha fazla bilgi edinmek için IguVerse uygulamasının diğer yararlı bilgilerini kontrol edin',
            },
            privacyPolicy: {
                title: 'Gizlilik Politikası',
                description:
                    'Gizlilik Politikamız hakkında daha fazla bilgi edinin',
            },
            termsOfUse: {
                title: 'Şartlar ve Koşullar',
                description:
                    'Kullanım Koşullarımız hakkında daha fazla bilgi edinin',
            },
            appVersion: {
                title: 'Uygulama sürümü',
                description: 'En yeni {{version}}',
            },
            webVersion: {
                title: 'Web Uygulaması',
                description: 'Web Uygulamasına Giriş',
            },
            accessibility: {
                title: 'Erişilebilirlik',
                description:
                    'Arayüzü tercihlerinize uyacak şekilde özelleştirin',
            },
            socialMedia: {
                title: 'Sosyal Medyamız',
                description:
                    "Takipte kalmak için IguVerse'i sosyal medyada takip edin",
            },
            adminSendPushNotification: {
                title: 'Anında Bildirim Gönder',
                description:
                    'Tüm kullanıcılara gösterilecek tek seferlik bir bildirim oluşturun',
            },
            adminReverification: {
                title: 'Reverifikasyon',
                description:
                    'Yönetici olarak, takip doğrulaması için bir sosyal hesap gönderebilirsiniz',
            },
            adminBlockUser: {
                title: 'Kullanıcıyı Engelle',
                description:
                    'IguVerse oyun kurallarını ihlal eden kullanıcının hesabını engelleyin',
            },
            adminMaintenanceMode: {
                title: 'Bakım Modu',
                description:
                    'Teknik çalışma durumunda, uygulamayı bakım moduna alın',
            },
            adminAssignWhiteList: {
                title: 'Beyaz Liste Atama',
                description:
                    "Beyaz listeyi kazanana göndermek için NFT'lerin sayısını ve sırasını seçin",
            },
        },
        languageSettings: {
            title: 'Diller',
            subtitle: 'Dil Seçiniz',
            description:
                'IguVerse uygulamasında içeriği görüntülemek için tercih edilen dili seçebilirsiniz',
            options: {
                pl: {
                    name: 'Lehçe',
                    change: 'Lehçe',
                },
                en: {
                    name: 'İngilizce',
                    change: 'İngilizce',
                },
                ru: {
                    name: 'Rusça',
                    change: 'Rusça',
                },
                uk: {
                    name: 'Ukrayna',
                    change: 'Ukrayna',
                },
                cn: {
                    name: 'Çince',
                    change: 'Çince',
                },
                id: {
                    name: 'Endonezce',
                    change: 'Endonezce',
                },
                es: {
                    name: 'İspanyolca',
                    change: 'İspanyolca',
                },
                tr: {
                    name: 'Türkçe',
                    change: 'Türkçe',
                },
            },
            switchLanguageModal: {
                title: '{{localeId}} diline geçin',
                description:
                    "IguVerse uygulamasındaki tüm içerik {{localeId}}'e geçecektir. İstediğiniz zaman değiştirebilirsiniz",
            },
        },
        notificationsSettings: {
            title: 'Bildirim',
            pushNotificationTitle: 'Anlık Bildirimler',
            emailNotificationTitle: 'E-posta Bildirimleri',
            notifications: {
                pushDailyReminder: 'Günlük Hatırlatıcıya Bas',
                pushRewardEarned: 'Kazanılan İtme Ödülü',
                pushSocialTaskCompleted: 'Push Sosyal Görevi Tamamlandı',
                pushPetLowHealth: 'Push Pet Düşük Sağlık',
                pushPetDead: 'Push Pet Öldü',
                pushMysteryLikesGame: 'The Mystery Of Likes',
                emailPetDead: 'E-posta Evcil Hayvan Öldü',
                emailSocialTaskCompleted: 'E-posta Sosyal Görevi Tamamlandı',
            },
            saved: 'Bildirim ayarları kaydedildi!',
        },
        socialAccountsSettings: {
            title: 'Sosyal Medya',
            headerTitle: 'Hesapları Bağlayın',
            headerText:
                'Sosyal görevleri tamamlayabilmek için sosyal medya hesabınızı bağlayın. Bilgi Tabanımızda hesap gereksinimleri hakkında daha fazla bilgi edinin',
            headerInfo: 'Bilgi Tabanını Görüntüle',
            alert: 'Hesabınızı bağladıktan sonra, hesabın doğrulanması için sosyal görevi tamamlamanız gerekir',
            modal: {
                title: 'Tam Doğrulama',
                text: 'Sosyal hesabınızı başarıyla bağladınız. Hesabın doğrulanması için sosyal görevi tamamlayın!',
                button: 'Görevlere Git',
            },
        },
        roles: { PLAYER: 'Oyuncu', ADMIN: 'Yönetici', MODERATOR: 'Moderatör' },
        support: {
            success: {
                title: 'Mesaj gönderildi!',
                text: 'Yakında size geri döneceğiz',
            },
            notSent: { text: 'Mesaj gönderilmedi' },
            errorOpen: {
                text: 'Mail istemci uygulaması açılırken hata oluştu',
            },
        },
        accessibilitySettings: {
            title: 'Erişilebilirlik',
            shake: 'Shaking Hakkında Geri Bildiriminizi Gönderin',
            vibration: 'Titreşim Tepkisi',
            saved: 'Erişilebilirlik ayarları kaydedildi!',
        },
        socialMediaSettings: {
            screenTitle: 'IguVerse Medya',
            communities: {
                title: 'Resmi Topluluklar',
                text: 'Evcil hayvan severlerden oluşan muhteşem topluluğumuza katılın, yardım alın ve sosyalleşin',
                socials: { discord: 'Discord', telegram: 'Telgraf' },
            },
            media: {
                title: 'Resmi Medya',
                text: 'Son dakika haberleri ve duyuruları almak için sosyal medya kanallarımızı takip edin',
                socials: {
                    twitter: 'Twitter',
                    instagram: 'Instagram',
                    youtube: 'Youtube',
                    tiktok: 'TikTok',
                    website: 'Web sitesi',
                    facebook: 'Facebook',
                },
            },
            telegram: {
                title: 'Telegram Toplulukları',
                main: 'Resmi Kanal',
                en: 'İngilizce Sohbet',
                uk: 'Ukrayna Sohbet',
                ru: 'Rus Sohbet',
                cn: 'Çince Sohbet',
                tr: 'Türkçe Sohbet',
                id: 'Endonezya Sohbeti',
                kr: 'Kore Sohbeti',
                jp: 'Japonca Sohbet',
                ab: 'Arapça Sohbet',
                in: 'Hint Sohbeti',
                pp: 'Filipinler Sohbet',
                vt: 'Vietnam Sohbet',
                bg: 'Bangladeş Sohbet',
                pl: 'Polonya Sohbeti',
                es: 'İspanyolca Sohbet',
                fr: 'French Sohbet',
                pt: 'Portekizce Sohbet',
            },
        },
        adminSendPushNotification: {
            title: 'Anında Bildirim Gönder',
            text: 'Tüm kullanıcılara gösterilecek tek seferlik bir bildirim oluşturun',
            button: 'Gönder',
            selectLanguage: {
                label: 'Dil',
                placeHolder: 'Bildirim dilini seçin',
                modalTitle: 'Dil Seçiniz',
                button: 'Kaydet',
                title: '{{amount}} Seçilen Dil',
            },
            titleInput: {
                label: 'Başlık ({{amount}} sembolden az)',
                placeHolder: 'Yeni Güncelleme!',
            },
            bodyInput: {
                label: 'Açıklama ({{amount}} sembolden daha az)',
                placeHolder: 'Gizemli kutular ile yeni güncellememizi keşfedin',
            },
            errors: { required: 'Bu alan zorunludur' },
        },
        adminReverification: {
            screenTitle: 'Reverifikasyon',
            title: 'Teyit için Gönder',
            text: 'Bir sosyal ağ seçin ve tekrar moderasyona göndermek için kullanıcının hesabını aşağıya girin',
            button: 'Gönder',
            labelSocial: 'Sosyal Medya',
            labelInput: 'Hesap Bağlantısı',
            placeHolder: 'Hesap bağlantısını girin',
            socialMediaModal: { title: 'Sosyal Medya Seçiniz' },
            checkModal: {
                title: 'Profil Ayrıntılarını Kontrol Et',
                text: 'Aşağıdaki sosyal hesaba bir göz atın ve doğru hesap olup olmadığını kontrol edin. Dikkatli olun, çünkü bu işlem geri alınamaz',
                button1: 'Teyit için Gönder',
                button2: 'Yanlış Hesap, İptal',
            },
            toastSuccess: 'Hesap teyit için gönderildi',
        },
        adminBlockUser: {
            screenTitle: 'Kullanıcıyı Engelle',
            title: 'Cüzdan Adresini Girin',
            text: 'IguVerse kurallarını ihlal eden hesaba bağlı cüzdan adresini girin',
            button: 'Blok',
            modal: {
                title: 'Kullanıcıyı Engelle?',
                text: 'Doğru kullanıcıyı engellediğinizden emin olun. Engellediğiniz kullanıcılar konusunda çok dikkatli olmalısınız. Bu eylem geri alınamaz!',
                button1: 'Gönder',
                button2: 'İptal',
            },
            toastSuccess: 'Kullanıcı başarıyla engellendi',
            toastError: 'Kullanıcı bulunamıyor',
            banReason: {
                screenTitle: 'Blok nedenini seçin',
                label: 'Blok Nedeni',
                placeHolder: 'Blok nedenini seçin',
            },
            banComment: {
                label: 'Yorum',
                placeHolder: 'Gerekirse yorum ekleyin',
            },
            error: {
                banComment: 'Yorum eklenmeli',
                banReason: 'Lütfen yasaklama nedenini seçin',
            },
        },
        adminMaintenanceMode: {
            screenTitle: 'Bakım Modu',
            on: {
                title: 'Bakım Modunu Açın',
                text: "Uygulamayı bakım moduna alabilirsiniz ve kullanıcılar uygulamaya erişemez. Kullanıcılar için kullanılabilir hale getirmek için Ayarlar'da Bakım Modunu Kapat'a tıklayın",
                button: 'Açık',
                modal: {
                    title: 'Bakım Modunu Açın mı?',
                    text: "Bakım modunu etkinleştirirseniz kullanıcılar uygulamaya erişemeyecektir. Uygulamayı tekrar kullanılabilir hale getirmek için Ayarlar'da Bakım Modunu Kapat'a tıklayın",
                    button1: 'Açık',
                    button2: 'İptal',
                },
                toastSuccess: 'Bakım Modu Açık',
            },
            off: {
                title: 'Bakım Modunu Kapatın',
                text: 'Uygulama bakım modundadır ve kullanıcılar şu anda uygulamaya erişememektedir. Teknik çalışma tamamlanır tamamlanmaz aşağıdaki düğmeye tıklayarak devre dışı bırakın. Onaylamayı unutmayın!',
                button: 'Kapat',
                modal: {
                    title: 'Bakım Modunu Kapatın mı?',
                    text: 'Teknik çalışmaların tamamlandığından ve uygulamanın düzgün çalışacağından emin olun. Uygulamayı tekrar kullanılabilir hale getirmek için aşağıdaki düğmeye tıklayın',
                    button1: 'Kapat',
                    button2: 'İptal',
                },
                toastSuccess: 'Bakım Modu Kapalı',
            },
        },
        adminAssignWhiteList: {
            screenTitle: 'Beyaz Liste Atama',
            button: 'Atama',
            title: 'Beyaz Liste Atama',
            text: "Kullanıcının cüzdan adresini girin ve NFT'lerin sırasını ve miktarını seçin",
            rank: { label: 'NFT Sıralaması', placeHolder: 'Rütbe seçin' },
            quantity: { label: 'Miktar' },
            modal: {
                screenTitle: 'Sıralama Seçiniz',
                title: 'Beyaz Liste Atayın?',
                text: 'Her şeyi dikkatlice kontrol edin: NFT Sıralaması ve NFT sayısı ile cüzdan adresi. Geri alınamayacağı için bu işlemi onaylarken kendinizden emin olmalısınız',
                button1: 'Atama',
                button2: 'İptal',
            },
            toastSuccess: 'Beyaz Liste başarıyla atandı',
            error: {
                quantity: {
                    max: 'Maksimum miktar {{quantity}}',
                    min: 'Minimum miktar {{quantity}}',
                    numbers: 'Sadece sayılar',
                },
                rank: 'Rütbe seçilmelidir',
            },
            toastError: 'Kullanıcı bulunamıyor',
        },
        adminAssignRole: {
            screenTitle: 'Rol Atama',
            button: 'Atama',
            title: 'Rol Atama',
            text: 'Kullanıcının cüzdan adresini girin ve atanacak rolü seçin',

            role: {
                label: 'Rol',
                placeHolder: 'Rol seçin',
            },
            roleModal: {
                title: 'Rol seçin',
            },
            attentionModal: {
                title: 'Rol Atama?',
                text: 'Sağlanan tüm verileri dikkatlice kontrol edin: cüzdan adresi ve rol. Bir hata yapmadığınızdan emin olun. Bu işlem geri alınamaz!',
                button1: 'Atama',
                button2: 'İptal',
            },
            error: {
                role: 'Rol seçilmelidir',
            },
            success: 'Rol başarıyla atandı',
            toastError: 'Kullanıcı bulunamıyor',
            toastSuccess: 'Rol başarıyla atandı',
        },
        walletInput: {
            label: 'Cüzdan Adresi',
            placeHolder: 'Cüzdan adresini girin',
        },
        walletInputError: 'Cüzdan adresi değil',
    },
    admin: {
        title: 'Yönetici',
        verify: {
            title: 'Kullanıcıları Doğrula',
            subtitle: 'Kullanıcı sosyal medyasını doğrulayın',
            text: 'Sosyal medya hesabı açın ve başarılı doğrulama için Evcil Hayvan Kimliğini sağlayın',
            emptyTitle: 'Artık görev yok',
            emptyText:
                'Doğrulamak için mevcut görev yok, daha sonra tekrar gelin',
            messages: {
                error: 'Yanlış Evcil Hayvan Kimliği, tekrar deneyin',
                success: 'Tebrikler! Kullanıcı doğrulandı',
                notFound: 'Kullanıcı reddedildi',
                failed: 'Hata oluştu, lütfen yöneticiye bildirin',
            },
            modalPetIdNotFound: {
                title: 'Evcil Hayvan Kimliği Bulunamadı mı?',
                text: 'Lütfen Evcil Hayvan Kimliğini dikkatlice inceleyin ve doğrulama yapamıyorsanız, doğrulama başarısızlığı için aşağıdaki nedenlerden birini seçin',
                reasons: {
                    notEnoughFollowers: {
                        title: 'Yeterli Takipçi Yok',
                        text: 'Hesabınız sosyal medyada yeterince aktif değil, açık değil ve/veya az takipçisi var',
                    },
                    petIdNotFound: {
                        title: 'Evcil Hayvan Kimliği Bulunamadı',
                        text: 'Evcil hayvan kimliği resimde görünmüyor veya gönderilmemiş',
                    },
                    petIdIncorrectPosition: {
                        title: 'Evcil Hayvan Kimliği Yanlış Konum',
                        text: 'Evcil hayvan kimliği kırpılmış veya yanlış yerleştirilmiş, böylece kodu görmek mümkün değil',
                    },
                    userNotFound: {
                        title: 'Kullanıcı Bulunamadı',
                        text: 'Gönderinin bulunduğu hesap ya silinmiş ya da yanlış bağlanmış ve kontrol edilemiyor',
                    },
                },
                button1: 'Evet, Onayla',
            },
            label: 'Evcil Hayvan Kimliği',
            placeHolder: 'Evcil Hayvan Kimliğini Girin',
            buttonVerify: 'Doğrulama',
            buttonNotFound: 'Evcil Hayvan Kimliği Bulunamadı',
            loadingVerifyUser: 'Kontrol ediyorum.',
            regexError: 'Yalnızca rakamlara ve A-Z karakterlerine izin verilir',
        },
    },
    socialMediaConnect: {
        addSocialAccount: 'Sosyal Hesap Ekle',
        selectAccountToShare: 'Paylaşılacak Hesabı Seçin',
        select: 'Seçiniz',
        connect: 'Bağlan',
        disconnect: 'Bağlantıyı Kes',
        unavailable: 'Şu anda mevcut değil',
        status: {
            moderating:
                'Hesabınız eklendi ve sosyal görevi tamamlamak için Pet ID gönderdiğinizde kontrol edilecektir!',
            success:
                'Hesap moderatörlerimiz tarafından başarıyla doğrulandı. Şimdi Kazanmak için Sosyalleş görevini tamamlamak için kullanabilirsiniz',
            reject: 'Hesap moderatörlerimiz tarafından onaylanmadı. Lütfen kurallarımıza uygun olan hesabı bağlayın',
        },
        modalTerms: {
            start: 'Sosyal hesap bağlayarak şunları kabul ediyorum ',
            and: ' ve ',
            privacyPolicy: 'Gizlilik Politikası',
            termOfUse: 'Kullanım Koşulları',
        },
        connectTiktokModal: {
            title: 'TikTok Hesabını Bağlayın',
            label: 'Kullanıcı Adı',
            placeHolder: 'TikTok kullanıcı adını girin',
            button: 'Bağlan',
            errors: {
                notExist:
                    'Bu hesap mevcut değil. Lütfen geçerli TikTok kullanıcı adını girin',
                somethingWrong: 'Bir şeyler ters gitti, lütfen tekrar deneyin',
                likeFollowers:
                    'Hesabınızda yeterli etkinlik yok. Yalnızca canlı hesap bağlanabilir',
                cannotLoad:
                    'Kullanıcı hesabı yüklenemiyor. Lütfen tekrar deneyin',
                alreadyLinked:
                    'Sağlanan kullanıcı adı zaten başka bir kullanıcı tarafından kullanılıyor',
                notLinked: 'Hesabın bağlantısı zaten kaldırılmış',
            },
        },
        socialPreview: {
            checkProfile: 'Profilinizi Kontrol Edin',
            takeALook:
                'Aşağıdaki sosyal medya hesabına bir göz atın ve\n' +
                '            bu hesabın size ait olup olmadığını kontrol edin',
            view: 'Görünüm',
        },
        connectInstagramModal: {
            title: 'Instagram Hesabını Bağlayın',
            label: 'Kullanıcı Adı',
            placeHolder: 'Hesap bağlantısını girin',
            addAccount: 'Benim, Hesap Ekle',
            cancel: 'Ben değilim, iptal',
            button: 'Bağlan',
            errors: {
                somethingWrong: 'Bir şeyler ters gitti, lütfen tekrar deneyin',
                alreadyLinked:
                    'Sağlanan kullanıcı adı zaten başka bir kullanıcı tarafından kullanılıyor',
            },
            viaInstagram: 'veya Instagram üzerinden giriş yapın',
        },
        connectTwitterModal: {
            title: 'Twitter Hesabını Bağlayın',
            label: 'Kullanıcı Adı',
            placeHolder: 'Twitter kullanıcı adını girin',
            button: 'Bağlan',
            errors: {
                notExist:
                    'Bu hesap mevcut değil. Lütfen geçerli bir Twitter kullanıcı adı girin',
                alreadyLinked:
                    'Sağlanan kullanıcı adı zaten başka bir kullanıcı tarafından kullanılıyor',
                somethingWrong: 'Bir şeyler ters gitti, lütfen tekrar deneyin',
            },
        },
        connectFacebookModal: {
            title: 'Facebook Hesabınızı Bağlayın',
            label: 'Kullanıcı Adı',
            placeHolder: 'Facebook kullanıcı adını girin',
            button: 'Bağlan',
            errors: {
                notExist:
                    'Bu hesap mevcut değil. Lütfen geçerli bir Facebook kullanıcı adı girin',
                alreadyLinked:
                    'Sağlanan kullanıcı adı zaten başka bir kullanıcı tarafından kullanılıyor',
                somethingWrong: 'Bir şeyler ters gitti, lütfen tekrar deneyin',
            },
            via: 'veya Facebook üzerinden giriş yapın',
        },
        terms: {
            instagram: {
                one: 'Genel profil',
                two: 'En az 100 takipçisi olan aktif hesap',
                three: '3 aydan eski en az 5 gönderi',
            },
            tikTok: {
                one: 'En az 500 takipçi',
                two: 'Aktif hesap ve 3 aydan eski en az 5 video',
                three: 'Hesapta en az 500 beğeni',
            },
            twitter: {
                one: 'Genel profil',
                two: 'En az 500 takipçisi olan aktif hesap',
                three: '3 aydan eski en az 5 gönderi',
            },
            facebook: {
                one: 'Genel profil',
                two: 'En az 100 arkadaşı olan aktif hesap',
                three: '3 aydan eski en az 5 gönderi',
                four: 'Hikayeler halka açık olmalı',
            },
        },
        errors: {
            duplicate: {
                title: '{{social}} zaten başka bir hesaba bağlı',
                text: 'Sosyal medya profiliniz başka bir hesaba bağlı. Önce bağlantıyı kesin ve tekrar deneyin',
                button: 'Kapat',
            },
            disconnect: {
                title: 'Hesap Bağlantısını Kes?',
                text: 'Yeni oyun günü başladığında, sosyal görevi tamamlamak için yeni hesabınızı kullanabileceksiniz',
                button1: 'Evet, Bağlantıyı Kes',
                button2: 'Hayır, kalsın',
            },
            userNameError:
                'Yasak semboller. Yalnızca latin karakterlere, rakamlara, noktalara ve alt çizgilere izin verilir',
        },
        success: {
            linkInstagram: 'Instagram başarıyla bağlandı',
            unLinkInstagram: 'Instagram bağlantısı kesildi',
            linkTiktok: 'TikTok başarıyla bağlandı',
            unLinkTiktok: 'TikTok bağlantısı kesildi',
            linkTwitter: 'Twitter başarıyla bağlandı',
            unLinkTwitter: 'Twitter bağlantısı kesildi',
            linkFacebook: 'Facebook başarıyla bağlandı',
            unLinkFacebook: 'Facebook bağlantısı kesildi',
        },
    },
    playTasksHistory: {
        title: 'Görev Geçmişi',
        info: 'Burada görevlerinizin geçmişini ve ilerleme durumunuzu görebilirsiniz',
        historyCard: {
            SocialTask: 'Sosyal Görev',
            VerificationTask: 'Görev Bul',
            MoveTask: 'Yürüme Görevi',
            PlayTask: 'Oyun Görevi',
        },
        emptyState: {
            title: 'Henüz Görev Yok',
            text: 'Henüz hiçbir günlük görevi tamamlamadınız. Ama sorun değil, hemen şimdi yapalım',
            button: 'Oynamaya Başla',
        },
        historyTaskDetails: {
            title: 'Görev Detayları',
            text: 'Toplanan enerji, Ödül cüzdanınızda jeton ödüllerine dönüştürülecektir. Aşağıdaki görevler hakkında daha fazla ayrıntı görüntüleyin',
            collectedEnergy: '{{earnedEnergy}} / {{maxEnergy}} Toplanan Enerji',
            viewRewardWaller: 'Ödül Cüzdanında Görüntüle',
            details: {
                type: 'Tip:',
                type_SocialTask: 'Sosyal Görev',
                type_VerificationTask: 'Görev Bul',
                type_MoveTask: 'Yürüme Görevi',
                type_PlayTask: 'Oyun Görevi',
                petExp: 'Evcil Hayvan Deneyimi:',
                exp: '{{exp}} XP',
                date: 'Tarih:',
            },
        },
    },
    successTaskEnergyBlock: {
        text: 'Enerji',
        collectedEnergy: '{{earnedEnergy}} / {{maxEnergy}} Toplanan Enerji',
    },
    successTaskPetsExp: {
        text: 'Toplanan XP',
        collectedExp: '{{collectedExp}} XP',
    },
    checkout: {
        title: 'İşlemi Doğrula',
        text: 'Bilgileri iki kez kontrol edin ve işleminizi onaylayın',
        confirm: 'Onaylayın ve Satın Alın',
        try: 'Tekrar Deneyin',
        cancel: 'İptal',
        purchasingFrom: 'Ödeme Yöntemi',
        available: 'Denge',
        deposit: 'Depozito',
        wallet: '{{coin}} Cüzdan',
        loadingPurchasing:
            'İşlem tamamlanıyor, lütfen uygulamayı kapatmayın...',
        free: 'Ücretsiz',
        whiteList: 'Beyaz Liste (1)',
        explorerUrl: "BscScan'de görüntüle",
        fields: {
            transaction: 'İşlem',
            value: 'Değer',
            amount: 'Miktar',
            totalSummary: 'Toplam Özet',
            from: 'Kimden (Cüzdan)',
            to: 'Adrese',
            fee: 'Blockchain ücreti',
            modalTitle: 'Talebi Onayla',
            toWallet: 'Kime (Cüzdan)',
            gamingWallet: 'Oyun Cüzdanı',
            mainWallet: 'Ana Cüzdan',
            confirm: 'Onaylayın',
            commissionFee: 'Komisyon Ücreti',
            nft: 'NFT',
            nftWallet: 'NFT Cüzdan',
            nftMarketplace: 'NFT Pazar yeri',
        },
        errors: {
            notEnoughCoinFunds: 'Yeterli para yok. Cüzdanınıza para yatırın',
            notEnoughCoinFundsMulti:
                'Yeterli para yok. Başka bir ödeme seçeneği seçin veya cüzdanınıza para yatırın',
            bnbNotEnough:
                'Bakiyenizde gaz ücretini karşılamak için yeterli BNB yok. Lütfen cüzdanınıza BNB yatırın',
            notEnoughBalanceFunds: 'Yeterli fon yok',
            notEnoughBalanceFundsMulti:
                'Yeterli para yok. Başka bir ödeme seçeneği seçin',
            insufficientVirtualBalance: 'Sanal bakiyenizde yeterli para yok',
        },
        purchasingFromCoins: {
            coins: 'Jetonlar',
            virtual: 'E-cüzdan',
            inapp: { ios: 'Elma', android: 'Google Pay' },
        },
        storePurchase: {
            loadings: {
                PURCHASE: 'Ödeme tamamlanıyor, lütfen uygulamayı kapatmayın...',
                FINALIZE: 'İşlem tamamlanıyor, lütfen uygulamayı kapatmayın...',
            },
            button: 'Tamam',
            storePurchaseError: {
                PURCHASE: {
                    title: 'Bir şeyler ters gitti',
                    message:
                        'Satın alma işlemi sırasında bir şeyler ters gitti. Lütfen tekrar deneyin\n' +
                        'Hata Kodu: {{code}}',
                },
                FINALIZE: {
                    title: 'Bir şeyler ters gitti',
                    message:
                        'İşlem sonuçlandırılırken bir şeyler ters gitti. Lütfen tekrar deneyin',
                },
            },
        },
    },
    charity: {
        title: 'Hayırseverlik',
        description:
            'IguVerse kullanıcıları günlük gelirlerinden önceden seçilmiş bir Yardım kuruluşuna bağışta bulunurlar',
        current: 'Benim Seçimim',
        dailyDonation: 'Ödüllerinizden Günlük Bağışlar',
        howItWorks: 'Nasıl Çalışır?',
        selectedOrganization: 'Seçilmiş Organizasyon',
        edit: 'Düzenle',
        organizations: 'Organizasyonlar',
        viewAll: 'Tümünü Görüntüle',
        donated: 'Bağışlandı',
        buttonSave: 'Kaydet',
        loadingPercentage: 'İşlem.',
        saveSuccess: 'Günlük bağış yüzdesi değiştirildi',
        organizationsTitle: 'Tüm Kuruluşlar',
        infoRows: {
            address: 'Adres',
            website: 'Web sitesi',
            email: 'E-posta',
            instagram: 'Instagram',
            twitter: 'Twitter',
        },
        readMore: 'Daha fazla bilgi edinin',
        hide: 'Gizle',
        donations: 'Bağışlar',
        totalSummary: 'Toplam Özet',
        time: {
            minuteAgo: 'dakika önce',
            minutesAgo: 'dakikalar önce',
            hourAgo: 'bir saat önce',
            hoursAgo: 'saatler önce',
            dayAgo: 'gün önce',
            daysAgo: 'günler önce',
        },
        payout: 'Yardım Ödemesi',
        noDonations: 'Henüz Bağış Yok',
        allDonations: 'Tüm Bağışlar',
        modals: {
            confirmPercentage: {
                title: 'Eyleminizi Onaylayın',
                text: 'Bağış yüzdesi kazancınızı etkileyecek ve doğrudan hayır kurumuna aktaracaktır, bağış oranınızı değiştirmek istediğinizden emin misiniz?',
            },
        },
        editOrganization: 'Organizasyon Düzenleme',
        editOrganizationNotChosen:
            'Bağış yapmak için en az bir kuruluş seçmeniz gerekir',
        loadingOrganizationChange: 'İşlem.',
        changeOrganizationSuccess: 'Kurtarılan hayır kurumu',
        organizationDetails: 'Organizasyon Detayları',
        selectDescription: 'Aşağıdaki listeden kuruluşu seçin',
        chooseOrganization: 'Organizasyon Seçiniz',
    },
    Marketplace: {
        title: 'Pazar Yeri',
        text: 'Pazaryerindeki diğer kullanıcılara evcil hayvan satın alabilir veya satabilirsiniz',
        description: 'Çok yakında',
    },
    Feed: {
        title: 'Sosyal Besleme',
        text: 'Mevcut tüm evcil hayvanları görüntüleyebilir ve onlarla etkileşime geçebilirsiniz',
        description: 'Çok yakında',
    },
    Leaderboard: {
        [ROUTES.LEADERBOARD_DAILY_TASKS]: {
            title: 'Görev Liderleri',
            text: 'Diğer kullanıcıların ilerlemesini takip edin ve günlük görevleri yaparken onlarla yarışın',
            emptyList: {
                title: 'Görev Liderleri Henüz Kullanıcı Yok',
                text: 'Bunu söylemek üzücü, ancak henüz hiçbir kullanıcı herhangi bir görevi tamamlamadı. Ama endişelenmeyin, hızlı bir şekilde düzeltilecektir',
            },
            energy: 'Toplanan Enerji',
            task: 'Tamamlanan Görevler',
        },
        [ROUTES.LEADERBOARD_PVP_GAMES]: {
            title: 'PvP Liderleri',
            text: 'Diğer kullanıcıların ilerlemesini takip edin ve PvP oyunları oynayarak ve kazanarak rekabet edin',
            emptyList: {
                title: 'PvP Liderleri Henüz Kullanıcı Yok',
                text: 'Bunu söylemek üzücü, ancak henüz hiçbir kullanıcı herhangi bir oyunlar tamamlamadı. Ama endişelenmeyin, hızlı bir şekilde düzeltilecektir',
            },
            turnover: 'IGU Ciro',
            totalTurnover: 'IGU Toplam Ciro',
            pnl: 'PNL (kazan/kaybet)',
            games: 'Oynanan PvP Oyunları',
        },
        emptyScreen: {
            title: 'Oops!',
            text: 'Yanlış bir şey var. Ama endişelenmeyin, hemen düzelecektir. Çekmeyi dene.',
        },
    },

    playCollectedExperience: {
        screenTitle: 'Birikmiş Tecrübe',
        title: 'Evcil Hayvan Deneyimi',
        text: 'Görevi tamamladıktan sonra evcil hayvanlarınız seviye atlamak için yeni XP topladı',
    },
    playSuccessScreen: {
        button: 'Daha Fazla Görev Görüntüle',
        button2: 'Ana sayfaya dön',
        emptyStates: {
            VERIFY: {
                title: 'Tamamlanan Görevi Bul',
                text: 'Tebrikler! Bugün için Bul görevini tamamladınız. Daha fazlası için yarın tekrar gelin',
                failTitle: 'Görev Bulma Başarısız',
                failText:
                    'Bugünkü Bulma görevinde başarısız oldunuz. Daha fazlası için yarın tekrar gel',
            },
            MOVE: {
                title: 'Yürüme Görevi Tamamlandı',
                text: 'Tebrikler! Görevi tamamlamak için tüm mesafeyi yürüdünüz. Daha fazlası için yarın tekrar gelin',
                failTitle: 'Yürüme Görevi Başarısız',
                failText:
                    'Bugünkü Yürüyüş görevinde başarısız oldunuz. Yarın tekrar gelin ve daha iyisini deneyin',
            },
            SOCIAL: {
                title: 'Paylaşım Görevi Tamamlandı',
                text: 'Tebrikler! Bir fotoğraf paylaştınız ve doğrulamayı geçti. Daha fazlası için yarın tekrar gelin',
            },
            PLAY: {
                title: 'Oyun Tamamlandı',
                text: 'Tebrikler! Bugünkü oyunu tamamladınız. Yarın daha fazlası için geri gelin',
                failTitle: 'Oyun Başarısız',
                failText:
                    'Ne yazık ki oyunda başarısız oldunuz. Bir dahaki sefere daha iyi deneyin',
            },
        },
    },
    general: {
        howItWorks: 'Nasıl Çalışır',
        comingSoon: 'Çok yakında',
        comingSoonDesc: 'Bu özellik henüz hazır değil.',
        copiedToClipboard: 'Panoya Kopyalandı',
        createPet: 'Bir Evcil Hayvan Yaratın',
        next: 'Sonraki',
        or: 'veya',
        ok: 'TAMAM',
        loading: 'Yükleniyor.',
        loadMore: 'Daha Fazla Yükle',
        errors: {
            unknown: {
                title: 'Bilinmeyen hata',
                message: 'Lütfen tekrar deneyin',
            },
            error: { title: 'Hata' },
            networkRequestFailed: {
                title: 'Ağ hatası',
                message: 'Ağ isteği başarısız oldu. Tekrar deneyin',
            },
            TASK_WRONG_STATE: {
                title: 'Hata',
                message: 'Görevin süresi doldu, lütfen tekrar deneyin',
            },
            TASK_CREATE_FORBIDDEN: {
                title: 'Hata',
                message: 'Görevin süresi doldu, lütfen tekrar deneyin',
            },
            UNPREDICTABLE_GAS_LIMIT: {
                title: 'Cüzdan Sorunları',
                message:
                    "Gaz ücretleri tahmin edilemiyor, işlem gerçekleşmeyecek. Gaz ücretini karşılamak için yeterli paranız ve BNB'niz olduğundan emin olun ve ardından tekrar deneyin",
            },
            INSUFFICIENT_FUNDS: {
                title: 'Yeterli Fon Yok',
                message:
                    "İşlem ücretini karşılamak için yeterli paranız ve BNB'niz olduğundan emin olun. Cüzdanınıza kripto yatırın ve tekrar deneyin",
            },
            fileIsTooBig: {
                title: 'Dosya çok büyük',
                text: "Görüntü dosyası {{size}} MB'den az olmalıdır",
            },
            cantOpenUrl: {
                text: "Cihazınız {{url}} URL'sini açamıyor. URL'yi kopyalayın ve manuel olarak takip edin",
            },
            gameAlreadyStarted: {
                text1: 'Oyun zaten başladı',
                text2: 'Lütfen başka bir oyun seçin',
            },
            gameBanned: {
                text1: 'Bu oyunu oynamaktan men edildin',
                text2: 'Bir sonraki duyuruya kadar bekleyin',
            },
            wrongGameStatus: {
                text: 'Yanlış oyun durumu',
            },
            emptyErrorScreen: {
                title: 'Oops!',
                text: 'Yanlış bir şey var. Ama endişelenmeyin, hemen düzelecektir',
            },
            ops: {
                text1: 'Oops!',
                text2: 'Bir şeyler yanlış gidiyor :(',
            },
        },
        success: { title: 'Başarı' },
        socialLoading: 'Bağlantı..',
        cancel: 'İptal',
        back: 'Geri',
        current: 'Güncel',
        knowledgeBaseButton: 'Bilgi tabanından daha fazla bilgi edinin',
        timerTitle: 'Kalan Süre',
        hint: '{{hint}}/{{maxHints}} İpuçları',
        continue: 'Devam et',
        skip: 'Atla',
        BUTTONS: {
            mintNewNft: 'Mint Yeni NFT',
            continue: 'Devam et',
            continueLater: 'Daha Sonra Devam Edin',
            mintNft: 'NFT olarak',
            select: 'Seçiniz',
            startPlaying: 'Oynamaya Başla',
            start: 'Başlangıç',
            learnMore: 'Daha Fazla Bilgi',
            playPvpGames: 'PVP Oyunları Oyna',
            goToWallet: 'Cüzdana git',
            createNewOrder: 'Yeni Sipariş Oluştur',
            apply: 'Uygula',
            clear: 'Temizle',
            viewProfile: 'Profili Görüntüle',
            buyForWithAmount: 'Için satın al {{amount}}',
            cancel: 'İptal',
            delistNft: 'NFT liste dışı bırakılsın mı',
            delist: 'NFT liste dışı bırakılsın mı',
            viewMarketplace: 'Pazar Yerini Görüntüle',
            getStarted: 'Başlayın',
            reloadApp: 'Uygulamayı Yeniden Yükle',
            createNewGame: 'Yeni Oyun Oluştur',
            exploreMoreGames: 'Daha Fazla Oyun Keşfet',
            viewGamesHistory: 'Oyun Geçmişini Görüntüle',
            viewStatistics: 'İstatistikleri Görüntüle',
            tryAgain: 'Tekrar Deneyin',
            createGame: 'Oyun oluştur',
            topUpBalance: 'Bakiye yükleme',
            continueToNextStep: 'Sonraki Adıma Devam Et',
            continueShopping: 'Alışverişe devam',
            enableNow: 'Şuan etkin',
            maybeLater: 'Belki sonra',
            backToSettings: 'Ayarlara Geri Dön',
            turnOff: 'Kapamak',
            purchaseFor: '{{amount}} için satın alma',
            purchase: 'Satın alma',
            viewAll: 'Tümünü Görüntüle',
            view: 'Görünüm',
            purchaseMore: 'Daha Fazla Satın Alın',
            viewDetails: 'Detayları Görüntüle',
            readMore: 'Daha Fazla Oku',
            hide: 'Gizle',
            viewChart: 'Grafiği Görüntüle',
        },
        KEYS: {
            ranks: 'Rütbeler',
            price: 'Fiyat',
            chance: 'Şans',
            rank: 'Rütbe',
            sortedBy: 'Sıralama Ölçütü',
            typeOfNft: 'NFT Türü',
            totalSummary: 'Toplam Özet',
            totalSuccessfulOrders: 'Toplam Başarılı Siparişler',
            totalPurchasesSummary: 'Toplam Satın Alma Özeti',
            NFTs: "NFT'ler",
            profile: 'Profil',
            detaylar: 'Ayrıntılar',
            numberAndLevel: '{{level}} Seviye',
            numberAndHealth: '{{health}} Sağlık',
            deadByAge: 'Evcil Hayvan Yaşlıydı ve Öldü',
            numberAndDaysAge: '{{days}} Gün Yaş',
            yourNFT: "NFT'niz",
            vs: 'VS',
            opponentsNFT: "Rakibin NFT'si",
            yourPoints: 'Puanlarınız',
            opponentsPoints: 'Rakibin Puanları',
            type: 'Türü',
            gameSettings: 'Oyun ayarları',
            difficulty: 'Zorluk',
            mode: 'Mod',
            livesCount: 'Yaşam Sayısı',
            yourAccount: 'Hesabınız',
            leaderboardPlace: 'Liderlik Tablosu Yeri',
            timeLeft: 'Kalan Zaman',
            ticketsAmount: 'Bilet Miktarı',
            tickets: 'Biletler',
            winner: 'Kazanan',
            prizes: 'Ödüller',
            won: 'Kazandı',
            hash: 'Hash',
            date: 'Tarih',
            roundId: 'Yuvarlak Kimlik',
            chainResults: 'Sonuçlar',
            globalSeed: 'Küresel Tohum',
            gamesHistory: 'Oyun Tarihi',
            users: 'Kullanıcılar',
        },
        FILTERS: {
            byDate: {
                Day: 'Bugün',
                Week: 'Son 7 gün',
                Month: 'Son 30 gün',
            },
        },
        ALERTS: {
            notEnoughCoinsOnGamingWallet:
                'Oyun cüzdanınızda oyuna katılmak için yeterli jeton yok. Oynamaya başlamak için hesabınıza para yükleyin',
        },
        MERGED: {
            selectText: '{{text}} seç',
        },
        DECLINATION: {
            Ticket: {
                one: 'Bilet',
                two: 'Biletler',
                five: 'Biletler',
            },
        },
    },
    modal: {
        mintPetLeave: {
            title: 'Gitmek mi istiyorsunuz?',
            text: 'Evcil hayvanınızı yaratmayı neredeyse bitirdiniz. Şimdi pes etmeyin!',
            keep: 'Evcil Hayvanınızı Bitirin',
            leave: 'Evet, ayrıl',
        },
        ModalFreeRank: {
            title: 'Büyük Bir Bonusu Kaçırıyorsunuz!',
            text: 'Mümkün olan en yüksek rütbelerin darphanesi için {{amount}} IGUP (${{dollarValue}}) bonusunu kaçırmak istemediğinize emin misiniz?',
            highest: 'Bonusumu Alın',
            proceed: 'Bonus Olmadan İlerleyin',
        },
        askForPermissions: 'İzin İsteyin',
        goToSettings: 'Ayarlara git',
        try: 'Tekrar Deneyin',
        cancel: 'İptal',
        deletePhoto: 'NFT Fotoğrafı Silinsin mi?',
        deletePhotoInfo: 'Fotoğrafınızı silmek istediğinizden emin misiniz?',
        yesDelete: 'Evet, Sil',
        noCancel: 'Hayır, İptal',
        changeRank: 'Rütbe Değiştirmek İster misiniz?',
        changeRankInfo: 'Darphane sürecinin ilk adımına yönlendirileceksiniz',
        changeRankGo: 'Sıralamayı Değiştir',
        upgradeRank: {
            title: '"{{slug}}" Rütbesine Yükseltme',
            text: 'Bazı özelliklerin kilidi daha yüksek Rütbelerle açılır. Bu özelliğe erişmek için Rütbenizi yükseltin',
            upgradeToRank: 'Rütbe Yükseltme',
        },
        savingName:
            'İsmi kaydetmek biraz zaman alır. Lütfen uygulamayı kapatmayın',
        generatingNFT:
            'Biraz sihir yapıyorum. Genellikle birkaç dakika sürer..',
        generateNewNFT: {
            title: 'Önceki Adıma Geri Dönelim mi?',
            text: 'Geri döndürülürsünüz ve mevcut ilerlemenizi kaybedersiniz. Evcil hayvanınız benzersizdir, birebir aynısını yaratamayız',
            yesGenerate: 'Evet, Beni Geri Götür',
            noKeep: 'Hayır, burada kal',
        },
        askForCameraPermissions: {
            title: 'Kamera İçin İzin Yok',
            text: 'Bu özelliği kullanabilmek için kameraya izin vermeniz gerekir',
        },
        askForLocationPermissions: {
            title: 'Konum İçin İzin Yok',
            text: 'Bu özelliği kullanabilmek için konum izinleri vermeniz gerekir',
        },
        askForCameraRollPermissions: {
            title: 'Film Rulosu İçin İzin Yok',
            text: 'Bu özelliği kullanabilmek için Film Rulosu izinlerini vermeniz gerekir',
        },
        askForLocationPermissionsWeb: {
            title: 'Konum İçin İzin Yok',
            text: 'Bu özelliği kullanabilmek için konum izinleri vermeniz gerekir',
            additionalText: '. Ayarlara gidin ve konum için izinleri açın',
            button: 'Kapat',
        },
        nftPreview: {
            title: 'NFT Önizlemesi',
            text: 'Bu evcil hayvanınızın bir önizlemesi',
        },
        confirmation: {
            title: 'Emin misiniz?',
            text: 'Lütfen devam etmek için eyleminizi onaylayın',
            yes: 'Evet, Onayla',
            cancel: 'İptal',
        },
        modalChangeLanguage: {
            screenTitle: 'Dil Değiştir',
            button: 'Değişim',
        },
    },
    navigationBar: {
        wallet: {
            MAIN: 'Ana',
            NFT: 'NFT',
            REWARDS: 'Ödüller',
            GAMING: 'Oyun',
        },
        tasks: { active: 'Aktif', history: 'Tarih' },
        admin: { verify: 'Doğrulama', dashboard: 'Gösterge Tablosu' },
        referrals: { invites: 'Davetiyeler', all: 'Yönlendirmelerim' },
        collections: { collection: 'Koleksiyon', mystery: 'Gizemli Kutular' },
        tooltip:
            'Bu cüzdan sekmesidir. Bakiyenizi ve ödüllerinizi görmek için buraya gidin. Sekmede, jetonları çekebilir, yatırabilir, talep edebilir ve takas edebilirsiniz',
    },
    AppState: {
        GameMaintenanceState: {
            title: 'Oyun Bakımı',
            text: 'IguVerse Görevleri bakım altında ve şu anda kullanılamıyor. Rahatsızlık için özür dileriz ve yakında geri döneceğiz',
            button: 'Anladım',
        },
        FullMaintenanceState: {
            title: 'Uygulama Bakım Altında',
            text: 'IguVerse Uygulaması bakım altında ve şu anda kullanılamıyor. Rahatsızlık için özür dileriz ve yakında geri döneceğiz. Sosyal medyamızda iletişimde kalın',
        },
        GlobalErrorState: {
            title: 'Planlanmamış Bakım',
            text: 'IguVerse Uygulaması geliştirme aşamasındadır ve şu anda planlanmamış bir bakımımız var. Rahatsızlık için özür dileriz ve yakında geri döneceğiz',
            button: 'Yeniden Dene',
        },
        UpdateRequiredState: {
            title: 'Güncelleme Mevcut',
            text: "Uygulamanın bu sürümü güncel değildir, kullanmaya devam etmek için lütfen uygulamayı {{store}} Store'dan güncelleyin",
            button: 'Güncelleme',
            cancel: 'Şimdi değil',
            error: "Bağlantıyı açamıyorum, {{store}} Store'u manuel olarak açın ve en yeni sürümü indirin",
        },
        UpdateRequiredStateWeb: {
            title: 'Uygulamanın Güncellenmesi...',
            text: 'Uygulama şu anda güncellemenin ortasında, lütfen birkaç dakika içinde tekrar deneyin',
            button: 'Tekrar deneyin',
        },
        NoNetworkConnectionState: {
            title: 'Bağlantı Yok',
            text: 'Görünüşe göre internet bağlantısıyla ilgili bazı sorunlarınız var. Uygulamanın düzgün çalışması için internet gereklidir',
            button: 'Anladım',
            reconnected: 'Yeniden bağlandık!',
            reconnecting: 'Bağlantı kesildi. Yeniden bağlanılıyor.',
        },
    },
    ranks: {
        rankLongTitle: '{{rank}} Sıralama',
        level: '{{level}} LVL',
        upgradeRankButton: 'Yükseltme Sıralaması',
        upgradeText:
            'Mevcut Rütbenizdeki tüm Seviyelere ulaştınız. {{rank}} yükseltmenin ve performansınızı artırmanın zamanı geldi',
        lockedText:
            '{{rank}} Rütbesi darphane için mevcut değildir. Seviye atlayarak ve oyunda ilerleyerek elde edebilirsiniz',
        perDay: 'Günlük',
        dailyUnlock: 'Günlük Kilit Açma',
        foodConsumption: 'Günlük Tüketim',
        maxAge: 'Max. Yaş',
        days: 'Günler',
        list: {
            free: {
                title: 'Ücretsiz',
                infoText:
                    "Ücretsiz Derece, size uygulamayı ve işlevlerini keşfetme fırsatı verecektir. Ancak, NFT'nizi satın almadan veya sıralamanızı yükseltmeden ödülleri talep edemez veya geri çekemezsiniz",
            },
            starter: { title: 'Başlangıç' },
            common: { title: 'Ortak' },
            uncommon: { title: 'Yaygın olmayan' },
            unusual: { title: 'Olağandışı' },
            rare: { title: 'Nadir' },
            mystical: { title: 'Mistik' },
            legendary: { title: 'Efsanevi' },
            epic: { title: 'Destansı' },
            exotic: { title: 'Egzotik' },
            royal: { title: 'Kraliyet' },
            diamond: { title: 'Elmas' },
        },
        ranksDetailedInfoScreen: { button: 'NFT olarak', current: 'Güncel' },
        rankDetailedInfo: {
            reward: {
                title: 'Günlük Ödül ≈ {{reward}} ≈ {{usd}}',
                text: 'Tüm günlük görevler tamamlanırsa jeton cinsinden tahmini günlük ödül',
                warning:
                    'Bu değer sadece evcil hayvanın kazanç kapasitesinin bir tahminidir ve değişiklik gösterebilir',
                warningFree:
                    'Serbest rütbenin oyunda ödül kazanmak için rastgele bir şansı vardır. Serbest rütbe için garantili ödüller yoktur',
            },
            rate: {
                title: 'Günlük Kilit Açma Oranı ≈ {{reward}} ({{rate}}) ≈ {{usd}}',
                text: "Mevcut VIGUP ödüllerinizin %1'ini ana cüzdanınıza aktarabilirsiniz. Bir kez talep edildikten sonra jeton değiştirilebilir, farklı bir cüzdana gönderilebilir veya geri çekilebilir",
                alert: 'VIGUP jetonlarının geri kalanı beklemede ve Kilitli Cüzdanda saklanacak',
            },
            consumption: {
                title: 'Gıda Tüketimi = {{consumption}}',
                text: 'Evcil hayvanınız her gün jeton tüketir. Evcil hayvan zamanında beslenmezse sağlığını kaybeder ve ölebilir',
            },
            age: {
                title: 'Maksimum Yaş = {{maxAge}} Gün',
                text: "NFT'niz bu yaşa geldiğinde ölecek ve restore edilmesi gerekecektir",
                alert: "Bir Rütbe Yükseltme, NFT'nizin yaşını 0'a sıfırlayacak ve yükseltilen sanal evcil hayvan, yeni Rütbenin yaş sınırına göre yaşayacaktır. NFT'yi geri yükledikten sonra Seviye 1'den başlayacaksınız",
            },
        },
        modalWhatIsRank: {
            title: 'Rütbe nedir?',
            text: 'Rütbe, evcil hayvanınızın kazanma kapasitesini ve Günlük Kilit Açma Oranı ve Evcil Hayvan Tüketim Oranı gibi diğer önemli özellikleri etkiler. Rütbe ne kadar yüksekse o kadar iyi özellikler',
            buttonAvailable: 'Mevcut Rütbeleri Görüntüle',
            buttonAll: 'Tüm Rütbeleri Görüntüle',
        },
        checkoutUpgradeRank: {
            title: 'Yükseltme Sıralaması',
            text: 'Rütbe yükseldikçe, evcil hayvanınız daha fazla ödül kazanacaktır',
            upgradeTo: 'Yükseltme',
            transaction: `"{{name}}" NFT için Sıralamayı {{rank}}'e Yükseltme`,
        },
        successUpgradeRank: {
            title: 'Rütbe Yükseltildi!',
            text: "NFT'nin rütbesi başarıyla yükseltildi. Günlük görevleri oynayın ve daha fazla ödül kazanın",
            backToPet: 'Evcil hayvan görüntüle',
        },
    },
    localNotifications: {
        moveToEarnFinished: {
            title: 'Yürüme görevi tamamlandı',
            message: 'Uygulamayı açın ve ne kadar Enerji topladığınızı görün',
        },
        noPets: {
            title: 'Evcil hayvanınızı almak için acele edin',
            message:
                "İlk evcil hayvanınızı alın ve IguVerse'deki muhteşem yolculuğunuza başlayın",
        },
    },
    monthPicker: {
        month1: 'Ocak',
        month2: 'Şubat',
        month3: 'Mart',
        month4: 'Nisan',
        month5: 'Mayıs',
        month6: 'Haziran',
        month7: 'Temmuz',
        month8: 'Ağustos',
        month9: 'Eylül',
        month10: 'Ekim',
        month11: 'Kasım',
        month12: 'Aralık',
        selectMonth: 'Seçiniz',
    },
    staking: {
        stakeLoading: 'Artırma etkinleştiriliyor, uygulamayı kapatmayın...',
        unStakeLoading: 'Artırmayı kaldırıyor, uygulamayı kapatmayın...',
        general: {
            dailyBoost: 'Günlük Takviye',
            ended: 'Bitti',
            summary: 'Toplam',
            days: '{{days}} Gün',
            current: 'Mevcut Artırma',
        },
        plans: {
            title: 'Opsiyon Detayları',
            text: 'Her artırma opsiyon kilit süresini ve bonusu belirler',
            days: ' Günler',
            boost: '{{boost}}% kadar artırma',
        },
        welcomeScreen: {
            title: 'Artırma',
            headerTitleStart: 'Kazanmak ',
            headerTitleCenter: '{{number}}% kadar',
            headerTitleEnd: ' ile Artırma',
            headerText:
                'Belirli bir süre boyunca jetonlarınızı kilitleyerek oyun içi ödüllerinizi artırabilirsiniz',
            stake: {
                title: 'Artırma Seçenekleri',
                text: 'Ödül artışı veya faiz için IGU ve IGUP jetonlarınızı yatırım yapıldı edin',
            },
            lock: {
                title: 'Kilit Dönemi',
                text: 'Jetonlarınız için bir artırma seçeneği belirleyin. Aynı anda birden fazla artırma seçeneği kullanabilirsiniz',
            },
            calculation: {
                title: 'Güçlendirme Hesaplaması',
                text: 'Artırma her gün günlük ödüllerinize bağlı olarak yeniden hesaplanır',
                alert: 'Ödülleriniz değiştiyse, destek de değişecektir. Mevcut desteği her zaman görebileceksiniz',
            },
            button: 'Artırmayı Etkinleştir',
        },
        optionsScreen: {
            toastAlready: 'Artırma seçeneği zaten aktif',
            button: 'Devam et',
            screenTitle: 'Artırma Seçeneği',
            title: 'Artırma Seçeneği Seçin',
            text: 'Jetonlarınız için bir artırma seçeneği seçin. Aynı anda birden fazla artırma seçeneği kullanabilirsiniz',
            IGUP: {
                title: 'IGUP ile Artır',
                text: "IGUP'ınızı belirli bir süre için kilitleyin ve günlük ödüllerinizde bir artış elde edin!",
            },
        },
        plansScreen: {
            button: 'Devam et',
            selectPlan: 'Opsiyon Seçiniz',
            title: 'Artırma Seçeneği Seçin',
            headerTitle: 'Opsiyon Seçiniz',
            headerText:
                'Seçtiğiniz miktar, dönem sonuna kadar akıllı sözleşmede kilitlenecektir. Aynı anda yalnızca bir artırma seçeneği edilebilir',
            headerInfoText: 'Hangi Planı Seçmelisiniz?',
            lock: {
                title: 'Kilit Süresi = {{days}} Gün',
                description:
                    'Kilit süresi, jetonlarınızın kilitleneceği ve bonusun aktif olacağı süredir',
            },
            boost: {
                title: 'Boost = ~{{boost}} %',
                description:
                    'Rewards Boost, oyun içi ödüllerinizi belirli bir yüzde oranında artıran bir değiştiricidir',
            },
            calculation: {
                title: 'Boost = ~{{boost}} %',
                description:
                    'Artırma her gün ödüllerinize göre yeniden hesaplanır',
                alert: 'Ödülleriniz değiştiyse, destek de değişecektir. Mevcut desteği her zaman görebileceksiniz',
            },
        },
        coinsInputScreen: {
            title: 'Jeton Miktarını Seçin',
            button: 'Günlük Takviyeyi Hesaplayın',
            button2: 'Adım Atla',
            loading: 'Günlük artış hesaplanıyor...',
            available: 'Mevcut: ',
            maxButton: 'Maksimum',
            errors: {
                digits: 'Yalnızca rakamlar olmalıdır',
                max: 'Bakiyenizde yeterli jeton yok. Lütfen başka bir miktar girin veya para yatırın',
                min: 'Toplam en az {{limit}} {{coin}} olmalıdır',
                maxStack: 'Toplam en fazla {{limit}} {{coin}} olmalıdır',
            },
            maxBoost: 'Artış Almak İçin {{amount}} {{coin}} Bahis Yapın',
            maxBoostModal: {
                title: 'Güçlendirmenizi maksimuma çıkarın',
                text: 'Önerilen tutarı kilitleyin ve bu seçenekte mümkün olan maksimum artırmayı alın!',
                button: 'Madeni Para Ekle',
                deposit: {
                    title: 'Optimal Mevduat = {{amount}} {{coin}}',
                    text: 'En yüksek verim için en uygun token sayısı. Değer, evcil hayvan sayısına ve özelliklerine bağlıdır',
                },
                boost: {
                    title: 'Maksimum Günlük Artış = {{boost}}',
                    text: 'Optimum depozito yatırıldıktan sonra günlük destek. Destek, evcil hayvanlarınızın istatistiklerine bağlı olarak her gün yeniden hesaplanacaktır. Gerekirse her zaman jeton ekleyebilirsiniz!',
                },
            },
        },
        dailyBoostScreen: {
            title: 'Günlük Takviye',
            headerTitle: 'Daily Boost = ',
            headerText:
                'Artırma, seçenek kilitleme süresi boyunca aktif olacak, daha sonra jetonlar talep edilebilir hale gelecek',
            button: 'Onayla',
            confirmationModal: {
                title: 'Onayla',
                keys: {
                    from: 'Kimden',
                    duration: 'Süre',
                    endingOn: 'Sona Eriyor',
                    dailyBoost: 'Günlük Takviye',
                    summary: 'Miktar',
                },
                values: {
                    from: 'Ana Cüzdan',
                    duration: '{{plan}}, {{days}} Gün',
                },
            },
        },
        successScreen: {
            title: 'Başarıyla Bahislenen Jetonlar',
            text: 'Jetonlarınız yatırım yapıldı edilir ve planın sonuna kadar tutulur. Planın bitiminden sonra, jetonları cüzdanınıza geri bırakmak için "Jetonları Alın" düğmesini kullanmanız gerekir',
            button: 'Cüzdana Geri Dön',
        },
        successUnStakeScreen: {
            title: 'Jetonlar Kazıksız',
            text: "Token'ları başarıyla geri aldınız. Jetonlar Ana Cüzdanınıza iade edilir",
            button: 'Cüzdana Geri Dön',
        },
        alreadyScreen: {
            title: 'Artırma',
            headerTitle: 'Plan Detayları',
            headerText:
                'Jetonlarınızı yatırım yapıldı ettiniz ve planın sonuna kadar tutulacaktır. Planın bitiminden sonra, jetonlar Ana cüzdana bırakılabilir',
            headerInfoText: 'Nasıl Çalışır?',
            confirmationModal: {
                title: 'İşlemi onaylayın',
                keys: {
                    from: 'Cüzdana',
                    duration: 'Süre',
                    endingOn: 'Bitti',
                    dailyBoost: 'Günlük Takviye',
                    summary: 'Toplam Özet',
                },
                values: {
                    from: 'Ödül Cüzdanı',
                    duration: '{{plan}}, {{days}} Gün',
                },
            },
            staked: {
                title: '{{coin}} Artırma',
                text: 'Aktif plan. Daha fazla jeton ekleyebilirsiniz',
                timerTitle: 'Kalan Süre',
                staking: 'Artırma:',
                deposit: 'Yatırıldı:',
                end: 'Bitti:',
                boost: 'Daily Boost:',
                summary: 'Özet:',
                buttonAdd: 'Daha Fazla Jeton Ekleyin',
                buttonUpgrade: 'Yükseltme Planı',
                buttonUnstake: 'Jetonları Alın',
                modalAddCoins: {
                    title: 'Daha Fazla Jeton Ekleyelim mi?',
                    text: 'Jeton ekledikten sonra, artırma seçeneğiniz yatırdığınız tutara ve zamanlayıcı yeniden başlayacak şekilde yeniden hesaplanacaktır',
                    button1: 'Jeton Ekle',
                    button2: 'İptal',
                },
                modalUpgrade: {
                    title: 'Yükseltme Planı?',
                    text: 'Artırma seçeneğinizi yükselttikten sonra, yatırdığınız tutara ve zamanlayıcı yeniden başlayacak şekilde yeniden hesaplanacaktır',
                    button1: 'Yükseltme',
                    button2: 'İptal',
                },
            },
        },
    },
    timer: {
        captions: { day: 'Günler', hour: 'Saatler', min: 'Min', sec: 'Sec' },
        newDay: 'Yeni gün',
        refreshed: 'Görevleriniz yenilendi',
    },
    referrals: {
        myReferrer: 'Bu kullanıcı tarafından davet edildiniz',
        referralCode: 'Sizin Ref. Kodunuz',
        referralLink: 'Ref. Bağlantınız',
        header: {
            title: 'Yeni Kullanıcıları Davet Et',
            text: 'Diğer kullanıcıları davet edin ve tavsiye programımızla daha da fazla kazanın. Nasıl çalıştığını aşağıda görebilirsiniz',
            infoText: 'Nasıl Çalışır?',
        },
        direct: {
            title: 'Doğrudan Yönlendirme - {{directPercentage}}',
            text: "Arkadaşlarınız tarafından kazanılan tüm ödüllerin {{directPercentage}}'ini alacaksınız",
        },
        indirect: {
            title: 'Dolaylı Yönlendirme - {{inDirectPercentage}}',
            text: "Arkadaşlarınızın arkadaşları tarafından kazanılan tüm ödüllerin {{inDirectPercentage}}'ini alacaksınız",
        },
        gaming: {
            title: 'Bonusları Alın',
            text: 'Tavsiye bonusları hem PvP oyunları hem de oyun görevleri için aktiftir',
        },
        buttonShare: 'Kullanıcıları Davet Et',
        invitedReferrals: {
            card: {
                direct: 'Doğrudan Yönlendirmeler',
                indirect: 'Dolaylı Yönlendirmeler',
                active: 'Aktif Yönlendirmeler (Doğrudan)',
                turnover: 'Toplam Ciro',
            },
            viewReward: 'Ödülleri Görüntüle',
            indirectModal: {
                title: 'Dolaylı Yönlendirme',
                text: 'Bu kullanıcı arkadaşlarınızdan biri tarafından davet edildi',
            },
            header: {
                title: 'Davetli Yönlendirmeler',
                text: 'Burada tüm davet edilen yönlendirmeleri ve tüm şartları yerine getirdiyseniz günlük desteğinizi görebilirsiniz',
                infoText: 'Daily Boost Nasıl Çalışır?',
                list: 'Yönlendirmeler',
                sort: 'Sıralama Ölçütü',
                filter: { CreatedAt: 'En son', UserEnergy: 'Enerji' },
            },
        },
        emptyScreen: {
            title: 'Oops!',
            text: 'Yanlış bir şey var. Ama endişelenmeyin, hemen düzelecektir. Çekmeyi dene.',
        },
        emptyList: {
            title: ' Henüz Davet Edilen Yönlendirme Yok',
            text: 'Henüz hiçbir kullanıcıyı davet etmediniz. Ama sorun değil, hemen şimdi yapalım',
        },
        allInvitedReferralsScreen: { title: 'Tüm Davetli Yönlendirmeler' },
        inviteUsersScreen: {
            title: 'Kullanıcı Davet Et',
            text: 'IguVerse uygulamasını indirin ve yönlendirme kodunu girin',
            myNFT: 'Evcil Hayvanım NFT',
            collectedEnergy: 'Toplanan Enerji',
            leaderBoard: 'Liderlik Tablosu Yeri',
            button: 'Paylaşım Kodu',
            download: 'IguVerse Uygulamasını İndirin',
        },
        referralCard: {
            title: 'Yönlendirme Kodunu Kullanın',
            text: 'Ek bonuslar almak için yönlendirme kodunu girin',
            button: 'Kodu Girin',
        },
        referrerModal: {
            title: 'Yönlendirme Kodu',
            text: 'Yönlendirme kodunu girin ve farklı indirimler ve bonuslar alacaksınız',
            label: 'Yönlendirme Kodu',
            placeHolder: 'Yönlendirme kodunu girin',
            noCode: 'Kodunuz yok mu? ',
            apply: 'Yönlendirmeler hakkında daha fazlasını okuyun',
            button: 'Yönlendirme Kodunu Gönder',
            success: {
                toastSuccess: {
                    title: 'Yönlendirme kodu gönderildi',
                    text: 'Artık tüm işlevler sizin için kullanılabilir',
                },
            },
            error: {
                empty: 'Yönlendirme kodu boş olamaz',
                incorrectCode:
                    'Yanlış Kod. Yönlendirme kodu mevcut değil veya süresi dolmuş',
                toastError: {
                    title: 'Yanlış Kod',
                    text: 'Yönlendirme kodu mevcut değil veya süresi dolmuş',
                },
                forbidden: 'Bu cihazda yönlendirme kodu kullanılamıyor',
                toastForbidden: {
                    title: 'Yasak',
                    text: 'Bu cihazda yönlendirme kodu kullanılamıyor',
                },
                toastAlreadyLinked: {
                    title: 'Zaten kullanılmış',
                    text: 'Hesabınız zaten kullanılıyor Yönlendirme kodu',
                },
            },
        },
        boostCards: {
            cardTitle: 'Günlük Artış = {{boost}}',
            cardText: 'Davet etmeniz gerekiyor ',
            users: ' Kullanıcılar',
            text: 'Ne kadar çok kullanıcı davet ederseniz, o kadar çok günlük destek alırsınız',
            button: 'Ödülleri Görüntüle',
        },
        howBoostWorks: {
            title: 'Günlük Ödülleri Artırın',
            text: 'Kullanıcıları davet edin ve tam yönlendirme sayısına ulaştıktan sonra günlük ödüllere destek alın. Ulaştığınızda destek otomatik olarak uygulanacaktır',
            alert: 'Boost her gün yeniden hesaplanır ve yalnızca her gün oynayan ve {{rewardEnergyThreshold}} Enerji elde eden aktif yönlendirmeler için geçerlidir',
        },
        modalReferee: {
            title: 'Yönlendirdiğiniz kişiyle tanışın',
            text: 'Yönlendirdiğiniz kişi hakkında daha fazla bilgi edinmek veya onu tanımak için davet edilen kullanıcının sosyal medyasını ziyaret edebilirsiniz',
            energy: 'Toplanan Enerji (24 saat)',
        },
    },
    aiQuoteInfo: {
        alertCard: {
            overload: { title: 'Sistem Aşırı Yüklendi' },
            dailyAttempts: { title: '{{attempts}} Kalan Girişimler' },
        },
        modalInfo: {
            title: 'Hayal Gücünüzden NFT',
            text: 'AI teknolojisini kullanarak NFT oluşturabilirsiniz ancak bu işlem çok maliyetlidir. Bazen yüksek yük nedeniyle geçici olarak kullanılamayabilir',
            daily: 'Son 24 saat Kullanım = ',
            dailyText:
                'Yapay zeka teknolojisini kullanarak 24 saat boyunca en fazla {{amount}} benzersiz evcil hayvan üretebilirsiniz',
            systemLoad: 'Sistem Yükü = {{load}}',
            systemLoadText:
                'Bazen büyük talep nedeniyle sistem aşırı yüklenmiş olabilir. Biraz beklemeniz gerekecek',
            load: {
                low: 'Düşük',
                medium: 'Orta',
                high: 'Yüksek',
                overloaded: 'Aşırı yüklenmiş',
            },
            systemUsage: 'Sistem Kullanımı = {{percentage}}',
            systemUsageText:
                'Sistem Beta sürümündedir ve şu anda günde sadece belirli miktarlarda kullanılabilir',
        },
        modalErrorNoMints: {
            title: 'Nane Kalmadı',
            text: 'Bugün için tüm darphanelerin harcandığını bildirmekten üzüntü duyuyoruz. Ancak endişelenmeyin, yarın AI teknolojisini kullanarak NFT basmayı deneyebilirsiniz',
            button1: 'Fotoğraftan Nane',
        },
        modalErrorOverLoad: {
            title: 'Sistem Aşırı Yüklendi',
            text: "AI mint'in şu anda diğer kullanıcılar tarafından aşırı yüklendiğini bildirmekten üzüntü duyuyoruz. Kullanılabilir olduğunda size haber vereceğiz",
            button1: 'Fotoğraftan Nane',
        },
    },
    howTo: {
        fee: {
            stepOne: {
                title: 'Blockchain Ücreti Yaklaşıktır',
                text: 'Uygulamadaki tüm işlemler blok zincirinde gerçekleşir ve BNB cinsinden bir komisyon ücreti vardır. Ücret tutarı yalnızca işlemin gerçekleştirildiği anda bilinebilir ve size yalnızca tahmini bir tutar gösteriyoruz',
            },
            stepTwo: {
                title: 'Jetonlar İçin Daha Yüksek Ücret',
                text: 'Blok zincirinde, belirli bir işlemi gerçekleştirmeden önce token kullanımını onaylamanız gerekir. BNB ile ödeme yapmak yalnızca bir işlem gerektirirken, diğer tokenleri harcamak iki işlem gerektirir: onay ve uygulama',
            },
        },
        charity: {
            stepOne: {
                title: 'Hayvan Organizasyonlarına Yardım Edin',
                text: 'Listeden yardım kuruluşlarını seçebilir ve dünyanın dört bir yanındaki hayvanlara yardım etmek için bağışta bulunabilirsiniz',
            },
            stepTwo: {
                title: 'Tercih Edilebilir Yüzdeyi Ayarla',
                text: "Ödüllerden bağışlanacak yüzdeyi seçebilirsiniz (%1'den %100'e kadar). Ayrıca bu değeri istediğiniz zaman değiştirebilirsiniz",
            },
        },
        play: {
            button: 'Oynamaya Başla',
            stepOne: {
                title: 'Görevleri Tamamlamak için Evcil Hayvanları Seçin',
                text: 'Aşağıdaki bölümden oyuna katılacak evcil hayvanları seçin. Sıralamadaki ilk evcil hayvan Sosyal görevde kullanılacak ve ana Evcil Hayvanınız olarak görüntülenecektir.',
            },
            stepTwo: {
                title: 'Enerji Yenileme',
                text: "Gün bitmeden önce görevleri tamamlayarak Enerji seviyenizi yenilemek için 24 saatiniz var. 100 Enerji, evcil hayvan istatistiklerine göre mümkün olan maksimum ödüllerinizden %100 kazanacağınız anlamına gelir. Her gün zamanlayıcı 00:00'a ulaştığında, Enerji seviyesi sıfırlanır",
            },
            stepThree: {
                title: 'Ödüller Kazanın',
                text: 'Görevleri tamamladıktan sonra Enerjiniz evcil hayvanınızın özelliklerine göre Ödüllere dönüştürülecektir',
            },
            stepFour: {
                title: "NFT'lerinizi artırın",
                text: 'Evcil hayvanlarınızın seviyesini yükseltin, yeni evcil hayvanlar edinin, daha fazla avantajdan yararlanmak için rütbeleri yükseltin. Liderlik Tablosunda en yüksek konuma ulaşın ve daha fazla ödülün tadını çıkarın',
            },
        },
        referrals: {
            button: 'Kullanıcıları Davet Et',
            stepOne: {
                title: 'Tavsiye Kodunuzu Paylaşın',
                text: 'Kullanıcıları IguVerse uygulamasına davet edin ve oyunlarından kazanın. Doğrudan yönlendirmeler için - {{direct}}% ve dolaylı yönlendirmeler için - {{inDirect}}% alacaksınız',
            },
            stepTwo: {
                title: 'Günlük Görevlere Hız Kazandırın',
                text: 'Kullanıcıları davet edin ve tam davet sayısına ulaştıktan sonra günlük görevlerde destek alın. "Tavsiyelerim" sekmesinde daha fazla ayrıntı bulabilirsiniz',
            },
            stepThree: {
                title: 'Daha Fazla İndirim Alın',
                text: `"Oynanacak NFT" bloğunda oyun oynamak için en az bir NFT seçin. İlk NFT'nin en fazla seviye deneyimini toplayacağını unutmayın`,
            },
            stepFour: {
                title: 'Oyun Bonusları Alın',
                text: 'Kazanılan her oyun ve her kontör için, doğrudan tavsiyeler size toplamın {{direct}}%, dolaylı tavsiyeler ise {{inDirect}}% verecektir',
            },
        },
        availableRewards: {
            stepOne: {
                titleOne: 'Ödüllerinizin ',
                titleTwo: "'ini Talep Edin",
                text: "Mevcut VIGUP ödüllerinizin %1'ini ana cüzdanınıza aktarabilirsiniz. Bir kez talep edildikten sonra jeton değiştirilebilir, farklı bir cüzdana gönderilebilir veya geri çekilebilir",
            },
            stepTwo: {
                title: 'Talep İşlemi',
                text: 'Talep, size VIGUP bakiyenizi IGUP ana cüzdanınıza dönüştürme hakkı veren blok zinciri işlemidir. Başarılı bir talepten sonra fonlar hemen kullanılabilir',
            },
            stepThree: {
                title: "VIGUP'u ile değiştirin ",
                text: 'Piyasa piyasaya sürüldüğünde kazanılan jetonları IGUAI jetonuyla değiştirebileceksiniz. Uygulamayı kullanarak, üst düzey çözümümüzü erken benimseyenlerden biri olursunuz',
            },
            stepFour: {
                title: 'Negatif Bakiye',
                text: 'Bazen kullanılabilir bakiyeniz negatif olabilir, bu da kilitli ödüllerinizi İyileştirme ve Seviye Atlama gibi farklı oyun içi işlemler için kullandığınız anlamına gelir. Kullanılabilir ödüllerinizin, kilitli bakiyenizin değerine kadar sıfırın altına düşmesine izin veriyoruz. Jetonlarınızın kilidi açıldığında, mevcut bakiyeniz de artacaktır',
            },
            alert: 'VIGUP jetonlarının geri kalanı beklemede ve Kilitli Cüzdanda saklanacak',
        },
        lockedRewards: {
            stepOne: {
                title: 'Kilitli Ödüller',
                text: 'Kazanılan ödüller evcil hayvanların istatistiklerine (Rütbe ve Seviye) göre kilitlenir. Kilitlenme süresini azaltmak için evcil hayvanlarınızı yükseltin',
            },
            stepTwo: {
                title: 'Kullanılabilir Ödüllere Dönüştürme',
                text: 'Kilitli ödüllerin kilidi otomatik olarak açılıyor ve kilit açıldıktan sonra Kullanılabilir Ödül bakiyesi altında mevcut olacak',
            },
            stepThree: {
                title: "VIGUP'u ile değiştirin ",
                text: 'Piyasa piyasaya sürüldüğünde kazanılan jetonları IGUAI jetonuyla değiştirebileceksiniz. Uygulamayı kullanarak, üst düzey çözümümüzü erken benimseyenlerden biri olursunuz',
            },
        },
        socializeToEarn: {
            CONFIRMED: 'Doğru',
            FAILED: 'Yanlış',
            step: {
                title: 'IguVerse Bağlantısı Eklendi',
                text: "Pet ID'yi paylaşırken her zaman Paylaşım Ekranında bulunan IguVerse uygulamasının bağlantısını ekleyin. Bağlantı, hikayenin kendisine eklenmelidir.",
            },
            stepOne: {
                title: 'Evcil Hayvan Kimliği ve Bağlantı Tamamen Görünür',
                text: 'Evcil hayvan kimliği ve bağlantı, doğrulayıcı tarafından zorlanmadan tanımlanabilir olmalıdır. Uygulamanın bağlantısı aktif olmalıdır',
            },
            stepTwo: {
                title: 'Küçük değişiklikler tamamdır',
                text: "Pet ID'nin boyutunu ve rengini ya da eğimini değiştirebilirsiniz. Doğal olarak, bu değişiklikler ilk kuralla çelişmemelidir",
            },
            stepThree: {
                title: 'Evcil hayvan kimliğini çıkarmak zor',
                text: 'Resmi veya parçalarını kırpmak ve gizlemek de dahil olmak üzere Pet ID üzerinde herhangi bir değişiklik yapılmasına izin vermiyoruz. Daha fazlasını öğrenmek için kaydırın',
            },
            stepFour: {
                title: 'Evcil hayvan kimliği kapsam dahilindedir',
                text: 'Resmin üst üste bindirilmesine veya aşırı boyanmasına ve aşırı küçültülmesine izin verilmez',
            },
        },
        verifyUser: {
            stepOne: {
                title: "Pet ID'yi sosyal medyada bulun",
                text: 'Diğer kullanıcının sosyal medya hesabını takip edin ve içeriği kontrol edin ve Evcil Hayvan Kimliğini bulun. Kodu uygulamaya yazın ve görevi tamamlayın',
            },
            stepTwo: {
                title: 'Bulunan Evcil Hayvan Kimliği Sağlayın',
                text: "Pet ID'den kodu girin veya QR kod tarayıcı kullanarak tarayın. Orada olmaması durumunda, Evcil Hayvan Bulunamadı düğmesine tıklayın. Görevi tamamlamak için tüm kullanıcıları bulun",
            },
            stepThree: {
                title: 'Sorumlu Olun',
                text: 'Adil oynayın ve yanlış kimlikler vererek veya bulamadığınızı iddia ederek sistemi yanıltarak hile yapmaya çalışmayın. Bunu yapmaya devam ederseniz hesabınız işaretlenebilir veya yasaklanabilir',
            },
        },
        purchaseBNB: {
            screenTitle: 'BNB Nasıl Satın Alınır',
            title: 'Binance üzerinden BNB satın alın',
            text: "BNB, kullandığımız blockchain olan Binance Smart Chain'de ücret ödemek için kullanılan bir kripto paradır. Oyun içi cüzdana BNB yatırma hakkında daha fazla bilgi edinmek için aşağıdaki videoyu izleyin",
            guideBlock: {
                title: 'Satın Alma ve Para Çekme Kılavuzu',
                first: 'Binance uygulamasına giriş yapın. Eğer yoksa indirin, kaydolun ve kendinizi doğrulayın',
                second: "Bir kart veya p2p hizmeti ile kripto satın alın. Hemen BNB'yi tercih edebilirsiniz!",
                third: 'Cüzdan sekmesini açın ve Para Çekme öğesine dokunun',
                fourth: 'Çekmek istediğiniz kripto para birimini seçin. Bizim durumumuzda, BNB',
                fiveStepOne:
                    'Çekmek istediğiniz adresi yapıştırın ve ağı seçin: ',
                fiveBold: 'BNB Akıllı Zincir (BEP-20)',
                fiveStepTwo:
                    '. Cüzdan adresiniz IguVerse uygulamasının cüzdan sekmesinde bulunabilir. 0x ile başlar ve harf ve rakamların bir kombinasyonudur',
                six: 'İşlemin gerçekleşmesi için birkaç saniye bekleyin ve işlem tamam!',
            },
            resourceBlock: {
                title: 'Yararlı Kaynaklar',
                buy: 'BNB (BNB) Nasıl Satın Alınır Kılavuz',
                withdraw: "Binance'ten Nasıl Para Çekilir",
                status: "Blockchain'de Kripto Para İşlem Durumu Nasıl Kontrol Edilir",
            },
        },
        petOrderId: {
            title: 'Evcil Hayvanları Düzenleyin',
            text: `"Oynanacak NFT" bölümünden Oynanabilir Karakter Evcil Hayvanlarını seçin ve diğerlerini sipariş edin! Evcil hayvanların siparişi, alacakları XP'yi belirleyecektir`,
            cardFeatureInfo: {
                title: 'Evcil Hayvan Önceliği',
                text: 'İlk Oynanabilir Karakter Evcil Hayvan, Evcil Hayvan Kimliğinizde, Evcil Hayvan oylamasında ve liderlik tablosunda sizi temsil edecektir',
            },
            button: 'Evcil Hayvanları Yeniden Sırala',
        },
        howToGamingAvailableWallet: {
            screenTitle: 'Mevcut Cüzdan',
            button: 'Tamamla',
            stepOne: {
                title: 'Rekabetçi Oyunlar Oynayın',
                text: 'Oyun cüzdanı, ödüller için diğer oyuncularla rekabet etmenize ve IGU kazanmanıza olanak tanır. Mevcut oyunları görmek için oyun sekmesini kullanın',
            },
            stepTwo: {
                title: 'Oyun Cüzdanına Para Yükleyin',
                text: 'Katılmak için oyun cüzdanınıza IGU yükleyin ve VIGU kazanın. Jeton yüklemek için aşağıdaki düğmeyi kullanın',
            },
            stepThree: {
                title: 'Ana Cüzdana Para Çekme',
                text: 'Rekabetçi oyunlarda kazanılan ödüller, oyun cüzdanında saklanacaktır. Bu ödülleri istediğiniz zaman ana cüzdanınıza çekebilirsiniz',
            },
            stepFour: {
                title: 'Yönlendirmelerden Bonus Alın',
                text: 'Kazanılan her oyun ve her kontör için, doğrudan tavsiyeler size toplamın {{direct}}%, dolaylı tavsiyeler ise {{indirect}}% verecektir',
            },
        },
        howToGamingPendingWallet: {
            screenTitle: 'Bekleyen Cüzdan',
            alert: 'Bekleyen Oyun Cüzdanındaki jetonlar IguVerse tarafından tutulmaz ve oyun süresince bir akıllı sözleşmede kilitlenir',
            stepOne: {
                title: 'Oynarken Donmuş',
                text: 'Oyun Cüzdanındaki para siz oyunu bitirene kadar dondurulacaktır. Bu önlem dolandırıcılığı önlemek için uygulanmıştır',
            },
            stepTwo: {
                title: 'Otomatik Çözme',
                text: 'Oyunu kazandıysanız paranız otomatik olarak Oyun Cüzdanına iade edilecektir. Aksi takdirde kazanana verilecektir',
            },
        },
        howToCommissionFee: {
            screenTitle: 'Komisyon Ücreti',
            stepOne: {
                title: ' Komisyon Ücreti',
                text: 'Oyun Cüzdanından her para çekme işlemi için {{commission}}% komisyon ücreti alıyoruz',
            },
            stepTwo: {
                title: 'Geliştirilmiş Tokenomik',
                text: 'PvP oyunları, çoğu GameFi projesinin ekonomilerinden üstün olan havuz ekonomik modelini takip eder. Ekonomiyi daha da güçlendirmek için komisyon ücreti kesilecek',
            },
        },
        HowToCollections: {
            stepOne: {
                title: 'Sanal Evcil Hayvan Arkadaşı',
                text: 'Yapay zekanın yardımıyla sosyal medyada kazanmanıza yardımcı olacak bir NFT evcil hayvanı oluşturun. Kendi evcil hayvanınızın fotoğrafını da yükleyebilirsiniz',
            },
            stepTwo: {
                title: 'Enerji Yenileme',
                text: "Gün bitmeden önce görevleri tamamlayarak Enerji seviyenizi yenilemek için 24 saatiniz var. 100 Enerji, evcil hayvan istatistiklerine göre mümkün olan maksimum ödüllerinizden %100 kazanacağınız anlamına gelir. Her gün zamanlayıcı 00:00'a ulaştığında, Enerji seviyesi sıfırlanır",
            },
            stepThree: {
                title: "VIGUP'u ile değiştirin ",
                text: 'Piyasa piyasaya sürüldüğünde kazanılan jetonları IGUAI jetonuyla değiştirebileceksiniz. Uygulamayı kullanarak, üst düzey çözümümüzü erken benimseyenlerden biri olursunuz',
            },
        },
    },
    energyInfoScreen: {
        title: 'Enerji Toplayın ve Jetonlarla Takas Edin',
        text: 'Enerji/IGUP değişim oranınız evcil hayvan miktarına, rütbelere, seviyelere ve güçlendirme gibi diğer değiştiricilere bağlıdır',
        button: 'Oynamaya Başla',
        features: {
            first: {
                title: '1 Enerji ≈ {{amount}} IGUP',
                text: 'Bu, farklı koşullara bağlı olarak değişebilecek yaklaşık döviz kurudur',
            },
            second: {
                title: 'Enerji eşiği = {{energy}}',
                text: 'Minimum {{energy}} Enerji puanı eşiğine ulaşamazsanız, Enerji puanlarınızın yarısı yakılır ve diğer yarısı bir sonraki güne aktarılır',
            },
        },
    },
    initial: {
        initialMint: {
            title: "İlk Evcil Hayvanınızı Yaratın ve IguVerse'teki Yolculuğunuza Başlayın",
            text: "Bu, IguVerse'deki muhteşem yolculuğunuzdan önceki son adımdır. İlk evcil hayvanınızı yaratın ve evcil hayvanınızla her gün oynamaya ve ödüller kazanmaya başlayın",
            button: 'İlk Evcil Hayvanınızı Yaratın',
        },
        initialReferral: {
            title: 'Referral Mint İndiriminin Keyfini Çıkarın!',
            text: 'Uygulamamıza davet edildiniz. IguVerse oynadığınız için indirimlerin ve bonusların tadını çıkarın. NFT evcil hayvanınızı oluşturmak için acele edin',
            button: 'Devam et',
        },
    },
    ModalShareOrSave: {
        title: 'İçeriğinizi Kaydedin',
        text: 'Favori IguVerse içeriğinizi film rulosuna kaydedin veya arkadaşlarınızla paylaşın',
        save: 'Film Rulosuna Kaydet',
        share: 'Paylaş',
        loading: 'İçerik hazırlanıyor..',
        saveSuccess: 'Film Rulosuna kaydedilen içerik',
    },
    RelatedApps: {
        downloadApp: {
            titleiOS: "Uygulama iOS'ta mevcut",
            titleAndroid: "Uygulama Android'de mevcut",
            description: 'Mobil uygulamada daha iyi deneyimin keyfini çıkarın',
            buttonOk: 'Uygulama İndir',
            buttonCancel: 'Şimdi değil',
        },
        switchToApp: {
            titleiOS: 'IOS Uygulamasına Geçin',
            titleAndroid: 'Android Uygulamasına Geçin',
            description: 'Mobil uygulamada daha iyi deneyimin keyfini çıkarın',
            buttonOk: 'Uygulamaya Geç',
            buttonCancel: 'Şimdi değil',
        },
    },
    ShareYourFeedback: {
        title: 'Geri Bildiriminizi Paylaşın',
        text: 'Geri bildiriminizi bizimle paylaşabilirsiniz ve bu formu göndererek istemci tarafı günlüklerini bize gönderirsiniz, böylece sorununuzu tanımlamamıza yardımcı olabiliriz',
        placeholder: 'Sorunlarınızı ayrıntılı olarak açıklayın',
        button: 'Gönder',
        loading: 'Gönderiyorum.',
        accessibility:
            '"Çalkalama Hakkında Geri Bildiriminizi Gönderin" özelliğini devre dışı bırakın',
    },
    ModalMainnet: {
        title: 'Özellik Kullanılamıyor',
        text: 'Bu özellik, IGU borsalarda yayınlanana kadar kullanılamayacaktır. Tam listeleme tarihi yakında duyurulacaktır',
        button: 'TAMAM',
    },
    ModalDailyRewards: {
        [DAILY_REWARD_STATUS.Bonus]: {
            title: 'PvP Bonusu Kredilendirildi',
            text: 'PvP oyunlarındaki etkinliğiniz için size doğrudan Oyun Cüzdanına yatırılan bir bonus verildi',
        },
        [DAILY_REWARD_STATUS.Daily]: {
            title: 'Cüzdanınızda Mevcut Günlük Ödül',
            text: 'Dünkü görevler için ödülleriniz geldi!',
        },
        [DAILY_REWARD_STATUS.Both]: {
            title: 'Günlük Ödül ve PvP Bonusu Aldınız',
            text: 'Günlük ödülleriniz geldi ve kilidi açılmaya başladı bile! Ayrıca PvP oyunlarını oynadığınız için bonus jetonlar aldınız',
        },
        dailyReward: {
            title: 'Mevcut Ödüller {{availableAmount}} / {{totalAmount}} IGUP',
            text: '{{availableAmount}} IGUP cüzdanınızda hemen kullanılabilir',
        },
        unlocks: {
            title: 'Kilitli Jetonlar',
            text: "{{restAmount}} IGUP'un kilidi kilit açma süresi boyunca kademeli olarak açılacaktır",
        },
    },
    MintBonusScreen: {
        mintSuccess: { title: 'Bonus Programı', text: 'Nane Bonusu' },
        BonusMintRanksDetailedInfoScreen: {
            title: 'Mint NFT - Anında IGUP Bonusu Alın',
            text: "Size NFT'yi basmanızı ve gelecekte çekebileceğiniz bir bonus almanızı öneriyoruz. Bir sonraki adıma geçin ve nane işlemini bitirin",
            button1: 'Sonraki Adıma Devam Et',
            button2: 'Tüm Bonusları Görüntüle',
            timeRemaining: 'Kalan Süre',
            features: {
                bonus: {
                    key: 'Rütbe Bonusu = {{amount}} IGUP (${{dollarValue}})',
                    value: 'Başarılı bir darphaneden sonra hesabınıza yatırılacak jetonlar',
                },
                lock: {
                    key: 'Kilit Süresi = {{days}} Gün',
                    value: 'Jetonlar kilit süresi bittikten sonra çekilebilecektir',
                },
            },
        },
        BonusMintRanksCarouselScreen: {
            screenTitle: 'Rütbe Bonusu',
            title: '{{slug}} Sıralama',
            button1: 'Sıralama Seçiniz',
            features: {
                bonus: {
                    key: 'Rütbe Bonusu = {{amount}} IGUP (${{dollarValue}})',
                    value: 'Başarılı bir darphaneden sonra hesabınıza yatırılacak jetonlar',
                },
                lock: {
                    key: 'Kilit Süresi = {{days}} Gün',
                    value: 'Jetonlar kilit süresi bittikten sonra çekilebilecektir',
                },
            },
        },
    },
    YourPetsAreHungry: {
        title: 'Evcil Hayvanlarınız Aç!',
        text: "Sağlık kaybı ödüllerinizi azaltır ve bir süre sonra NFT'lerinizi kullanılamaz hale getirebilir. Sürekli kazanmak için evcil hayvanlarınızı besleyin!",
    },
    priceUpModal: {
        title: 'Fiyat Artışı Şu Kadar ',
        text: "Yüksek talep ve projenin hızlı büyümesi nedeniyle ekibimiz, erken benimseyenleri ödüllendirmek ve ekonominin uzun vadede sürdürülebilir ve dengeli kalmasını sağlamak için NFT'lerin fiyatlarını yükseltmeye karar verdi",
        priceUpdate: 'Fiyat Artışı',
        button: 'Mint Yeni NFT',
    },
    updateModal: {
        banner: {
            title: 'Yeni Güncelleme Çıktı!',
            text: 'Uygulamanın yeni {{version}} sürümünü kontrol edin',
        },
        screen: {
            screenTitle: 'Yeni Güncelleme',
            title: 'Yeni Güncelleme Çıktı!',
            text: 'IguVerse ekibi, uygulama deneyiminizi iyileştirmek ve yeni özellikler geliştirmek için çok çalışıyor. Yeni {{version}} sürümündeki bu iyileştirmelerin keyfini çıkarın',
            button: 'Oynamaya Başla',
        },
    },
    communityModal: {
        title: 'Topluluktan Yardım Alın',
        text: 'Sorularınızı yanıtlamak ve yeni bilgiler edinmek için resmi sosyal medyamıza katılın. Kârı nasıl artıracağınızı, para çekmeyi ve çok daha fazlasını öğrenin!',
        button1: 'Sosyalleri Görüntüle',
        button2: 'Bunu Bir Daha Gösterme',
    },
    socialTooltip: {
        text: 'Hesabınızın veya Evcil Hayvan Kimliğinizin neden kriterlerimize uymadığını ve reddedildiğini öğrenmek için "Başarısız" etiketine tıklayın. Sonraki adımlarınız hakkında bilgi edinmek için Bilgi Tabanına erişeceksiniz',
    },
    gameIterationText: {
        text: 'Dünün ödülleri sayılıyor, bu işlem genellikle yaklaşık {{minutes}} dakika sürer. Bu işlem sona erdiğinde tekrar oynayabileceksiniz',
        toastErrorTitle: 'Dünün ödülleri sayılıyor',
    },
    howConnectFacebookModal: {
        info: 'Nasıl Bağlanılır',
        screenTitle: 'Facebook Nasıl Bağlanır',
        title: 'Facebook kimliğini bulma',
        text: "Facebook hesabınızı bağlamak için Facebook kimliğinizi bulup kopyalamanız gerekir. Profil sayfanızı ziyaret edin ve bağlantının /'den sonraki kısmını kopyalayın - bu sizin Facebook kimliğinizdir",
        button: 'Hesabı Bağlayın',
    },
    listingIgu: {
        iguListing: 'IGU Listesi',
        title: ' listelenmeye hazırlanıyor de ',
        textOne: '{{exchange}} borsasındaki listeleme de gerçekleşecek ',
        textTwo: '. Kemerlerinizi bağlayın İguanalar, uçuyoruz!',
        button: 'Borsa araştırması',
        listed: {
            title: ' listeleniyor ',
            text: "Uzun zamandır beklenen IGU lansmanı nihayet geldi - Space Odyssey'imizin sadece başlangıcı! Hemen şimdi {{exchange}} borsasında IGU parası alın ve ticaret yapın",
        },
    },
    bybitVote: {
        title1: "IGU'ya Oy Verin ve ",
        title2: ' Dolarlık Ödülleri Paylaşın!',
        text: "IguVerse, bir sonraki ByVit listesi için oy verebileceğiniz ByVotes'a katılmayı seçti. IGU'ya oy verin ve ödülleri kazanın!",
        banner: {
            title1: '',
            title2: "'dan başlayan fiyatlarla Oy Ver ve Kazan",
        },
        button: 'Daha fazla bilgi edin',
    },
    howToPurchaseIGU: {
        modalTitle: 'IGU Nasıl Satın Alınır',
        exchangesModalTitle: 'Borsalarda IGU Satın Al',
        cardDeposit: {
            title: 'Depozito',
            text: 'Desteklenen jetonları herhangi bir BSC BEP-20 cüzdanından yatırabilirsiniz',
        },
        cardExchange: {
            title: 'Borsalarda Satın Al',
            text: 'Listelendiği borsalarda IGU satın alın ve ticaret yapın',
        },
        cardTrade: {
            title: 'Uygulamada Ticaret',
            text: 'Doğrudan uygulamada hızlı ve kolay bir şekilde IGU ticareti yapın',
        },
    },
    howToClaimFreePet: {
        title: 'Talep Etmek İçin Bir NFT Satın Alın',
        text: 'Hesabınızda herhangi bir NFT olmadığı için ödül talebinde bulunamazsınız. Ücretsiz Evcil Hayvan, blok zincirinde olmadığı için bir NFT değildir. Bir NFT pet satın almak veya sahip olduğunuz hayvanı sıralamak, ödüllere erişmenizi sağlayacaktır',
        alert: 'Daha önce kazandığınız tüm ödüller izlenir ve bunları satın alma işleminden sonra talep edebilirsiniz',
        button: 'Mint Yeni NFT',
    },
    howToClaimOnButton: {
        titleOne: 'Ödüllerinizin ',
        titleTwo: "'ini Talep Edin",
        text: "Mevcut VIGUP ödüllerinizin %1'ini ana cüzdanınıza aktarabilirsiniz. Bir kez talep edildikten sonra jeton değiştirilebilir, farklı bir cüzdana gönderilebilir veya geri çekilebilir",
        alert: 'VIGUP jetonlarının geri kalanı beklemede ve Kilitli Cüzdanda saklanacak',
        button: 'Ödülünüzü Talep Edin',
    },
    onBoarding: {
        mainWallet: {
            title: 'Ana Cüzdan',
            stepOne: {
                title: 'Tüm Kriptolarınız Burada',
                text: 'Bu cüzdan, hesabınızda bulunan tüm desteklenen jetonları saklar. Desteklenmeyen jetonlar gösterilmez. Tüm ödülleriniz talepten sonra buraya aktarılacaktır',
            },
            stepTwo: {
                title: 'Cüzdanlar Arasında Gezin',
                text: 'Ana Cüzdan sekmesinden, hesabınızda bulunan diğer tüm cüzdanları kaydırarak açabilirsiniz. Bu cüzdanlar arasında NFT Cüzdanı, Ödül Cüzdanı ve Oyun Cüzdanı bulunur',
            },
        },
        login: {
            stepOne: {
                title: 'Kripto Kazanmanın Yeni Bir Yolu',
                text: 'Kripto belirteçleri kazanmak için günlük sosyal medya rutininizi kullanın! Görevler, çevrimiçi içerik paylaşmayı, yürümeyi ve atari oyunu oynamayı içerir',
            },
            stepTwo: {
                title: 'Sanal Evcil Hayvan Arkadaşı',
                text: 'Yapay zekanın yardımıyla sosyal medyada kazanmanıza yardımcı olacak bir NFT evcil hayvanı oluşturun. Kendi evcil hayvanınızın fotoğrafını da yükleyebilirsiniz',
            },
            stepThree: {
                title: 'Rekabetçi Oyunlar',
                text: 'Çok daha fazlasını kazanmak ister misiniz? PvP oyun modlarımızda başkalarına meydan okuyun ve büyük kazanın',
            },
            stepFour: {
                title: 'Hayvanlar için Bağışlar',
                text: "Günlük ödüllerinizin %1'i hayvan refahına gidiyor. Uygulamada bağış boyutunu artırabilirsiniz",
            },
            stepFive: {
                title: 'Gelecek Ürünler',
                text: 'Uygulama, bir serideki yalnızca ilk üründür. Yapay zeka destekli pazar yerimizin ve yayınlandıktan sonra merkezi olmayan bir reklam ağının erken uygulayıcısı olun',
            },
        },
    },
    HomeScreen: {
        MemsModal: {
            title1: "MemeFi Discord'da ",
            title2: ' İndirim: Şimdi Katılın!',
            text: "MemeFi, Discord'da bir NFT Hediye Kampanyası başlattı. Basit bir görev size $MEMF damlalı NFT'ler için Royale Biletleri kazandıracak",

            button1: "Discord'a Katılın",
            button2: 'Web Sitesini Keşfedin',
            banner: {
                title: '$450.000 Düşüş',
                text: "MemeFi, Discord'da bir NFT Hediye Kampanyası başlattı",
            },
        },
        exploreGames: 'Oyunları Keşfet',
        minimalBet: {
            title: 'Minimum Bahis = {{amount}}',
            text: 'Bir oyunda yatırabileceğiniz en küçük meblağ',
        },
        WelcomeHeader: {
            title: 'Tekrar hoşgeldiniz!',
            text: 'Her gün kripto oynayın ve kazanın',
        },
        ModalGameComingSoon: {
            title: 'Oyun Çok Yakında',
            text: 'Ekibimiz yeni PvP oyunu üzerinde çok çalışıyor ve yakında çıkacak. Kütüphanemizdeki diğer eğlenceli oyunlara göz atın!',
        },
        GamesBlock: {
            header: 'Rekabetçi Oyunlar',
            button: 'Oyun Oyna',
            buttonContinue: 'Oynamaya devam et',
            buttonComingSoon: 'Çok Yakında...',
            orders: '{{orders}} Odalar',
            games: {
                [MYSTERY_GAMES.mysteryLikes]: {
                    title: 'The Mystery of Likes',
                    text: 'Bir NFT için doğru beğeni sayısını tahmin edin',
                },

                [MYSTERY_GAMES.nftRoyal]: {
                    title: 'The Grand Race',
                    text: 'Meyvelerle dolu bir yolda zafer için yarışın',
                },
                [MYSTERY_GAMES.nftEvolution]: {
                    title: 'NFT Evolution',
                    text: "NFT'ler üretin ve daha güçlü sürümler alın",
                },
                [MYSTERY_GAMES.luckyStrike]: {
                    title: 'Lucky Strike',
                    text: 'Heyecan verici bir talih oyununda şansınızı kaçırmak ve hepsini talep etmek için biletleri kapın',
                },
                [MYSTERY_GAMES.quantumSpin]: {
                    title: 'Quantum Disk',
                    text: 'Parayı sallamak için kuantum çarkınızı döndürün',
                },
                [MYSTERY_GAMES.tokenteller]: {
                    title: 'Tokenteller',
                    text: 'Kristal kürenizi alın ve gelecekteki IGU fiyatlarını tahmin edin',
                },
                socialProof: '{{game}} PvP oyununda şu anda {{amount}} kazandı',
            },
        },
        GamesFeatures: {
            orders: 'Boş Oyun Odaları',
            prizePool: 'Toplam Ödül Havuzu',
            turnover: '{{coin}} Ciro',
            totalSlots: 'Toplam tur',
        },
        VacantRoomsEmpty: {
            title: 'Boş Oyun Yok',
            text: 'Şu an için aktif oyun isteği yok. Bir tane oluşturmak ister misin? Herhangi bir oyuncu size meydan okuyabilecek',
        },
        EmptyGameHistory: {
            title: 'Henüz Oyun Yok',
            text: 'Herhangi bir oyun oynamadınız veya yaratmadınız. Şimdi bir tane oluşturun ve rastgele bir oyuncu tarafından meydan okunun',
        },
        GamesNavigationBar: {
            ORDERS: 'Boş Odalar',
            HISTORY: 'Tarih',
            ROUNDS: 'Turlar',
            WHEEL: 'Disk',
        },
        ActiveOrdersFilters: {
            title: 'Boş Odalar',
            modalTitle: 'Göre sırala',
            Newest: 'En Yeni',
            Oldest: 'En Eski',
            Highest: 'En Yüksek Ödül',
            Lowest: 'En Düşük Ödül',
        },
        ConfirmPlayModal: {
            title: 'Bahis mi ',
            title2: 'Döndürmek için ',
            text: "Oyuna katılarak, The Pending Game Wallet'a çekilecek hisseyi onaylamış olursunuz",
        },
        GamesCreateWelcome: {
            screenTitle: '"{{game}}" İçin Düzen Yaratın',
            title: 'Diğerlerine Meydan Okuyun',
            text: 'Tercih edilen bahis miktarıyla bir oyun oluşturun ve oyunu bitirin, böylece diğer oyuncular sizin meydan okumanızı üstlenebilsin',
        },
        MaxMinimalBetFeature: {
            title: 'Minimum Bahis = {{min}}, Maksimum Bahis = {{max}}',
            text: 'Bir oyunda yatırabileceğiniz en küçük ve en büyük meblağlar',
        },
        GameTermination: {
            title: 'Otomatik Sonlandırma = {{days}} Gün',
            text: 'Başka hiçbir oyuncu size meydan okumazsa oyunun sona erdiği süre',
            alert: 'Yedi gün içinde kimse size meydan okumazsa, oyun otomatik olarak silinecek ve depozito bakiyenize iade edilecektir',
        },
        EnterCoinsAmountScreen: {
            screenTitle: 'Madeni Para Miktarını Girin',
            error: {
                max: 'Yetersiz bakiye, devam etmek için doldurun',
                maxStake:
                    'Maksimum bahis miktarı {{amount}}, lütfen bahis miktarını azaltın',
                minStake:
                    'Minimum bahis tutarı {{amount}}, lütfen hisseyi artırın',
                digits: 'Yalnızca rakamlar olmalıdır',
            },
            confirmTransaction: {
                valueType: 'The Mystery Of Likes İçin "{{game}}"',
            },
        },
        PreviousGameModal: {
            title: 'Önceki Oyunu Bitir?',
            text: 'Diğer kullanıcıların size meydan okuyabilmesi için katıldığınız oyunu tamamlayın. Oyun otomatik olarak {{days}} günler içinde sona erecek',
            button1: 'Önceki oyunu bitir',
        },
        GameHistoryScreen: {
            title: 'Tarih',
            text: 'İşte tamamladığınız oyunların geçmişi. Bunları aya göre görüntüleyebilirsiniz',
            status: {
                [MYSTERY_LIKES_STATUS.WaitingForMyself]:
                    'Senin sıranı bekliyorum',
                [MYSTERY_LIKES_STATUS.WaitingForOpponent]: 'Rakibi beklemek',
                [MYSTERY_LIKES_STATUS.Refund]: 'Oyunun süresi doldu',
            },
        },
        MysteryGamesBanner: {
            oneGame: {
                title: 'Oynamaya devam et!',
                text: '"{{game}}" oyununu bitir',
            },
            more: {
                title: 'Oynamaya devam et!',
                text: '2 tane tamamlanmamış oyun var',
            },
        },
        MysteryGamesContinueModal: {
            title: 'Oynamaya devam et',
            text: 'Oyun sonuçlarını öğrenmek için tamamlamanız gereken 2 bitmemiş oyun var',
        },
        MysteryLikes: {
            MysteryLikesHowItWorks: {
                stepOne: {
                    title: 'Beğeni Sayısını Tahmin Et',
                    text: 'Her oyun turunda diğer oyuncuya karşı {{gamesAmount}} oyun vardır. Kazanmak için rakibinizden daha fazla kez doğru tahmin edin',
                },
                stepTwo: {
                    title: 'Katılın ve Oyunlar Oluşturun',
                    text: 'Kullanıcılar katılabilir ve oyun oluşturabilir. Bir oyun oluştururken, VIGU jetonlarındaki hisseyi seçmelisiniz. Bir oyuna katılarak, oyun yaratıcısı tarafından belirtilen miktarda jeton yatırmayı kabul etmiş olursunuz',
                },
                stepThree: {
                    title: 'Hile imkansız',
                    text: "Bir NFT'nin beğeni sayısına kullanıcılar erişemez, bu nedenle hile yapmak mümkün değildir. Kötü şans felci geçiriyor gibi görünüyorsanız, öyledir. Biraz daha oynayın ve gidişat kesin olarak değişecektir",
                },
            },
            MysteryLikesCreateGameSuccess: {
                title: 'Bir Oyun Yaratıldı',
                text: 'Başarıyla bir oyun oluşturdunuz! Cevaplarınızı gelecekteki rakibinizin cevaplarıyla karşılaştırabilmemiz için lütfen turu bitirin',
                button: 'Oynamaya Başla',
            },
            MysteryLikesSelectRange: {
                title: 'Aralığı Seçin',
                text: 'Doğru sayıda beğeni içeren aralığı seçin',
                button: 'Sonraki Resme Devam Edin',
                toastError: 'Zaten Oylandı',
                buttonFinish: 'Oyunu Bitir',
                tooltip1:
                    "Bu, rakibinizin NFT'sidir. Kaç beğeni aldığını tahmin etmelisin. Beğeniler hem size hem de rakibinize görünmez",
                tooltip2:
                    'Beğeni sayısını seçmek için kartlardan birine tıklayın ve aşağıdaki buton ile bir sonraki resme geçin',
            },
            MysteryLikesSelectRangeFinish: {
                [MYSTERY_LIKES_STATUS.WaitingForOpponent]: {
                    title: 'Rakibi beklemek',
                    text: 'Oyunu tamamladınız. Şimdi size meydan okumak ve katılmak için rakibinize kalmış. Bir rakip tarafından yedi gün içinde tamamlanmazsa, oyun otomatik olarak sonlandırılır ve depozitonuz iade edilir',
                },
                [MYSTERY_LIKES_STATUS.Won]: {
                    title: 'Sen kazandın!',
                    textOne:
                        'Tebrikler! Rakibinizi geride bırakmayı başardınız. ',
                    textTwo: ' hemen cüzdanınıza aktarılacaktır',
                },
                [MYSTERY_LIKES_STATUS.Draw]: {
                    title: 'Vay be, berabere!',
                    text: 'Her ne kadar olası görünmese de, ikiniz de eşit miktarda puan kazandınız. Bahsiniz cüzdanınıza iade edildi. Bir tur daha ister misin?',
                },
                [MYSTERY_LIKES_STATUS.Lost]: {
                    title: 'Oyunu kaybettin :(',
                    text: 'Ne yazık ki, rakibiniz bu oyun turunda sizi geride bırakmayı başardı. Payınız cüzdanlarına aktarıldı. Bir dahaki sefere her zaman kazanabilirsin!',
                },

                statistics: 'İstatistikleriniz',
                alert: 'Yedi gün içinde kimse size meydan okumazsa, oyun otomatik olarak silinecek ve depozito bakiyenize iade edilecektir',
                likes: 'Beğeniler',
            },
            MysteryLikesConfirmPlay: {
                warning:
                    "Bir NFT'nin beğeni sayısına kullanıcılar erişemez, bu nedenle hile yapmak mümkün değildir",
            },
            MysteryLikesLoadingScreen: {
                prepare: {
                    title: "NFT'lerin hazırlanması",
                    text: "Rastgele bir düzen elde edebilmeniz için NFT'leri karıştırıyoruz. Beğeniler oyunculara görünmez! Lütfen biraz bekleyin ve oyundan veya uygulamadan ayrılmayın",
                },
                complete: {
                    title: 'Sonuçları Analiz Etme',
                    text: 'Sonuçları duyurmak için sizin ve rakibinizin seçimlerini işliyoruz. Lütfen biraz bekleyin ve oyundan veya uygulamadan ayrılmayın',
                },
            },
        },

        NftEvolution: {
            breedCost: {
                title: 'Yetiştirme Maliyeti{{amount}}',
                text: "%40 indirimle çiftleştirmeden sonra bir sonraki Kademe NFT'sinin maliyeti",
                alert: 'Bir sonraki rütbeyi almak garanti değildir',
            },
            WelcomeNftEvolution: {
                BestRankToBreed: {
                    title: 'Yetiştirilecek En İyi Rütbeler',
                    text: 'İşte üreme için en üst Sıra kombinasyonlarının bir listesi',
                },
                stepOne: {
                    title: "Cins NFT'ler",
                    text: "Üreme için iki NFT seçin ve belirli bir olasılıkla rastgele Derecede bir NFT elde edin. NFT'ler kaybolmaz!",
                },
                stepTwo: {
                    title: 'DNA Klonlama',
                    text: "Yüksek teknolojiye sahip laboratuvarlarımız artık ölü hayvanların DNA'sını alıp klonlayabiliyor! Öyleyse, birkaç ölü NFT alın ve onları üretin. Sağlık geri yüklenmeyecek",
                },
                stepThree: {
                    title: 'Sıralama Şansı',
                    text: "Üreme sırasında her Dereceyi alma şansının ne olduğunu öğrenin. NFT'lerin aynı Derecede olması gerekmez. Ancak, daha yüksek Dereceler de dahil olmak üzere herhangi bir Dereceden NFT kazanma fırsatınız var",
                },
                stepFour: {
                    title: 'Yetiştirme Maliyeti',
                    text: "%40 indirimle çiftleştirmeden sonra bir sonraki Kademe NFT'sinin maliyeti. AI tarafından oluşturulan benzersiz bir NFT alacaksınız. Bir fotoğraftan oluşturma mevcut değil",
                },
            },
            NftEvolutionSelectPets: {
                text: 'İşte üreme için en üst Sıra kombinasyonlarının bir listesi',
                button: 'Şansları Hesaplayın',
                emptyCard: {
                    first: "Geçilecek ilk NFT'yi seçin",
                    second: "Geçilecek ikinci NFT'yi seçin",
                },
                loading: 'Analizi...',
            },
            NftEvolutionSelectPet: {
                title: "NFT'yi seçin",
            },
            NftEvolutionCheckout: {
                title: 'Peluang perkawinan silang',
                text: 'Cari tahu lebih lanjut tentang apa yang Anda dapatkan dari perkawinan silang',
                button: 'Için Cins {{amount}}',
                loading: {
                    title: 'Üreme',
                    text: "Lütfen NFT'ler üretilirken bekleyin. Uygulamayı kapatmayın veya sekmeden çıkmayın. Üreme işlemi genellikle beş dakika kadar sürer",
                },
            },
            ConfirmBreedModal: {
                title: 'Için Cins ',
                text: 'Oyuna katıldığınızda, rastgele Derecede yeni bir NFT almak için iki NFT oluşturmayı kabul edersiniz',
            },
            NftEvolutionSuccess: {
                title: '{{rank}} Seviye NFT Oluşturuldu!',
                text: "Tebrikler! NFT'lerinizi başarıyla oluşturdunuz ve {{rank}} Seviyesinde bir NFT aldınız",
            },
            NftEvolutionMintPet: {
                title: "Yeni NFT'yi Özelleştir",
                text: "Sizin için NFT'nin dört görüntüsünü otomatik olarak oluşturduk. Onlara göz atın, en iyisini seçin ve yeni NFT'nizin adını yazın",
            },
            noPetModal: {
                title: 'Oynamak İçin Yeni Bir NFT Darp Edin',
                text: 'Oyunda yer almak için en az iki evcil hayvan gereklidir. Yeni bir tane bas ve oynamaya başla',
            },
        },

        NftRoyal: {
            lockPeriodWarning:
                'Hile yapmayı önlemek için, sadece beceri ve şansın kazananı belirlediğini',

            NftRoyalHowItWorks: {
                stepOne: {
                    title: 'Eğlenceli Bir Atari Oyunu Oyna',
                    text: 'Bu, güçlü rakiplerle karşılaşacağınız günlük görevlerden oyunun bir çeşididir. Deneyiminizi geliştirmek için çeşitli oyun modları sunuyoruz. Tek bir rakibin olacak',
                },
                stepTwo: {
                    title: 'Katılın ve Oyunlar Oluşturun',
                    text: 'Kullanıcılar katılabilir ve oyun oluşturabilir. Bir oyun oluştururken, VIGU jetonlarındaki hisseyi seçmelisiniz. Bir oyuna katılarak, oyun yaratıcısı tarafından belirtilen miktarda jeton yatırmayı kabul etmiş olursunuz',
                },
                stepThree: {
                    title: 'Hile imkansız',
                    text: 'Hile yapmayı önlemek için, sadece beceri ve şansın kazananı belirlediğini garanti eden akıllı bir hile tespit sistemi kullanıyoruz',
                },
            },
            NftRoyalGameSettings: {
                gameMode: {
                    [NFT_ROYAL_GAME_MODE.Score]: {
                        title: 'Puanlar',
                        text: 'Oyuncular puan için yarışacak',
                    },
                    [NFT_ROYAL_GAME_MODE.Fruit]: {
                        title: 'Meyve',
                        text: 'Oyuncular meyveler için yarışacak',
                    },
                },
                difficultyType: {
                    [GAME_DIFFICULTY.Easy]: {
                        title: 'Kolay',
                        text: 'Düşük hız ve düşük kaktüs yumurtlama oranı',
                    },
                    [GAME_DIFFICULTY.Medium]: {
                        title: 'Orta',
                        text: 'Orta hız ve orta hızda kaktüs yumurtlama',
                    },
                    [GAME_DIFFICULTY.Hard]: {
                        title: 'Zor',
                        text: 'Yüksek hız ve yüksek kaktüs yumurtlama oranı',
                    },
                },
                lives: 'Oyundaki maksimum can sayısı',
            },
            NftRoyalGameSettingsModal: {
                title: 'Oyun ayarları',
                text: 'Daha heyecan verici bir oyun için çeşitli farklı parametreler vardır',
                feature: {
                    mode: {
                        description:
                            'Skor modunda puan için yarışıyorsunuz ve meyve modunda toplanan meyve sayısı için yarışıyorsunuz',
                    },
                    difficulty: {
                        description:
                            'Üç zorluk seviyesi (kolay, orta ve zor) kaktüslerin hızını ve yumurtlamasını kontrol eder',
                    },
                    livesCount: {
                        description:
                            'Oyundaki can sayısı. Oyun, oyunculardan birinin son canını kaybetmesiyle sona erer',
                    },
                },
            },

            NftRoyalCreateGameSuccess: {
                title: 'Başarılı bir oyun yarattınız!',
                text: 'Lütfen oyunu bitirin, böylece sonuçlarınızı gelecekteki rakibinizin sonuçlarıyla karşılaştırabiliriz',
            },

            NftRoyalGameHistory: {
                [NFT_ROYAL_GAME_HISTORY_STATUS.WaitingForOpponent]: {
                    title: 'Rakibi beklemek',
                    text: 'Oyunu tamamladınız. Şimdi size meydan okumak ve katılmak için rakibinize kalmış. Bir rakip tarafından yedi gün içinde tamamlanmazsa, oyun otomatik olarak sonlandırılır ve depozitonuz iade edilir',
                },
                [NFT_ROYAL_GAME_HISTORY_STATUS.Won]: {
                    title: 'Sen kazandın!',
                    textOne:
                        'Tebrikler! Rakibinizi geride bırakmayı başardınız. ',
                    textTwo: ' oyun cüzdanınıza hemen aktarılacak',
                },
                [NFT_ROYAL_GAME_HISTORY_STATUS.Draw]: {
                    title: 'Vay be, berabere!',
                    text: 'Her ne kadar olası görünmese de, ikiniz de eşit miktarda puan kazandınız. Bahsiniz cüzdanınıza iade edildi. Bir tur daha ister misin?',
                },
                [NFT_ROYAL_GAME_HISTORY_STATUS.Lost]: {
                    title: 'Oyunu kaybettin :(',
                    text: 'Ne yazık ki, rakibiniz bu oyun turunda sizi geride bırakmayı başardı. Payınız cüzdanlarına aktarıldı. Bir dahaki sefere her zaman kazanabilirsin!',
                },
                GameStatistics: {
                    title: 'Oyun İstatistikleri',
                    score: 'Puanınız',
                    lives: 'Kurtarılan Hayatlar',
                    fruitCollected: 'Toplanan Meyveler',
                },
            },
            NftRoyalLoadingScreen: {
                prepare: {
                    title: 'Oyun Hazırlanıyor',
                    text: 'Oyunun başlaması için gerekli tüm çalışmaları yapıyoruz. Lütfen biraz bekleyin. Çok uzun sürmeyecek!',
                },
                complete: {
                    title: 'Sonuçları Analiz Etme',
                    text: 'Sonuçlarınızı ve rakibinizin sonuçlarını duyurmak için işliyoruz. Lütfen biraz bekleyin ve oyunu veya uygulamayı terk etmeyin',
                },
            },
            emptyScreen: {
                title: 'Oops!',
                text: 'Yanlış bir şey var. Ama endişelenmeyin, hemen düzelecektir',
            },
        },

        [MYSTERY_GAMES.luckyStrike]: {
            keys: {
                participants: 'Katılımcılar',
                winners: 'Şanslı Kazananlar',
            },

            purchaseTicket: 'Bilet Al',
            ticketsGrabbed: 'Yakalanan Biletler',
            soldOut: 'Tüm Biletler Tükendi',
            LuckyStrikeTimerBlock: {
                title: 'Tur Biter',
                text: 'Turun bitmesine kalan süre',
            },
            HashSecuritySystem: {
                title: 'Güvenli Hash Sistemi',
                text: 'Her biletin, diğer oyunculardan gizlenen benzersiz bir hash kodu vardır. Kod kazananı belirler!',
            },
            LuckyStrikePricePool: {
                title: 'Ödül = {{text}}',
                text: 'Bilet primlerinden toplanan toplam havuz. Bir kazanan hepsini alır. Ödül Oyun Cüzdanına ödenir',
            },
            LuckyStrikeParticipants: {
                title: 'Katılımcılar = {{text}}',
                text: 'Katılacak oyuncular ve oyuncu limiti. Limite ulaşıldığında, yeni biletler kullanılamaz hale gelir',
            },
            LuckyStrikeHowItWorks: {
                stepOne: {
                    title: 'Lucky Strike Tanıtımı',
                    text: 'Bir tur oynayın ve yakışıklı bir ödül kazanın! Her turda aldığınız her bilet, kazanma şansınızı artırır',
                },
                stepTwo: {
                    title: 'Şansını Arttır',
                    text: 'Oyuncular, bilet primlerinden oluşan havuzu kazanma şansına sahiptir. Ne kadar çok bilet toplarsanız, ödülü alma şansınız o kadar yüksek olur',
                },
                stepThree: {
                    title: 'Aldatmak İmkansız',
                    text: "Bir bilet hash'ine diğer kullanıcılar erişemeyeceğinden, hile yapmak mümkün değildir. Kötü şans felci geçiriyor gibi görünüyorsanız, olan budur. Biraz daha oynayın ve gidişat kesin olarak değişecektir",
                },
            },
            LuckyStrikeMain: {
                title: 'Şanslı Turlar',
                text: 'Turların süresi, oyuncu sayısı ve kazanma şansı değişir',
                emptyList: {
                    title: 'Kazanan Yok',
                    text: 'Şu anda turu kazanan kullanıcı yok. Yakında kazananlar görünecek.',
                },
            },
            LuckyStrikeWinners: {
                title: 'Şanslı Kazananlar',
                text: 'Şanslı kazananlara bir göz atın',
            },
            LuckyStrikePurchaseModal: {
                title: '"{{type}}" Bileti Alın',
                text: "Primler oyun havuzundan toplanır. Kazanan tüm havuzu alır ve bilet hash'ine göre belirlenir. Ne kadar çok bilet alırsanız, ödülü alma şansınız o kadar yüksek olur",
                alert: 'Hileyi önlemek ve oyun deneyimini geliştirmek için bir oyun başına maksimum {{maxTickets}} bilet alabilirsiniz',
            },
            LuckyStrikeWaitingForResult: {
                title: 'Sonuçlar bekleniyor!',
                text: 'Oyunun sonucunu öğrenmek için turun bitmesini bekleyin. Kazanma şansınızı artırmak için daha fazla bilet alabilirsiniz',
            },
            LuckyStrikeUserTickets: {
                text: 'Her biletin, diğer oyunculardan gizlenen ve oyunun adilliğini garanti etmemize yardımcı olan benzersiz bir hash kodu vardır',
                alert: 'Zaten oyun başına izin verilen maksimum {{text}} bilete sahipsiniz',
            },

            LuckyStrikeHistoryItem: {
                [LUCKY_STRIKE_GAMES_STATUS.Won]: '{{round}} Kazandı',
                [LUCKY_STRIKE_GAMES_STATUS.Lost]: '{{round}} Kaybetti',
                [LUCKY_STRIKE_GAMES_STATUS.WaitingForResults]:
                    'Sonuçlar Bekleniyor',
            },
            LuckyStrikeHistoryBlockHeader: {
                [LUCKY_STRIKE_GAMES_STATUS.Won]: {
                    title: 'Sen kazandın!',
                    textOne:
                        'Tebrikler! Biletiniz şanslı olandır ve tüm ödül havuzunu kazanırsınız. ',
                    textTwo: ' anında cüzdanınıza yatırılacaktır',
                },

                [LUCKY_STRIKE_GAMES_STATUS.Lost]: {
                    title: 'Kaybettin :(',
                    text: 'Ne yazık ki, bu sefer raundu kazanmayı başaramadınız. Bir sonrakinde sana bol şans!',
                },
            },
            LuckyStrikeGameHistoryInfo: {
                gameType: 'Oyun Türü',
                correctTicket: 'Kazanan Bilet',
                yourTicket: 'Sizin Bilet',
                yourTickets: 'Sizin Biletler',
            },

            toasts: {
                soldOut: {
                    text1: 'Hata!',
                    text2: 'Tüm Biletler Tükendi!',
                },
                gameExpired: {
                    text1: 'Hata!',
                    text2: 'Tur Süresi Doldu',
                },
                gamePending: {
                    text1: 'Oops!',
                    text2: 'Bir şeyler yanlış gidiyor',
                },
            },
        },

        [MYSTERY_GAMES.quantumSpin]: {
            keys: {
                spin: 'Döndürmek',
                spinning: 'Dönüyor',
            },
            QuantumSpinProvablyFair: {
                card: {
                    title: 'Kesinlikle Adil',
                    text: "Sonuçlar zincirlenmiştir, bu da sistemi aldatmayı imkansız hale getirir. Twitter'da ilk hash'i yayınladığımız için sonuçların adilliğini kendiniz kanıtlayabilirsiniz",
                },

                title: 'Kesinlikle Adil',
                text: 'Tüm sonuçlar, herkesin oyunun adilliğini kontrol etmesine olanak tanıyan bir şifreleme işlevi aracılığıyla hesaplanır',
                algorithm: {
                    title: 'Algoritma',
                    text: 'Sonraki {{rounds}} turun tüm oyun sonuçları önceden belirlenmiştir. Her turdan önce, sonucun karma değerini açıklıyoruz, böylece sonucu gerçekten sonra değiştirmemiz imkansız hale geliyor.\n\nAslında tüm sonuçları birbirine bağladık, gelecekteki sonuçları değiştirmemizi bile imkansız hale getiriyor. Ve sonuçlar zincirini oluşturmadan önce, ilk karma değeri açıkladık, bunu Twitter`a yayınladık ve bilemeyeceğimiz gelecekteki bir Bitcoin blok karmasını karıştırdık. Bu, tüm sonuçların kesin olarak adil olduğu anlamına geliyor.\n\nOyunun ilk turu başlamadan önce, karma değerlerden oluşan bir zincir oluşturduk. Her karma değeri 256 bitlik bir değerdir. Zincir, rastgele seçilen 256 bitlik bir değerle başlar ve her sonraki değer, önceki değerin BLAKE2b karması kullanılarak hesaplanır.\n\nKriptografik bir karma fonksiyonu kullanmak, zincirdeki herhangi bir değeri önceki değeri kullanarak kolayca hesaplayabilmeyi sağlar, ancak ters yöndeki değerleri kolayca hesaplayamaz. Önceden hesaplanmış karma zincirindeki son değer, oyunun ilk turunda kullandığımız ve halka açık olarak yayınladığımız değerdir. Oyunun ikinci turu sondan ikinci karma değeri, üçüncü tur sondan üçüncü karma değeri vb. kullandı. Zinciri bu şekilde gezerek, geçmiş tüm oyun turlarının sonuçlarının önceden hesaplanmış zincirle tutarlı olduğunu, ancak gelecekteki turların sonuçlarının kullanıcılar için öngörülemez olduğunu doğrulayabilirsiniz.\n\nOyun sonuçlarını kendi lehimize yanlı olacak şekilde bir başlangıç değeri kullanarak zincir oluşturma ihtimalini ortadan kaldırmak için, zincirdeki her değer global tohuma eklenir ve elde edilen değer BLAKE2b kullanılarak tekrar karma haline getirilerek her oyun turunun sonucunu belirleyecek nihai değer oluşturulur. Bu global tohum, madenciliğinden önce duyurduğumuz Bitcoin blok zincirinin karmasına ayarlanmıştır. Global tohumun dahil edilmesi, oyunların sonucunun ilk oyunun karma değeri yayınlandığında bize bilinmez olduğunu garanti eder',
                },
                verification: {
                    title: 'Verification Example',
                    text: 'Anyone can verify that the outcomes of all prior game rounds were generated using the Kesinlikle Adil algorithm with the following python code',
                },
            },
            QuantumSpinHowItWorks: {
                stepOne: {
                    title: 'Kuantum Tekerleğini Döndürün',
                    text: 'Tekerlek süperpozisyonda; ne getireceğini bilmiyoruz. Belirsizliği ortadan kaldırmak ve en büyük ödülü kazanmak için çarkı döndürün',
                },
                stepTwo: {
                    title: 'Her kuantum dönüşü enerji, yani jeton gerektirir',
                    text: 'Ödülünüz bahis miktarınızdan daha düşük veya daha yüksek değerde olabilir. Doğal olarak, büyük bir ödül alabilirsin!',
                },
                stepThree: {
                    title: 'Aldatmak İmkansız',
                    text: 'Bir dönüşün sonuçları, oyun anında rastgele bir süreçle belirlenir ve takım tarafından bilinmez. Adalete ve şeffaflığa değer veririz',
                },
            },
            QuantumSuccess: {
                coin: 'Tebrikler! Hemen cüzdanınıza aktarılacak olan ödüllerde {{coin}} kazandınız. Şansınızı tekrar deneyin ve sonuçlarınızı sosyal ağlarda paylaşın',
                rank: 'Tebrikler! Hemen cüzdanınıza aktarılacak olan bir {{rank}} Rank NFT kazandınız. Şansınızı tekrar deneyin ve sonuçlarınızı sosyal ağlarda paylaşın',
            },
            QuantumSpinGameHistory: {
                again: 'Tekrar çevir',
            },
            QuantumSpinDetailsModal: {
                button: 'Diske Geri Dön',
            },
            QuantumSpinHistory: {
                title: 'Burada boş',
                text: 'Henüz hiç oyun oynamadınız. Şimdi deneyin!',
            },
        },
        [MYSTERY_GAMES.tokenteller]: {
            predictPrice: 'Fiyat Tahmini',
            addMoreTokens: 'Daha Fazla Jeton Ekle',
            priceDirection: 'Fiyat Yönü',

            [TOKEN_TELLER_GAME_PREDICTION_DIRECTION.Up]: 'YUKARI',
            [TOKEN_TELLER_GAME_PREDICTION_DIRECTION.Down]: 'AŞAĞI',
            TokenTellerConfirmationModal: {
                [TOKEN_TELLER_GAME_PREDICTION_DIRECTION.Up]: 'YUKARI Çarpanı',
                [TOKEN_TELLER_GAME_PREDICTION_DIRECTION.Down]: 'AŞAĞI Çarpanı',
            },

            TokenTellerHowItWorks: {
                stepOne: {
                    title: 'Tokenteller Giriş',
                    text: 'Bu hızlı tempolu oyunda tahmin becerilerinizi test edin. {{min}} dakikalık bir turda IGU fiyat hareketini tahmin edin. Gerekli tüm araçları kullanın: kristal küreler, hayvan kahinleri ve hatta kara büyü',
                },
                stepTwo: {
                    title: 'Ödül Boyutu',
                    text: 'Bir oyunda ya yukarıyı ya da aşağıyı seçersiniz. Ödül boyutunuz, boğa havuzunun ayı havuzuna oranı olan çarpana bağlıdır. Çarpan Tahmin Sekmesinde gösterilir ve tur yayınlanıncaya kadar değişebilir',
                },
                stepThree: {
                    title: 'Aldatmak İmkansızdır',
                    text: 'Borsalardan güncel {{coin}} fiyatını alan güvenilir bir kahin kullanıyoruz. Her zaman borsadaki fiyatı kontrol edebilirsiniz',
                },
            },
            TokenTellerMainScreen: {
                title: 'Turlar',
                text: 'Yalnızca yaklaşan bir tura katılabilirsiniz',
            },
            TokenTellerPurchaseModal: {
                title: 'Fiyat Hareketini Tahmin',
                text: 'Edin {{coin}} nereye gittiğini tahmin etmek için bir tura katılın. Aşağıdan hisseyi ve yönü seçin',
                alert: 'Tokenın {{direction}} çıkacağı tahminini zaten yaptınız. Artık konumunuzu yalnızca bu yönde artırabilirsiniz',
            },

            TokenTellerPricePool: {
                title: 'Havuz = {{text}}',
                text: 'Havuz kullanıcıların stakelerinden toplanır. Ödül, toplam boğa ve ayı bahisleri arasındaki orana bağlıdır',
            },
            TokenTellerUpPayout: {
                title: 'YUKARI Çarpanı = {{coefficient}}X',
                text: 'Fiyat yükselirse kazanan çarpan',
            },
            TokenTellerDownPayout: {
                title: 'AŞAĞI Çarpanı = {{coefficient}}X',
                text: ' Fiyat düşerse kazanan çarpan',
            },
            TokenTellerParticipants: {
                title: 'Katılımcılar = {{text}}',
                text: 'Tura katılan oyuncu sayısı',
            },

            TokenTellerTimerBlock: {
                [TOKEN_TELLER_GAME_STATUS.Pending]: {
                    title: 'Tur Başlıyor',
                },
                [TOKEN_TELLER_GAME_STATUS.Closed]: {
                    title: 'Tur Bitiş Tarihinde',
                },
            },
            TokenTellerHistoryItem: {
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Won]: 'Kazanmak',
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Lost]: 'Kaybetmek',
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.WaitingForResults]:
                    'Sonuç Bekleniyor',
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Refund]: 'Çizmek',
            },

            TokenTellerHistoryBlockHeader: {
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Won]: {
                    title: 'Sen kazandın!',
                    textOne:
                        'Tebrikler! Fiyat hareketini doğru tahmin ettiniz. ',
                    textTwo: ' anında cüzdanınıza yatırılacaktır',
                },

                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Lost]: {
                    title: 'Kaybettin :(',
                    text: 'Maalesef bu sefer kazanmayı başaramadınız. Bir sonraki turda kendinizi kanıtlamak için iyi bir neden!',
                },
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Refund]: {
                    title: 'Vay, bu bir Beraberlik!',
                    text: 'Her ne kadar düşük bir ihtimal gibi görünse de, bu bir beraberlik. Bahis tutarınız cüzdanınıza iade edildi. Bir tur daha ister misin?',
                },
            },

            TokenTellerGameHistoryInfoItem: {
                iguBefore: 'Başlangıç fiyatı',
                iguAfter: 'Kapanış fiyatı',
                prediction: 'Konum',
                totalPool: 'Toplam Havuz',
                participants: 'Katılımcılar',
                upPayout: 'YUKARI Çarpanı',
                downPayout: 'AŞAĞI Çarpanı',
            },
        },
        DailyTasks: {
            header: 'Günlük Görevler',
            collected: '{{collectedEnergy}} / {{maxEnergy}} Toplanmış',
            SocialTask: {
                title: 'Sosyal bir ödev',
                text: 'Sosyal medya paylaşımları yapın',
            },
            VerificationTask: {
                title: 'Bir arama görevi',
                text: 'Diğer kullanıcıların mesajlarını kontrol edin',
            },
            MoveTask: {
                title: 'Hareketli görev',
                text: 'Evcil hayvanınızla dışarıda yürümenin keyfini çıkarın',
            },
            PlayTask: {
                title: 'Oyun görevi',
                text: 'Heyecan verici bir arcade oyunu oynayın',
            },
        },
        ReferralCard: {
            title: "NFT'de {{percent}}% indirim",
            text: "Yeni kullanıcıları IguVerse uygulamasına davet edin ve mint NFT'de indirim kazanın",
            button: 'Davetiye',
        },
        TimerTopUp: {
            title: 'Her Yükleme için',
            text1: 'Jetonları şimdi yatırın ve cüzdanınıza {{percent}}% daha fazla {{coin}} alın! Yalnızca şu tarihlerden önce kullanılabilir:',
            text2: 'Yeni rekabetçi oyunlarımızı oynamaya başlayın ve bakiyenizde bonus jetonlar kazanın!',
        },
    },
    pvpBonus: {
        cardButton: 'PVP Bonuslar',
        title: 'PvP Bonuslar',
        text: 'NFT sahipleri, PvP oynamak için teşvik alma hakkına sahiptir. Hemen başlayın ve bonuslarınızı hemen alın!',
        pvpBonusModal: {
            title: "PvP'de Nasıl Daha Fazla Kazanılır",
            text: "IguVerse'in PvP'den dönüşü, cironuzla orantılı olarak sizinle paylaşılacaktır! Bir NFT alın ve oynadığınız için otomatik olarak bonuslar kazanın",
            features: {
                games: {
                    title: 'Oyun Sayacı = {{games}}',
                    text: 'Bugün oynadığınız oyunlar. Şimdi kendini durdurma!',
                },
                bonus: {
                    title: 'PvP Bonuslar = {{amount}}',
                    text: 'Bunlar, günün sonunda PvP oyunlarını oynadığınız için alacağınız ekstra jetonlardır. Başkalarıyla çatışın ve daha da fazla kazanın!',
                },
            },
        },
        pvpBonusModalFreePet: {
            title: "PvP'de Daha Fazla Jeton Almak İçin Sıralamayı Yükseltin",
            text: 'PvP bonuslarına hak kazanabilmeniz için Serbest Derecedeki evcil hayvanınızın daha yüksek bir Dereceye yükseltilmesi gerekir',
        },
    },
    MarketPlace: {
        navigationBar: {
            ORDERS: 'Aktif Siparişler',
            MY_PROFILE: 'Benim profilim',
        },
        MarketPlaceActiveOrdersScreen: {
            title: 'Pazar yeri',
            text: 'NFT ticareti yapabileceğiniz bir yer',
            empty: {
                title: 'Satılık NFT Yok',
                text: 'Henüz satış emri oluşturulmadı. İlk oluşturan siz olun!',
            },
            notFound: {
                title: 'Sonuç bulunamadı',
                text: 'Böyle bir sipariş bulamadık. Aramak için başka bir anahtar kelime girin',
            },
        },
        MarketPlaceSearch: {
            modalTitle: 'Filtreler',
            placeHolder: 'Nft, koleksiyon, kullanıcı ara...',
            typeSection: {
                [MARKETPLACE_PET_TYPE.AISystem]: 'AI Sistemi',
                [MARKETPLACE_PET_TYPE.FromPhoto]: 'Fotoğraftan',
                [MARKETPLACE_PET_TYPE.Alive]: 'Canlı',
                [MARKETPLACE_PET_TYPE.Dead]: 'Ölü',
            },

            sortBySection: {
                [MARKETPLACE_ORDERS_SORT_OPTION.FromHighestPrice]:
                    'En Yüksek Fiyattan',
                [MARKETPLACE_ORDERS_SORT_OPTION.FromLowestPrice]:
                    'En Düşük Fiyattan',
                [MARKETPLACE_ORDERS_SORT_OPTION.RecentlyListed]:
                    'Yakın Zamanda Listelendi',
                [MARKETPLACE_ORDERS_SORT_OPTION.EndingSoon]: 'Yakında Bitiyor',
            },
        },
        MarketPlaceWelcomeCreateOrderScreen: {
            screenTitle: 'Yeni Sipariş Oluştur',
            title: "NFT'nizi Büyük Dünyaya Tanıtın",
            text: "Burada NFT'lerinizi listeleyebilir ve satabilirsiniz",
            features: {
                rank: {
                    title: 'Asgari Derece – {{rank}}',
                    text: "NFT'niz {{lowRank}} Dereceden daha yüksek bir Dereceye sahip olmalıdır. Yalnızca uygulamada satın alınan NFT'ler pazarda takas edilebilir",
                },
                termination: {
                    title: 'Otomatik Sonlandırma = {{days}} Günler',
                    text: 'Daha önce satın alınmadıysa siparişin sona ereceği süre',
                    alert: "Eğer {{days}} gün içerisinde kimse NFT satın almazsa, sipariş otomatik olarak Marketplace'ten silinecektir. Listeleme sırasında oynamaya ve kazanmaya devam edebilirsiniz",
                },
                commission: {
                    title: 'Komisyon Ücreti = {{commission}}%',
                    text: 'Başarıyla satılan her NFT, {{commission}}% komisyon ücretine tabidir',
                },
            },
        },
        MarketPlaceModalNoPet: {
            title: 'Satmak İçin Bir NFT Darp Edin',
            text: 'Bir NFT satmak için en az bir evcil hayvanınızın olması gerekir. Şimdi bir tane nane!',
        },
        MarketPlaceSelectNftScreen: {
            screenTitle: "NFT'yi seçin",
        },
        MarketPlaceSelectNftPriceScreen: {
            screenTitle: 'NFT Fiyatını Girin',
        },
        MarketPlaceCreateOrderSuccessScreen: {
            title: 'Pazar Yerinde Listelenen NFT',
            text: "NFT'nizi başarıyla listelediniz. Artık diğer kullanıcılar onu satın alabilecek",
        },
        navigationBarOverview: {
            OVERVIEW: 'Genel bakış',
            OWNER_HISTORY: 'Sahibin Geçmişi',
        },
        MarketPlaceOverview: {
            text: "Bu, başka bir kullanıcının NFT'sidir. Özelliklerini aşağıda görebilirsiniz:",
            textOwner: "Bu senin NFT'n. Özelliklerini aşağıda görebilirsiniz:",
            OverviewOwnerSection: {
                profileLabel: 'Sahibinin Profili',
            },
            proceedToCheckoutModal: {
                title: 'Çıkışa doğru devam et?',
                text: 'Bir NFT satın aldıktan sonra 24 saat bekleme modunda olacaktır. Satın almadan önce tüm özelliklerini kontrol ettiğinizden emin olun',
            },
        },
        DelistNftModal: {
            title: 'NFT liste dışı bırakılsın mı?',
            text: 'Listeden çıkarılırsa, NFT pazar yerini terk edecek ve artık satın alınamayacak',
        },
        MarketplaceProfile: {
            joined: 'Katıldı {{date}}',
            myNFTs: "NFT'lerim",
            exploreNFTs: "NFT'leri keşfedin",
            emptyUser: {
                title: 'Sipariş Yok',
                text: 'Henüz pazaryeri siparişi oluşturulmadı',
            },
            empty: {
                title: 'Sipariş Yok',
                text: 'Bu kullanıcı henüz herhangi bir sipariş oluşturmadı',
            },
        },
        MarketPlaceDelistSuccessScreen: {
            title: 'NFT "{{name}}", pazardan başarıyla kaldırıldı',
        },
        MarketPlaceBuySuccessScreen: {
            title: 'Aileye Yeni NFT Katıldı',
            text: 'Başarıyla yeni bir NFT satın aldınız! Artık koleksiyonunuz yeni bir üyeye kavuştu ve artık çok daha güçlü',
        },
        MarketPlaceOverviewOwnerHistoryScreen: {
            empty: {
                title: 'NFT Geçmişi Yok',
                text: 'NFT henüz işlem görmedi. İlk satın alan siz olabilirsiniz!',
            },
        },
        MarketPlaceNoTradeAvalibleScreen: {
            title: 'Pazar Yeri Çıktı!',
            description:
                "IguVerse NFT'lerinizi takas edebileceğiniz dahili pazarımızı kısa süre önce kullanıma sunduk. Web App aracılığıyla açın ve ilk siparişinizi şimdi yapın!",
            button: 'Web Uygulamasında Keşfet',
        },
    },
    SpaceId: {
        card: {
            title: 'SPACE Kimliği al',
            text: 'Özel takma adınızı uygulamada ve ötesinde her yerde gösterin',
        },
        how: {
            screenTitle: 'SPACE ID Nasıl Kullanılır',
            title: 'Dijital Kimliği Kaydedin',
            text: 'Karmaşık okunamayan adreslerden bıktınız mı? SPACE ID ile insan tarafından okunabilen bir kimlik (alan adı) ile kendinizinkini değiştirin!',
            guideBlock: {
                first: 'IguVerse cüzdanınızı, tohum kelime öbeğiniz aracılığıyla herhangi bir gözetim dışı DeFi Cüzdanına (ör. Trustwallet, Metamask) aktarın',
                second: 'BEP-20 ağını ekleyin ve cüzdanınızı web sitesine bağlayın',
                third: 'Web sitesinde istediğiniz alan adını arayın',
                fourth: 'İstediğiniz alan adını satın alın ve IguVerse uygulamasını güncelleyin. Özel takma adınızı cüzdanda, skor tablosunda ve kullanıldığı diğer herhangi bir yerde görebileceksiniz',
                alert: 'Bir alan adı satın almak için cüzdanınızda bir miktar BNB olması gerekir',
            },
            button1: 'SPACE ID etki alanlarını keşfedin',
        },
        modal: {
            title: 'Eşsiz SPACE ID!',
            text: 'Özel bir alan adını başarıyla satın aldınız ve kaydettiniz! Artık benzersiz adınız uygulamanın her yerinde gösterilecek. Gerçek adresiniz aynı kalacak ve cüzdanınızdaki "Kopyala"ya tıklayarak kopyalayabilirsiniz',
            link: 'SPACE ID Daha Fazla Bilgi Edinin',
        },
    },
    Achievements: {
        title: 'Başarılar',
        text: 'Eşsiz ilerlemenizi takip eden ve becerilerinizi ve oyun deneyiminizi sergilemenizi sağlayan heyecan verici görevler',
        unlocked: '{{achievement}} Kilidi Açıldı!',
        unlockedText:
            'Tebrikler! Bir başarının kilidini açmayı başardınız. Sosyal medyada arkadaşlarınızla paylaşın!',
        button: 'Başarıyı Paylaşın',
        modal: {
            title: 'Başarılarla öne çıkın',
            text: 'Başarılar elde etmek için görevleri tamamlayın. Biraz meydan okuma ve bir sandık dolusu madalya ile oynamak çok daha eğlenceli',
        },
    },
};

export default tr;
